import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03 (YYYY-MM-DD), compliant with ISO 8601 standard for representation of dates using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the date-timeformat outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representationof dates and times using the Gregorian calendar. */
  DateTime: any;
  Hex: any;
  /** Raw JSON value */
  Json: any;
  /** The Long scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** ObjectId */
  ObjectId: any;
  RGBAHue: any;
  RGBATransparency: any;
  /** Slate-compatible RichText AST */
  RichTextAST: any;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The file name */
  fileName: Scalars['String'];
  /** The file handle */
  handle: Scalars['String'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']>;
  /** List of Asset versions */
  history: Array<Version>;
  iconPlace: Array<Place>;
  /** The unique identifier */
  id: Scalars['ID'];
  imageContent: Array<Content>;
  imageLink: Array<Link>;
  imagePage: Array<Page>;
  imagePlace: Array<Place>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  mediaGroup?: Maybe<Media>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  seoImage: Array<Seo>;
  /** The file size */
  size?: Maybe<Scalars['Float']>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String'];
  /** The file width */
  width?: Maybe<Scalars['Float']>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetIconPlaceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlaceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaceWhereInput>;
};


/** Asset system model */
export type AssetImageContentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


/** Asset system model */
export type AssetImageLinkArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Asset system model */
export type AssetImagePageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


/** Asset system model */
export type AssetImagePlaceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlaceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaceWhereInput>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetMediaGroupArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetSeoImageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoWhereInput>;
};


/** Asset system model */
export type AssetStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  handle: Scalars['String'];
  height?: InputMaybe<Scalars['Float']>;
  iconPlace?: InputMaybe<PlaceCreateManyInlineInput>;
  imageContent?: InputMaybe<ContentCreateManyInlineInput>;
  imageLink?: InputMaybe<LinkCreateManyInlineInput>;
  imagePage?: InputMaybe<PageCreateManyInlineInput>;
  imagePlace?: InputMaybe<PlaceCreateManyInlineInput>;
  imagesGallery?: InputMaybe<GalleryCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  mediaGroup?: InputMaybe<MediaCreateOneInlineInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seoImage?: InputMaybe<SeoCreateManyInlineInput>;
  size?: InputMaybe<Scalars['Float']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  handle: Scalars['String'];
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  iconPlace_every?: InputMaybe<PlaceWhereInput>;
  iconPlace_none?: InputMaybe<PlaceWhereInput>;
  iconPlace_some?: InputMaybe<PlaceWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  imageContent_every?: InputMaybe<ContentWhereInput>;
  imageContent_none?: InputMaybe<ContentWhereInput>;
  imageContent_some?: InputMaybe<ContentWhereInput>;
  imageLink_every?: InputMaybe<LinkWhereInput>;
  imageLink_none?: InputMaybe<LinkWhereInput>;
  imageLink_some?: InputMaybe<LinkWhereInput>;
  imagePage_every?: InputMaybe<PageWhereInput>;
  imagePage_none?: InputMaybe<PageWhereInput>;
  imagePage_some?: InputMaybe<PageWhereInput>;
  imagePlace_every?: InputMaybe<PlaceWhereInput>;
  imagePlace_none?: InputMaybe<PlaceWhereInput>;
  imagePlace_some?: InputMaybe<PlaceWhereInput>;
  mediaGroup?: InputMaybe<MediaWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoImage_every?: InputMaybe<SeoWhereInput>;
  seoImage_none?: InputMaybe<SeoWhereInput>;
  seoImage_some?: InputMaybe<SeoWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AssetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']>;
};

export type AssetUpdateInput = {
  fileName?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  iconPlace?: InputMaybe<PlaceUpdateManyInlineInput>;
  imageContent?: InputMaybe<ContentUpdateManyInlineInput>;
  imageLink?: InputMaybe<LinkUpdateManyInlineInput>;
  imagePage?: InputMaybe<PageUpdateManyInlineInput>;
  imagePlace?: InputMaybe<PlaceUpdateManyInlineInput>;
  imagesGallery?: InputMaybe<GalleryUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  mediaGroup?: InputMaybe<MediaUpdateOneInlineInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seoImage?: InputMaybe<SeoUpdateManyInlineInput>;
  size?: InputMaybe<Scalars['Float']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  fileName?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateManyLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  iconPlace_every?: InputMaybe<PlaceWhereInput>;
  iconPlace_none?: InputMaybe<PlaceWhereInput>;
  iconPlace_some?: InputMaybe<PlaceWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  imageContent_every?: InputMaybe<ContentWhereInput>;
  imageContent_none?: InputMaybe<ContentWhereInput>;
  imageContent_some?: InputMaybe<ContentWhereInput>;
  imageLink_every?: InputMaybe<LinkWhereInput>;
  imageLink_none?: InputMaybe<LinkWhereInput>;
  imageLink_some?: InputMaybe<LinkWhereInput>;
  imagePage_every?: InputMaybe<PageWhereInput>;
  imagePage_none?: InputMaybe<PageWhereInput>;
  imagePage_some?: InputMaybe<PageWhereInput>;
  imagePlace_every?: InputMaybe<PlaceWhereInput>;
  imagePlace_none?: InputMaybe<PlaceWhereInput>;
  imagePlace_some?: InputMaybe<PlaceWhereInput>;
  mediaGroup?: InputMaybe<MediaWhereInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoImage_every?: InputMaybe<SeoWhereInput>;
  seoImage_none?: InputMaybe<SeoWhereInput>;
  seoImage_some?: InputMaybe<SeoWhereInput>;
  size?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  width?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Associate = {
  __typename?: 'Associate';
  contribution: Scalars['String'];
  name: Scalars['String'];
  statute: Scalars['String'];
};

export type AssociateInput = {
  contribution: Scalars['String'];
  name: Scalars['String'];
  statute: Scalars['String'];
};

export type Author = {
  __typename?: 'Author';
  name: Scalars['String'];
  speciality?: Maybe<Scalars['String']>;
};

export type AuthorInput = {
  name: Scalars['String'];
  speciality?: InputMaybe<Scalars['String']>;
};

export enum BannerTheme {
  Imagine = 'IMAGINE',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long'];
};

export enum BlogCategory {
  Announcement = 'ANNOUNCEMENT',
  Guide = 'GUIDE'
}

export enum BreakpointSize {
  Default = 'DEFAULT',
  Lg = 'LG',
  Md = 'MD',
  Sm = 'SM',
  Xl = 'XL',
  Xs = 'XS'
}

export enum ButtonSize {
  Lg = 'LG',
  Sm = 'SM'
}

export enum ButtonTheme {
  Indigo = 'INDIGO',
  White = 'WHITE'
}

export enum ButtonVariant {
  Danger = 'DANGER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String'];
  hex: Scalars['Hex'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type Company = {
  __typename?: 'Company';
  address: Scalars['String'];
  fiscalCode: Scalars['String'];
  name: Scalars['String'];
  registrationNumber: Scalars['String'];
  representative: Scalars['String'];
};

export type CompanyInput = {
  address: Scalars['String'];
  fiscalCode: Scalars['String'];
  name: Scalars['String'];
  registrationNumber: Scalars['String'];
  representative: Scalars['String'];
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']>;
};

export type Content = Entity & Node & {
  __typename?: 'Content';
  content?: Maybe<ContentContentRichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Content>;
  heading?: Maybe<Heading>;
  /** List of Content versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  image?: Maybe<Asset>;
  linkGroup?: Maybe<LinkGroup>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Content>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  video?: Maybe<Video>;
};


export type ContentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type ContentHeadingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type ContentImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentLinkGroupArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type ContentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ContentSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type ContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentVideoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentConnection = {
  __typename?: 'ContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentContentRichText = {
  __typename?: 'ContentContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<ContentContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type ContentContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type ContentContentRichTextEmbeddedTypes = Asset | Link;

export type ContentCreateInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  heading?: InputMaybe<HeadingCreateOneInlineInput>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  linkGroup?: InputMaybe<LinkGroupCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ContentCreateLocalizationsInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  video?: InputMaybe<VideoCreateOneInlineInput>;
};

export type ContentCreateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ContentCreateLocalizationInput = {
  /** Localization input */
  data: ContentCreateLocalizationDataInput;
  locale: Locale;
};

export type ContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ContentCreateLocalizationInput>>;
};

export type ContentCreateManyInlineInput = {
  /** Connect multiple existing Content documents */
  connect?: InputMaybe<Array<ContentWhereUniqueInput>>;
  /** Create and connect multiple existing Content documents */
  create?: InputMaybe<Array<ContentCreateInput>>;
};

export type ContentCreateOneInlineInput = {
  /** Connect one existing Content document */
  connect?: InputMaybe<ContentWhereUniqueInput>;
  /** Create and connect one Content document */
  create?: InputMaybe<ContentCreateInput>;
};

/** An edge in a connection. */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Content;
};

/** Identifies documents */
export type ContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentWhereStageInput>;
  heading?: InputMaybe<HeadingWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  linkGroup?: InputMaybe<LinkGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<VideoWhereInput>;
};

export enum ContentOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentUpdateInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  heading?: InputMaybe<HeadingUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  linkGroup?: InputMaybe<LinkGroupUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<ContentUpdateLocalizationsInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  video?: InputMaybe<VideoUpdateOneInlineInput>;
};

export type ContentUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
};

export type ContentUpdateLocalizationInput = {
  data: ContentUpdateLocalizationDataInput;
  locale: Locale;
};

export type ContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ContentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ContentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ContentUpsertLocalizationInput>>;
};

export type ContentUpdateManyInlineInput = {
  /** Connect multiple existing Content documents */
  connect?: InputMaybe<Array<ContentConnectInput>>;
  /** Create and connect multiple Content documents */
  create?: InputMaybe<Array<ContentCreateInput>>;
  /** Delete multiple Content documents */
  delete?: InputMaybe<Array<ContentWhereUniqueInput>>;
  /** Disconnect multiple Content documents */
  disconnect?: InputMaybe<Array<ContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Content documents */
  set?: InputMaybe<Array<ContentWhereUniqueInput>>;
  /** Update multiple Content documents */
  update?: InputMaybe<Array<ContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Content documents */
  upsert?: InputMaybe<Array<ContentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentUpdateManyInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ContentUpdateManyLocalizationsInput>;
};

export type ContentUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
};

export type ContentUpdateManyLocalizationInput = {
  data: ContentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ContentUpdateManyLocalizationInput>>;
};

export type ContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentUpdateManyInput;
  /** Document search */
  where: ContentWhereInput;
};

export type ContentUpdateOneInlineInput = {
  /** Connect existing Content document */
  connect?: InputMaybe<ContentWhereUniqueInput>;
  /** Create and connect one Content document */
  create?: InputMaybe<ContentCreateInput>;
  /** Delete currently connected Content document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Content document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Content document */
  update?: InputMaybe<ContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Content document */
  upsert?: InputMaybe<ContentUpsertWithNestedWhereUniqueInput>;
};

export type ContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentUpdateInput;
  /** Unique document search */
  where: ContentWhereUniqueInput;
};

export type ContentUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentCreateInput;
  /** Update document if it exists */
  update: ContentUpdateInput;
};

export type ContentUpsertLocalizationInput = {
  create: ContentCreateLocalizationDataInput;
  locale: Locale;
  update: ContentUpdateLocalizationDataInput;
};

export type ContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentUpsertInput;
  /** Unique document search */
  where: ContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type ContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentWhereStageInput>;
  heading?: InputMaybe<HeadingWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  linkGroup?: InputMaybe<LinkGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<VideoWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Content record uniquely */
export type ContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CreateEnquiryInput = {
  consent: Scalars['Boolean'];
  data?: InputMaybe<EnquiryDataInput>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  subject: EnquirySubject;
};

export type CreateLayerInput = {
  category: Scalars['ObjectId'];
  feature: PolygonFeatureInput;
};

export enum DocumentFileTypes {
  Doc = 'doc',
  Docx = 'docx',
  Html = 'html',
  Jpg = 'jpg',
  Odp = 'odp',
  Ods = 'ods',
  Odt = 'odt',
  Pdf = 'pdf',
  Png = 'png',
  Ppt = 'ppt',
  Pptx = 'pptx',
  Svg = 'svg',
  Txt = 'txt',
  Webp = 'webp',
  Xls = 'xls',
  Xlsx = 'xlsx'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * PDF:	jpg, odp, ods, odt, png, svg, txt, and webp
   * DOC:	docx, html, jpg, odt, pdf, png, svg, txt, and webp
   * DOCX:	doc, html, jpg, odt, pdf, png, svg, txt, and webp
   * ODT:	doc, docx, html, jpg, pdf, png, svg, txt, and webp
   * XLS:	jpg, pdf, ods, png, svg, xlsx, and webp
   * XLSX:	jpg, pdf, ods, png, svg, xls, and webp
   * ODS:	jpg, pdf, png, xls, svg, xlsx, and webp
   * PPT:	jpg, odp, pdf, png, svg, pptx, and webp
   * PPTX:	jpg, odp, pdf, png, svg, ppt, and webp
   * ODP:	jpg, pdf, png, ppt, svg, pptx, and webp
   * BMP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * GIF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * JPG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * PNG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * WEBP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * TIFF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * AI:	    jpg, odp, ods, odt, pdf, png, svg, and webp
   * PSD:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * SVG:	jpg, odp, ods, odt, pdf, png, and webp
   * HTML:	jpg, odt, pdf, svg, txt, and webp
   * TXT:	jpg, html, odt, pdf, svg, and webp
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type Enquiry = {
  __typename?: 'Enquiry';
  _id: Scalars['ObjectId'];
  consent: Scalars['Boolean'];
  data?: Maybe<EnquiryData>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  subject: EnquirySubject;
};

export type EnquiryData = {
  __typename?: 'EnquiryData';
  details?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EnquiryDataInput = {
  details?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum EnquirySubject {
  House = 'HOUSE',
  Plot = 'PLOT',
  Project = 'PROJECT',
  Viewing = 'VIEWING'
}

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Asset system model */
  Asset = 'Asset',
  Content = 'Content',
  Footer = 'Footer',
  Form = 'Form',
  Gallery = 'Gallery',
  Heading = 'Heading',
  HeadingText = 'HeadingText',
  Link = 'Link',
  LinkGroup = 'LinkGroup',
  Media = 'Media',
  Navigation = 'Navigation',
  Page = 'Page',
  /** Place that can be marked on the map */
  Place = 'Place',
  Prop = 'Prop',
  Question = 'Question',
  QuestionGroup = 'QuestionGroup',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  Section = 'Section',
  Seo = 'Seo',
  /** To be used for news & awards */
  Story = 'Story',
  Text = 'Text',
  TextSection = 'TextSection',
  /** User system model */
  User = 'User',
  /** Video content */
  Video = 'Video'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export enum FeatureIcon {
  Bolt = 'BOLT',
  Globe = 'GLOBE',
  Mail = 'MAIL',
  Scale = 'SCALE'
}

export type File = {
  __typename?: 'File';
  fieldname?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
};

export type FileInput = {
  fieldname?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
};

export type Footer = Entity & Node & {
  __typename?: 'Footer';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Footer>;
  /** List of Footer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  primaryLinks: Array<Link>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  secondaryLinks: Array<Link>;
  slug: Scalars['String'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type FooterHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type FooterPrimaryLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type FooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FooterSecondaryLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type FooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type FooterConnection = {
  __typename?: 'FooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FooterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  primaryLinks?: InputMaybe<LinkCreateManyInlineInput>;
  secondaryLinks?: InputMaybe<LinkCreateManyInlineInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FooterCreateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Create and connect multiple existing Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>;
};

export type FooterCreateOneInlineInput = {
  /** Connect one existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>;
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>;
};

/** An edge in a connection. */
export type FooterEdge = {
  __typename?: 'FooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Footer;
};

/** Identifies documents */
export type FooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  primaryLinks_every?: InputMaybe<LinkWhereInput>;
  primaryLinks_none?: InputMaybe<LinkWhereInput>;
  primaryLinks_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  secondaryLinks_every?: InputMaybe<LinkWhereInput>;
  secondaryLinks_none?: InputMaybe<LinkWhereInput>;
  secondaryLinks_some?: InputMaybe<LinkWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FooterOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FooterUpdateInput = {
  primaryLinks?: InputMaybe<LinkUpdateManyInlineInput>;
  secondaryLinks?: InputMaybe<LinkUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FooterUpdateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterConnectInput>>;
  /** Create and connect multiple Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>;
  /** Delete multiple Footer documents */
  delete?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Disconnect multiple Footer documents */
  disconnect?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Footer documents */
  set?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Update multiple Footer documents */
  update?: InputMaybe<Array<FooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Footer documents */
  upsert?: InputMaybe<Array<FooterUpsertWithNestedWhereUniqueInput>>;
};

export type FooterUpdateManyInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type FooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterUpdateManyInput;
  /** Document search */
  where: FooterWhereInput;
};

export type FooterUpdateOneInlineInput = {
  /** Connect existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>;
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>;
  /** Delete currently connected Footer document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Footer document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Footer document */
  update?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Footer document */
  upsert?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>;
};

export type FooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterUpdateInput;
  /** Unique document search */
  where: FooterWhereUniqueInput;
};

export type FooterUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterCreateInput;
  /** Update document if it exists */
  update: FooterUpdateInput;
};

export type FooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterUpsertInput;
  /** Unique document search */
  where: FooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  primaryLinks_every?: InputMaybe<LinkWhereInput>;
  primaryLinks_none?: InputMaybe<LinkWhereInput>;
  primaryLinks_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  secondaryLinks_every?: InputMaybe<LinkWhereInput>;
  secondaryLinks_none?: InputMaybe<LinkWhereInput>;
  secondaryLinks_some?: InputMaybe<LinkWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Footer record uniquely */
export type FooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Form = Entity & Node & {
  __typename?: 'Form';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  details?: Maybe<RichText>;
  /** Get the document in other stages */
  documentInStages: Array<Form>;
  /** List of Form versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Form>;
  name?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  success?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type FormHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type FormPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type FormPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type FormUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormConnection = {
  __typename?: 'FormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** details input for default locale (en) */
  details?: InputMaybe<Scalars['RichTextAST']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** success input for default locale (en) */
  success?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FormCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['RichTextAST']>;
  success?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FormCreateLocalizationInput = {
  /** Localization input */
  data: FormCreateLocalizationDataInput;
  locale: Locale;
};

export type FormCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormCreateLocalizationInput>>;
};

export type FormCreateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Create and connect multiple existing Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
};

export type FormCreateOneInlineInput = {
  /** Connect one existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
};

/** An edge in a connection. */
export type FormEdge = {
  __typename?: 'FormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Form;
};

/** Identifies documents */
export type FormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SuccessAsc = 'success_ASC',
  SuccessDesc = 'success_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FormUpdateInput = {
  /** details input for default locale (en) */
  details?: InputMaybe<Scalars['RichTextAST']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** success input for default locale (en) */
  success?: InputMaybe<Scalars['String']>;
};

export type FormUpdateLocalizationDataInput = {
  details?: InputMaybe<Scalars['RichTextAST']>;
  success?: InputMaybe<Scalars['String']>;
};

export type FormUpdateLocalizationInput = {
  data: FormUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormUpsertLocalizationInput>>;
};

export type FormUpdateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormConnectInput>>;
  /** Create and connect multiple Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
  /** Delete multiple Form documents */
  delete?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Disconnect multiple Form documents */
  disconnect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Form documents */
  set?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Update multiple Form documents */
  update?: InputMaybe<Array<FormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Form documents */
  upsert?: InputMaybe<Array<FormUpsertWithNestedWhereUniqueInput>>;
};

export type FormUpdateManyInput = {
  /** details input for default locale (en) */
  details?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  /** success input for default locale (en) */
  success?: InputMaybe<Scalars['String']>;
};

export type FormUpdateManyLocalizationDataInput = {
  details?: InputMaybe<Scalars['RichTextAST']>;
  success?: InputMaybe<Scalars['String']>;
};

export type FormUpdateManyLocalizationInput = {
  data: FormUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormUpdateManyLocalizationInput>>;
};

export type FormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormUpdateManyInput;
  /** Document search */
  where: FormWhereInput;
};

export type FormUpdateOneInlineInput = {
  /** Connect existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
  /** Delete currently connected Form document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Form document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Form document */
  update?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Form document */
  upsert?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
};

export type FormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormUpdateInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

export type FormUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCreateInput;
  /** Update document if it exists */
  update: FormUpdateInput;
};

export type FormUpsertLocalizationInput = {
  create: FormCreateLocalizationDataInput;
  locale: Locale;
  update: FormUpdateLocalizationDataInput;
};

export type FormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormUpsertInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  success_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  success_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  success_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  success_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  success_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  success_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  success_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  success_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  success_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Form record uniquely */
export type FormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Gallery = Entity & {
  __typename?: 'Gallery';
  /** The unique identifier */
  id: Scalars['ID'];
  images: Array<Asset>;
  /** System stage field */
  stage: Stage;
};


export type GalleryImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetWhereInput>;
};

export type GalleryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GalleryWhereUniqueInput;
};

/** A connection to a list of items. */
export type GalleryConnection = {
  __typename?: 'GalleryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GalleryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GalleryCreateInput = {
  images?: InputMaybe<AssetCreateManyInlineInput>;
};

export type GalleryCreateManyInlineInput = {
  /** Create and connect multiple existing Gallery documents */
  create?: InputMaybe<Array<GalleryCreateInput>>;
};

export type GalleryCreateOneInlineInput = {
  /** Create and connect one Gallery document */
  create?: InputMaybe<GalleryCreateInput>;
};

export type GalleryCreateWithPositionInput = {
  /** Document to create */
  data: GalleryCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type GalleryEdge = {
  __typename?: 'GalleryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Gallery;
};

/** Identifies documents */
export type GalleryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GalleryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GalleryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GalleryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
};

export enum GalleryOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC'
}

export type GalleryUpdateInput = {
  images?: InputMaybe<AssetUpdateManyInlineInput>;
};

export type GalleryUpdateManyInlineInput = {
  /** Create and connect multiple Gallery component instances */
  create?: InputMaybe<Array<GalleryCreateWithPositionInput>>;
  /** Delete multiple Gallery documents */
  delete?: InputMaybe<Array<GalleryWhereUniqueInput>>;
  /** Update multiple Gallery component instances */
  update?: InputMaybe<Array<GalleryUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Gallery component instances */
  upsert?: InputMaybe<Array<GalleryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type GalleryUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type GalleryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GalleryUpdateManyInput;
  /** Document search */
  where: GalleryWhereInput;
};

export type GalleryUpdateOneInlineInput = {
  /** Create and connect one Gallery document */
  create?: InputMaybe<GalleryCreateInput>;
  /** Delete currently connected Gallery document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single Gallery document */
  update?: InputMaybe<GalleryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Gallery document */
  upsert?: InputMaybe<GalleryUpsertWithNestedWhereUniqueInput>;
};

export type GalleryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<GalleryUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: GalleryWhereUniqueInput;
};

export type GalleryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GalleryUpdateInput;
  /** Unique document search */
  where: GalleryWhereUniqueInput;
};

export type GalleryUpsertInput = {
  /** Create document if it didn't exist */
  create: GalleryCreateInput;
  /** Update document if it exists */
  update: GalleryUpdateInput;
};

export type GalleryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<GalleryUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: GalleryWhereUniqueInput;
};

export type GalleryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GalleryUpsertInput;
  /** Unique document search */
  where: GalleryWhereUniqueInput;
};

/** Identifies documents */
export type GalleryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GalleryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GalleryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GalleryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
};

/** References Gallery record uniquely */
export type GalleryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GeometryPolygon = {
  __typename?: 'GeometryPolygon';
  coordinates?: Maybe<Array<Array<Array<Scalars['Float']>>>>;
  type: Scalars['String'];
};

export type GeometryPolygonInput = {
  coordinates?: InputMaybe<Array<Array<Array<Scalars['Float']>>>>;
  /** Polygon */
  type: Scalars['String'];
};

export enum GridTheme {
  Dark = 'DARK',
  Light = 'LIGHT',
  White = 'WHITE'
}

export type Heading = Entity & Node & {
  __typename?: 'Heading';
  /** Element type (h1,h2,h3...) */
  as?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Heading>;
  headingText?: Maybe<HeadingText>;
  /** List of Heading versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Heading>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type HeadingCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type HeadingCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type HeadingDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type HeadingHeadingTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type HeadingHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type HeadingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type HeadingPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type HeadingPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type HeadingPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type HeadingScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type HeadingSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type HeadingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type HeadingUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeadingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeadingWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeadingConnection = {
  __typename?: 'HeadingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeadingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeadingCreateInput = {
  as?: InputMaybe<Scalars['String']>;
  ckybpv2rc021601xt94lcawzl?: InputMaybe<ContentCreateManyInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  headingText?: InputMaybe<HeadingTextCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeadingCreateLocalizationsInput>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type HeadingCreateLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type HeadingCreateLocalizationInput = {
  /** Localization input */
  data: HeadingCreateLocalizationDataInput;
  locale: Locale;
};

export type HeadingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeadingCreateLocalizationInput>>;
};

export type HeadingCreateManyInlineInput = {
  /** Connect multiple existing Heading documents */
  connect?: InputMaybe<Array<HeadingWhereUniqueInput>>;
  /** Create and connect multiple existing Heading documents */
  create?: InputMaybe<Array<HeadingCreateInput>>;
};

export type HeadingCreateOneInlineInput = {
  /** Connect one existing Heading document */
  connect?: InputMaybe<HeadingWhereUniqueInput>;
  /** Create and connect one Heading document */
  create?: InputMaybe<HeadingCreateInput>;
};

/** An edge in a connection. */
export type HeadingEdge = {
  __typename?: 'HeadingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Heading;
};

/** Identifies documents */
export type HeadingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  as?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  as_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  as_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  as_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  as_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  as_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  as_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  as_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  as_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  as_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeadingWhereStageInput>;
  documentInStages_none?: InputMaybe<HeadingWhereStageInput>;
  documentInStages_some?: InputMaybe<HeadingWhereStageInput>;
  headingText?: InputMaybe<HeadingTextWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeadingOrderByInput {
  AsAsc = 'as_ASC',
  AsDesc = 'as_DESC',
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type HeadingText = Entity & Node & {
  __typename?: 'HeadingText';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeadingText>;
  /** List of HeadingText versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items: Array<HeadingTextItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type HeadingTextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type HeadingTextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type HeadingTextHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type HeadingTextItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HeadingTextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type HeadingTextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type HeadingTextSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type HeadingTextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeadingTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeadingTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeadingTextConnection = {
  __typename?: 'HeadingTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeadingTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeadingTextCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<HeadingTextItemCreateManyInlineInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type HeadingTextCreateManyInlineInput = {
  /** Connect multiple existing HeadingText documents */
  connect?: InputMaybe<Array<HeadingTextWhereUniqueInput>>;
  /** Create and connect multiple existing HeadingText documents */
  create?: InputMaybe<Array<HeadingTextCreateInput>>;
};

export type HeadingTextCreateOneInlineInput = {
  /** Connect one existing HeadingText document */
  connect?: InputMaybe<HeadingTextWhereUniqueInput>;
  /** Create and connect one HeadingText document */
  create?: InputMaybe<HeadingTextCreateInput>;
};

/** An edge in a connection. */
export type HeadingTextEdge = {
  __typename?: 'HeadingTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HeadingText;
};

export type HeadingTextItem = Heading | Text;

export type HeadingTextItemConnectInput = {
  Heading?: InputMaybe<HeadingConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type HeadingTextItemCreateInput = {
  Heading?: InputMaybe<HeadingCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type HeadingTextItemCreateManyInlineInput = {
  /** Connect multiple existing HeadingTextItem documents */
  connect?: InputMaybe<Array<HeadingTextItemWhereUniqueInput>>;
  /** Create and connect multiple existing HeadingTextItem documents */
  create?: InputMaybe<Array<HeadingTextItemCreateInput>>;
};

export type HeadingTextItemCreateOneInlineInput = {
  /** Connect one existing HeadingTextItem document */
  connect?: InputMaybe<HeadingTextItemWhereUniqueInput>;
  /** Create and connect one HeadingTextItem document */
  create?: InputMaybe<HeadingTextItemCreateInput>;
};

export type HeadingTextItemUpdateInput = {
  Heading?: InputMaybe<HeadingUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type HeadingTextItemUpdateManyInlineInput = {
  /** Connect multiple existing HeadingTextItem documents */
  connect?: InputMaybe<Array<HeadingTextItemConnectInput>>;
  /** Create and connect multiple HeadingTextItem documents */
  create?: InputMaybe<Array<HeadingTextItemCreateInput>>;
  /** Delete multiple HeadingTextItem documents */
  delete?: InputMaybe<Array<HeadingTextItemWhereUniqueInput>>;
  /** Disconnect multiple HeadingTextItem documents */
  disconnect?: InputMaybe<Array<HeadingTextItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeadingTextItem documents */
  set?: InputMaybe<Array<HeadingTextItemWhereUniqueInput>>;
  /** Update multiple HeadingTextItem documents */
  update?: InputMaybe<Array<HeadingTextItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeadingTextItem documents */
  upsert?: InputMaybe<Array<HeadingTextItemUpsertWithNestedWhereUniqueInput>>;
};

export type HeadingTextItemUpdateManyWithNestedWhereInput = {
  Heading?: InputMaybe<HeadingUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type HeadingTextItemUpdateOneInlineInput = {
  /** Connect existing HeadingTextItem document */
  connect?: InputMaybe<HeadingTextItemWhereUniqueInput>;
  /** Create and connect one HeadingTextItem document */
  create?: InputMaybe<HeadingTextItemCreateInput>;
  /** Delete currently connected HeadingTextItem document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected HeadingTextItem document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single HeadingTextItem document */
  update?: InputMaybe<HeadingTextItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeadingTextItem document */
  upsert?: InputMaybe<HeadingTextItemUpsertWithNestedWhereUniqueInput>;
};

export type HeadingTextItemUpdateWithNestedWhereUniqueInput = {
  Heading?: InputMaybe<HeadingUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type HeadingTextItemUpsertWithNestedWhereUniqueInput = {
  Heading?: InputMaybe<HeadingUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type HeadingTextItemWhereInput = {
  Heading?: InputMaybe<HeadingWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type HeadingTextItemWhereUniqueInput = {
  Heading?: InputMaybe<HeadingWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

/** Identifies documents */
export type HeadingTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeadingTextWhereStageInput>;
  documentInStages_none?: InputMaybe<HeadingTextWhereStageInput>;
  documentInStages_some?: InputMaybe<HeadingTextWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<HeadingTextItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeadingTextOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type HeadingTextUpdateInput = {
  items?: InputMaybe<HeadingTextItemUpdateManyInlineInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
};

export type HeadingTextUpdateManyInlineInput = {
  /** Connect multiple existing HeadingText documents */
  connect?: InputMaybe<Array<HeadingTextConnectInput>>;
  /** Create and connect multiple HeadingText documents */
  create?: InputMaybe<Array<HeadingTextCreateInput>>;
  /** Delete multiple HeadingText documents */
  delete?: InputMaybe<Array<HeadingTextWhereUniqueInput>>;
  /** Disconnect multiple HeadingText documents */
  disconnect?: InputMaybe<Array<HeadingTextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeadingText documents */
  set?: InputMaybe<Array<HeadingTextWhereUniqueInput>>;
  /** Update multiple HeadingText documents */
  update?: InputMaybe<Array<HeadingTextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeadingText documents */
  upsert?: InputMaybe<Array<HeadingTextUpsertWithNestedWhereUniqueInput>>;
};

export type HeadingTextUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type HeadingTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeadingTextUpdateManyInput;
  /** Document search */
  where: HeadingTextWhereInput;
};

export type HeadingTextUpdateOneInlineInput = {
  /** Connect existing HeadingText document */
  connect?: InputMaybe<HeadingTextWhereUniqueInput>;
  /** Create and connect one HeadingText document */
  create?: InputMaybe<HeadingTextCreateInput>;
  /** Delete currently connected HeadingText document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected HeadingText document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single HeadingText document */
  update?: InputMaybe<HeadingTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeadingText document */
  upsert?: InputMaybe<HeadingTextUpsertWithNestedWhereUniqueInput>;
};

export type HeadingTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeadingTextUpdateInput;
  /** Unique document search */
  where: HeadingTextWhereUniqueInput;
};

export type HeadingTextUpsertInput = {
  /** Create document if it didn't exist */
  create: HeadingTextCreateInput;
  /** Update document if it exists */
  update: HeadingTextUpdateInput;
};

export type HeadingTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeadingTextUpsertInput;
  /** Unique document search */
  where: HeadingTextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeadingTextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type HeadingTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeadingTextWhereStageInput>;
  documentInStages_none?: InputMaybe<HeadingTextWhereStageInput>;
  documentInStages_some?: InputMaybe<HeadingTextWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<HeadingTextItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeadingTextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingTextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingTextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingTextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeadingTextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeadingText record uniquely */
export type HeadingTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type HeadingUpdateInput = {
  as?: InputMaybe<Scalars['String']>;
  ckybpv2rc021601xt94lcawzl?: InputMaybe<ContentUpdateManyInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  headingText?: InputMaybe<HeadingTextUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<HeadingUpdateLocalizationsInput>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
};

export type HeadingUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']>;
};

export type HeadingUpdateLocalizationInput = {
  data: HeadingUpdateLocalizationDataInput;
  locale: Locale;
};

export type HeadingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeadingCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<HeadingUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<HeadingUpsertLocalizationInput>>;
};

export type HeadingUpdateManyInlineInput = {
  /** Connect multiple existing Heading documents */
  connect?: InputMaybe<Array<HeadingConnectInput>>;
  /** Create and connect multiple Heading documents */
  create?: InputMaybe<Array<HeadingCreateInput>>;
  /** Delete multiple Heading documents */
  delete?: InputMaybe<Array<HeadingWhereUniqueInput>>;
  /** Disconnect multiple Heading documents */
  disconnect?: InputMaybe<Array<HeadingWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Heading documents */
  set?: InputMaybe<Array<HeadingWhereUniqueInput>>;
  /** Update multiple Heading documents */
  update?: InputMaybe<Array<HeadingUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Heading documents */
  upsert?: InputMaybe<Array<HeadingUpsertWithNestedWhereUniqueInput>>;
};

export type HeadingUpdateManyInput = {
  as?: InputMaybe<Scalars['String']>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeadingUpdateManyLocalizationsInput>;
};

export type HeadingUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']>;
};

export type HeadingUpdateManyLocalizationInput = {
  data: HeadingUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type HeadingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeadingUpdateManyLocalizationInput>>;
};

export type HeadingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeadingUpdateManyInput;
  /** Document search */
  where: HeadingWhereInput;
};

export type HeadingUpdateOneInlineInput = {
  /** Connect existing Heading document */
  connect?: InputMaybe<HeadingWhereUniqueInput>;
  /** Create and connect one Heading document */
  create?: InputMaybe<HeadingCreateInput>;
  /** Delete currently connected Heading document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Heading document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Heading document */
  update?: InputMaybe<HeadingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Heading document */
  upsert?: InputMaybe<HeadingUpsertWithNestedWhereUniqueInput>;
};

export type HeadingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeadingUpdateInput;
  /** Unique document search */
  where: HeadingWhereUniqueInput;
};

export type HeadingUpsertInput = {
  /** Create document if it didn't exist */
  create: HeadingCreateInput;
  /** Update document if it exists */
  update: HeadingUpdateInput;
};

export type HeadingUpsertLocalizationInput = {
  create: HeadingCreateLocalizationDataInput;
  locale: Locale;
  update: HeadingUpdateLocalizationDataInput;
};

export type HeadingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeadingUpsertInput;
  /** Unique document search */
  where: HeadingWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeadingWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type HeadingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  as?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  as_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  as_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  as_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  as_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  as_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  as_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  as_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  as_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  as_starts_with?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeadingWhereStageInput>;
  documentInStages_none?: InputMaybe<HeadingWhereStageInput>;
  documentInStages_some?: InputMaybe<HeadingWhereStageInput>;
  headingText?: InputMaybe<HeadingTextWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeadingWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeadingWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Heading record uniquely */
export type HeadingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum Icon {
  Phone = 'PHONE'
}

export enum Illustration {
  Inspiration = 'INSPIRATION',
  Location = 'LOCATION',
  Plots = 'PLOTS',
  Projects = 'PROJECTS'
}

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale'
}

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']>;
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
};

export type ImagineProject = {
  __typename?: 'ImagineProject';
  _id?: Maybe<Scalars['ObjectId']>;
  author?: Maybe<ProjectAuthor>;
  images?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  team?: Maybe<Scalars['String']>;
};

export type Layer = {
  __typename?: 'Layer';
  _id: Scalars['ObjectId'];
  category?: Maybe<MapLayerCategory>;
  feature: PolygonFeature;
};

export type LayerProperties = {
  __typename?: 'LayerProperties';
  area: Scalars['Float'];
  label: Scalars['String'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  selectable: Scalars['Boolean'];
  visible: Scalars['Boolean'];
};

export type LayerPropertiesInput = {
  area: Scalars['Float'];
  label: Scalars['String'];
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Float']>;
  selectable?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type Link = Entity & Node & {
  __typename?: 'Link';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Link>;
  /** List of Link versions */
  history: Array<Version>;
  icon?: Maybe<Icon>;
  /** The unique identifier */
  id: Scalars['ID'];
  illustration?: Maybe<Illustration>;
  image?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Link>;
  page?: Maybe<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  showTitle?: Maybe<Scalars['Boolean']>;
  size?: Maybe<ButtonSize>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<ButtonVariant>;
};


export type LinkCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type LinkHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type LinkImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type LinkPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LinkStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type LinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  ckxk2nl423hlr01z077x4ghy7?: InputMaybe<NavigationCreateManyInlineInput>;
  cky0e5szt3pff01z28xu44qxp?: InputMaybe<PlaceCreateManyInlineInput>;
  cky1kzuq64rsv01yu0v9g7505?: InputMaybe<FooterCreateManyInlineInput>;
  cky1l0ks04nsc01wec8hehcgz?: InputMaybe<FooterCreateManyInlineInput>;
  ckyb6b4nq12hx01z67w3s81ti?: InputMaybe<LinkGroupCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Icon>;
  illustration?: InputMaybe<Illustration>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LinkCreateLocalizationsInput>;
  page?: InputMaybe<PageCreateOneInlineInput>;
  showTitle?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ButtonSize>;
  slug?: InputMaybe<Scalars['String']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ButtonVariant>;
};

export type LinkCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LinkCreateLocalizationInput = {
  /** Localization input */
  data: LinkCreateLocalizationDataInput;
  locale: Locale;
};

export type LinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
};

export type LinkCreateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Connect one existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Link;
};

export type LinkGroup = Entity & Node & {
  __typename?: 'LinkGroup';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<LinkGroup>;
  /** List of LinkGroup versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items: Array<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<LinkGroup>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type LinkGroupCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkGroupCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGroupDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type LinkGroupHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type LinkGroupItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type LinkGroupLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type LinkGroupPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkGroupPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGroupScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LinkGroupSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type LinkGroupUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkGroupUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LinkGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkGroupConnection = {
  __typename?: 'LinkGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkGroupCreateInput = {
  ckybpy7b5023q01xt5gy87llr?: InputMaybe<ContentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<LinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LinkGroupCreateLocalizationsInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  /** slug input for default locale (en) */
  slug?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LinkGroupCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LinkGroupCreateLocalizationInput = {
  /** Localization input */
  data: LinkGroupCreateLocalizationDataInput;
  locale: Locale;
};

export type LinkGroupCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LinkGroupCreateLocalizationInput>>;
};

export type LinkGroupCreateManyInlineInput = {
  /** Connect multiple existing LinkGroup documents */
  connect?: InputMaybe<Array<LinkGroupWhereUniqueInput>>;
  /** Create and connect multiple existing LinkGroup documents */
  create?: InputMaybe<Array<LinkGroupCreateInput>>;
};

export type LinkGroupCreateOneInlineInput = {
  /** Connect one existing LinkGroup document */
  connect?: InputMaybe<LinkGroupWhereUniqueInput>;
  /** Create and connect one LinkGroup document */
  create?: InputMaybe<LinkGroupCreateInput>;
};

/** An edge in a connection. */
export type LinkGroupEdge = {
  __typename?: 'LinkGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LinkGroup;
};

/** Identifies documents */
export type LinkGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LinkGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  items_every?: InputMaybe<LinkWhereInput>;
  items_none?: InputMaybe<LinkWhereInput>;
  items_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LinkGroupOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type LinkGroupUpdateInput = {
  ckybpy7b5023q01xt5gy87llr?: InputMaybe<ContentUpdateManyInlineInput>;
  items?: InputMaybe<LinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<LinkGroupUpdateLocalizationsInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  /** slug input for default locale (en) */
  slug?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type LinkGroupUpdateLocalizationDataInput = {
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type LinkGroupUpdateLocalizationInput = {
  data: LinkGroupUpdateLocalizationDataInput;
  locale: Locale;
};

export type LinkGroupUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LinkGroupCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LinkGroupUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LinkGroupUpsertLocalizationInput>>;
};

export type LinkGroupUpdateManyInlineInput = {
  /** Connect multiple existing LinkGroup documents */
  connect?: InputMaybe<Array<LinkGroupConnectInput>>;
  /** Create and connect multiple LinkGroup documents */
  create?: InputMaybe<Array<LinkGroupCreateInput>>;
  /** Delete multiple LinkGroup documents */
  delete?: InputMaybe<Array<LinkGroupWhereUniqueInput>>;
  /** Disconnect multiple LinkGroup documents */
  disconnect?: InputMaybe<Array<LinkGroupWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkGroup documents */
  set?: InputMaybe<Array<LinkGroupWhereUniqueInput>>;
  /** Update multiple LinkGroup documents */
  update?: InputMaybe<Array<LinkGroupUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkGroup documents */
  upsert?: InputMaybe<Array<LinkGroupUpsertWithNestedWhereUniqueInput>>;
};

export type LinkGroupUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<LinkGroupUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type LinkGroupUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type LinkGroupUpdateManyLocalizationInput = {
  data: LinkGroupUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LinkGroupUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LinkGroupUpdateManyLocalizationInput>>;
};

export type LinkGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkGroupUpdateManyInput;
  /** Document search */
  where: LinkGroupWhereInput;
};

export type LinkGroupUpdateOneInlineInput = {
  /** Connect existing LinkGroup document */
  connect?: InputMaybe<LinkGroupWhereUniqueInput>;
  /** Create and connect one LinkGroup document */
  create?: InputMaybe<LinkGroupCreateInput>;
  /** Delete currently connected LinkGroup document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected LinkGroup document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single LinkGroup document */
  update?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkGroup document */
  upsert?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
};

export type LinkGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkGroupUpdateInput;
  /** Unique document search */
  where: LinkGroupWhereUniqueInput;
};

export type LinkGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkGroupCreateInput;
  /** Update document if it exists */
  update: LinkGroupUpdateInput;
};

export type LinkGroupUpsertLocalizationInput = {
  create: LinkGroupCreateLocalizationDataInput;
  locale: Locale;
  update: LinkGroupUpdateLocalizationDataInput;
};

export type LinkGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkGroupUpsertInput;
  /** Unique document search */
  where: LinkGroupWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LinkGroupWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type LinkGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LinkGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  items_every?: InputMaybe<LinkWhereInput>;
  items_none?: InputMaybe<LinkWhereInput>;
  items_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LinkGroupWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkGroupWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkGroupWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkGroupWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LinkGroupWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LinkGroup record uniquely */
export type LinkGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  icon?: InputMaybe<Icon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<Icon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<Icon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<Icon>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  illustration?: InputMaybe<Illustration>;
  /** All values that are contained in given list. */
  illustration_in?: InputMaybe<Array<InputMaybe<Illustration>>>;
  /** Any other value that exists and is not equal to the given value. */
  illustration_not?: InputMaybe<Illustration>;
  /** All values that are not contained in given list. */
  illustration_not_in?: InputMaybe<Array<InputMaybe<Illustration>>>;
  image?: InputMaybe<AssetWhereInput>;
  page?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showTitle?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showTitle_not?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ButtonSize>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<ButtonSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<ButtonSize>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<ButtonSize>>>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  variant?: InputMaybe<ButtonVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<ButtonVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<ButtonVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<ButtonVariant>>>;
};

export enum LinkOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IllustrationAsc = 'illustration_ASC',
  IllustrationDesc = 'illustration_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type LinkUpdateInput = {
  ckxk2nl423hlr01z077x4ghy7?: InputMaybe<NavigationUpdateManyInlineInput>;
  cky0e5szt3pff01z28xu44qxp?: InputMaybe<PlaceUpdateManyInlineInput>;
  cky1kzuq64rsv01yu0v9g7505?: InputMaybe<FooterUpdateManyInlineInput>;
  cky1l0ks04nsc01wec8hehcgz?: InputMaybe<FooterUpdateManyInlineInput>;
  ckyb6b4nq12hx01z67w3s81ti?: InputMaybe<LinkGroupUpdateManyInlineInput>;
  icon?: InputMaybe<Icon>;
  illustration?: InputMaybe<Illustration>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<LinkUpdateLocalizationsInput>;
  page?: InputMaybe<PageUpdateOneInlineInput>;
  showTitle?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ButtonSize>;
  slug?: InputMaybe<Scalars['String']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ButtonVariant>;
};

export type LinkUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LinkUpdateLocalizationInput = {
  data: LinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LinkUpsertLocalizationInput>>;
};

export type LinkUpdateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkConnectInput>>;
  /** Create and connect multiple Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Disconnect multiple Link documents */
  disconnect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Link documents */
  set?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link documents */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Link documents */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkUpdateManyInput = {
  icon?: InputMaybe<Icon>;
  illustration?: InputMaybe<Illustration>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<LinkUpdateManyLocalizationsInput>;
  showTitle?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ButtonSize>;
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ButtonVariant>;
};

export type LinkUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LinkUpdateManyLocalizationInput = {
  data: LinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateManyLocalizationInput>>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Connect existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Link document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertLocalizationInput = {
  create: LinkCreateLocalizationDataInput;
  locale: Locale;
  update: LinkUpdateLocalizationDataInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  icon?: InputMaybe<Icon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<Icon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<Icon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<Icon>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  illustration?: InputMaybe<Illustration>;
  /** All values that are contained in given list. */
  illustration_in?: InputMaybe<Array<InputMaybe<Illustration>>>;
  /** Any other value that exists and is not equal to the given value. */
  illustration_not?: InputMaybe<Illustration>;
  /** All values that are not contained in given list. */
  illustration_not_in?: InputMaybe<Array<InputMaybe<Illustration>>>;
  image?: InputMaybe<AssetWhereInput>;
  page?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showTitle?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showTitle_not?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ButtonSize>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<ButtonSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<ButtonSize>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<ButtonSize>>>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ButtonVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<ButtonVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<ButtonVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<ButtonVariant>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en',
  Ro = 'ro'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type LoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponseDto = {
  __typename?: 'LoginResponseDTO';
  token: Scalars['String'];
};

export type MapLayerCategory = {
  __typename?: 'MapLayerCategory';
  _id: Scalars['ObjectId'];
  code?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type MapLayerPoint = {
  __typename?: 'MapLayerPoint';
  _id: Scalars['ObjectId'];
  index: Scalars['Float'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  order: Scalars['Float'];
  projection: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Me = {
  __typename?: 'Me';
  profile?: Maybe<Participant>;
  role?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type Media = Entity & Node & {
  __typename?: 'Media';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Media>;
  /** List of Media versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items: Array<MediaGroupItems>;
  name?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type MediaCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MediaDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type MediaHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type MediaItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MediaPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type MediaPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MediaScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MediaSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type MediaUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MediaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MediaWhereUniqueInput;
};

/** A connection to a list of items. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MediaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MediaCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<MediaGroupItemsCreateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MediaCreateManyInlineInput = {
  /** Connect multiple existing Media documents */
  connect?: InputMaybe<Array<MediaWhereUniqueInput>>;
  /** Create and connect multiple existing Media documents */
  create?: InputMaybe<Array<MediaCreateInput>>;
};

export type MediaCreateOneInlineInput = {
  /** Connect one existing Media document */
  connect?: InputMaybe<MediaWhereUniqueInput>;
  /** Create and connect one Media document */
  create?: InputMaybe<MediaCreateInput>;
};

/** An edge in a connection. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Media;
};

export type MediaGroupItems = Asset | Video;

export type MediaGroupItemsConnectInput = {
  Asset?: InputMaybe<AssetConnectInput>;
  Video?: InputMaybe<VideoConnectInput>;
};

export type MediaGroupItemsCreateInput = {
  Asset?: InputMaybe<AssetCreateInput>;
  Video?: InputMaybe<VideoCreateInput>;
};

export type MediaGroupItemsCreateManyInlineInput = {
  /** Connect multiple existing MediaGroupItems documents */
  connect?: InputMaybe<Array<MediaGroupItemsWhereUniqueInput>>;
  /** Create and connect multiple existing MediaGroupItems documents */
  create?: InputMaybe<Array<MediaGroupItemsCreateInput>>;
};

export type MediaGroupItemsCreateOneInlineInput = {
  /** Connect one existing MediaGroupItems document */
  connect?: InputMaybe<MediaGroupItemsWhereUniqueInput>;
  /** Create and connect one MediaGroupItems document */
  create?: InputMaybe<MediaGroupItemsCreateInput>;
};

export type MediaGroupItemsUpdateInput = {
  Asset?: InputMaybe<AssetUpdateInput>;
  Video?: InputMaybe<VideoUpdateInput>;
};

export type MediaGroupItemsUpdateManyInlineInput = {
  /** Connect multiple existing MediaGroupItems documents */
  connect?: InputMaybe<Array<MediaGroupItemsConnectInput>>;
  /** Create and connect multiple MediaGroupItems documents */
  create?: InputMaybe<Array<MediaGroupItemsCreateInput>>;
  /** Delete multiple MediaGroupItems documents */
  delete?: InputMaybe<Array<MediaGroupItemsWhereUniqueInput>>;
  /** Disconnect multiple MediaGroupItems documents */
  disconnect?: InputMaybe<Array<MediaGroupItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MediaGroupItems documents */
  set?: InputMaybe<Array<MediaGroupItemsWhereUniqueInput>>;
  /** Update multiple MediaGroupItems documents */
  update?: InputMaybe<Array<MediaGroupItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MediaGroupItems documents */
  upsert?: InputMaybe<Array<MediaGroupItemsUpsertWithNestedWhereUniqueInput>>;
};

export type MediaGroupItemsUpdateManyWithNestedWhereInput = {
  Asset?: InputMaybe<AssetUpdateManyWithNestedWhereInput>;
  Video?: InputMaybe<VideoUpdateManyWithNestedWhereInput>;
};

export type MediaGroupItemsUpdateOneInlineInput = {
  /** Connect existing MediaGroupItems document */
  connect?: InputMaybe<MediaGroupItemsWhereUniqueInput>;
  /** Create and connect one MediaGroupItems document */
  create?: InputMaybe<MediaGroupItemsCreateInput>;
  /** Delete currently connected MediaGroupItems document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected MediaGroupItems document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single MediaGroupItems document */
  update?: InputMaybe<MediaGroupItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MediaGroupItems document */
  upsert?: InputMaybe<MediaGroupItemsUpsertWithNestedWhereUniqueInput>;
};

export type MediaGroupItemsUpdateWithNestedWhereUniqueInput = {
  Asset?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
};

export type MediaGroupItemsUpsertWithNestedWhereUniqueInput = {
  Asset?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type MediaGroupItemsWhereInput = {
  Asset?: InputMaybe<AssetWhereInput>;
  Video?: InputMaybe<VideoWhereInput>;
};

export type MediaGroupItemsWhereUniqueInput = {
  Asset?: InputMaybe<AssetWhereUniqueInput>;
  Video?: InputMaybe<VideoWhereUniqueInput>;
};

/** Identifies documents */
export type MediaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<MediaGroupItemsWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MediaOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type MediaUpdateInput = {
  items?: InputMaybe<MediaGroupItemsUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type MediaUpdateManyInlineInput = {
  /** Connect multiple existing Media documents */
  connect?: InputMaybe<Array<MediaConnectInput>>;
  /** Create and connect multiple Media documents */
  create?: InputMaybe<Array<MediaCreateInput>>;
  /** Delete multiple Media documents */
  delete?: InputMaybe<Array<MediaWhereUniqueInput>>;
  /** Disconnect multiple Media documents */
  disconnect?: InputMaybe<Array<MediaWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Media documents */
  set?: InputMaybe<Array<MediaWhereUniqueInput>>;
  /** Update multiple Media documents */
  update?: InputMaybe<Array<MediaUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Media documents */
  upsert?: InputMaybe<Array<MediaUpsertWithNestedWhereUniqueInput>>;
};

export type MediaUpdateManyInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type MediaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MediaUpdateManyInput;
  /** Document search */
  where: MediaWhereInput;
};

export type MediaUpdateOneInlineInput = {
  /** Connect existing Media document */
  connect?: InputMaybe<MediaWhereUniqueInput>;
  /** Create and connect one Media document */
  create?: InputMaybe<MediaCreateInput>;
  /** Delete currently connected Media document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Media document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Media document */
  update?: InputMaybe<MediaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Media document */
  upsert?: InputMaybe<MediaUpsertWithNestedWhereUniqueInput>;
};

export type MediaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MediaUpdateInput;
  /** Unique document search */
  where: MediaWhereUniqueInput;
};

export type MediaUpsertInput = {
  /** Create document if it didn't exist */
  create: MediaCreateInput;
  /** Update document if it exists */
  update: MediaUpdateInput;
};

export type MediaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MediaUpsertInput;
  /** Unique document search */
  where: MediaWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MediaWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type MediaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<MediaGroupItemsWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MediaWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MediaWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Media record uniquely */
export type MediaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Member = {
  __typename?: 'Member';
  name: Scalars['String'];
  signatureNumber: Scalars['String'];
};

export type MemberInput = {
  name: Scalars['String'];
  signatureNumber: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateProject: Project;
  addLayer: Layer;
  addProject: Project;
  /**
   * Create one asset
   * @deprecated Asset mutations will be overhauled soon
   */
  createAsset?: Maybe<Asset>;
  /** Create one content */
  createContent?: Maybe<Content>;
  createEnquiry: Enquiry;
  /** Create one footer */
  createFooter?: Maybe<Footer>;
  /** Create one form */
  createForm?: Maybe<Form>;
  /** Create one heading */
  createHeading?: Maybe<Heading>;
  /** Create one headingText */
  createHeadingText?: Maybe<HeadingText>;
  /** Create one link */
  createLink?: Maybe<Link>;
  /** Create one linkGroup */
  createLinkGroup?: Maybe<LinkGroup>;
  /** Create one media */
  createMedia?: Maybe<Media>;
  /** Create one navigation */
  createNavigation?: Maybe<Navigation>;
  /** Create one page */
  createPage?: Maybe<Page>;
  /** Create one place */
  createPlace?: Maybe<Place>;
  /** Create one prop */
  createProp?: Maybe<Prop>;
  /** Create one question */
  createQuestion?: Maybe<Question>;
  /** Create one questionGroup */
  createQuestionGroup?: Maybe<QuestionGroup>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one section */
  createSection?: Maybe<Section>;
  /** Create one seo */
  createSeo?: Maybe<Seo>;
  /** Create one story */
  createStory?: Maybe<Story>;
  /** Create one text */
  createText?: Maybe<Text>;
  /** Create one textSection */
  createTextSection?: Maybe<TextSection>;
  /** Create one video */
  createVideo?: Maybe<Video>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one content from _all_ existing stages. Returns deleted document. */
  deleteContent?: Maybe<Content>;
  /** Delete one footer from _all_ existing stages. Returns deleted document. */
  deleteFooter?: Maybe<Footer>;
  /** Delete one form from _all_ existing stages. Returns deleted document. */
  deleteForm?: Maybe<Form>;
  /** Delete one heading from _all_ existing stages. Returns deleted document. */
  deleteHeading?: Maybe<Heading>;
  /** Delete one headingText from _all_ existing stages. Returns deleted document. */
  deleteHeadingText?: Maybe<HeadingText>;
  deleteLayer: Scalars['String'];
  /** Delete one link from _all_ existing stages. Returns deleted document. */
  deleteLink?: Maybe<Link>;
  /** Delete one linkGroup from _all_ existing stages. Returns deleted document. */
  deleteLinkGroup?: Maybe<LinkGroup>;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many Content documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentsConnection)
   */
  deleteManyContents: BatchPayload;
  /** Delete many Content documents, return deleted documents */
  deleteManyContentsConnection: ContentConnection;
  /**
   * Delete many Footer documents
   * @deprecated Please use the new paginated many mutation (deleteManyFootersConnection)
   */
  deleteManyFooters: BatchPayload;
  /** Delete many Footer documents, return deleted documents */
  deleteManyFootersConnection: FooterConnection;
  /**
   * Delete many Form documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormsConnection)
   */
  deleteManyForms: BatchPayload;
  /** Delete many Form documents, return deleted documents */
  deleteManyFormsConnection: FormConnection;
  /**
   * Delete many HeadingText documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeadingTextsConnection)
   */
  deleteManyHeadingTexts: BatchPayload;
  /** Delete many HeadingText documents, return deleted documents */
  deleteManyHeadingTextsConnection: HeadingTextConnection;
  /**
   * Delete many Heading documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeadingsConnection)
   */
  deleteManyHeadings: BatchPayload;
  /** Delete many Heading documents, return deleted documents */
  deleteManyHeadingsConnection: HeadingConnection;
  /**
   * Delete many LinkGroup documents
   * @deprecated Please use the new paginated many mutation (deleteManyLinkGroupsConnection)
   */
  deleteManyLinkGroups: BatchPayload;
  /** Delete many LinkGroup documents, return deleted documents */
  deleteManyLinkGroupsConnection: LinkGroupConnection;
  /**
   * Delete many Link documents
   * @deprecated Please use the new paginated many mutation (deleteManyLinksConnection)
   */
  deleteManyLinks: BatchPayload;
  /** Delete many Link documents, return deleted documents */
  deleteManyLinksConnection: LinkConnection;
  /**
   * Delete many Media documents
   * @deprecated Please use the new paginated many mutation (deleteManyMediasConnection)
   */
  deleteManyMedias: BatchPayload;
  /** Delete many Media documents, return deleted documents */
  deleteManyMediasConnection: MediaConnection;
  /**
   * Delete many Navigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationsConnection)
   */
  deleteManyNavigations: BatchPayload;
  /** Delete many Navigation documents, return deleted documents */
  deleteManyNavigationsConnection: NavigationConnection;
  /**
   * Delete many Page documents
   * @deprecated Please use the new paginated many mutation (deleteManyPagesConnection)
   */
  deleteManyPages: BatchPayload;
  /** Delete many Page documents, return deleted documents */
  deleteManyPagesConnection: PageConnection;
  /**
   * Delete many Place documents
   * @deprecated Please use the new paginated many mutation (deleteManyPlacesConnection)
   */
  deleteManyPlaces: BatchPayload;
  /** Delete many Place documents, return deleted documents */
  deleteManyPlacesConnection: PlaceConnection;
  /**
   * Delete many Prop documents
   * @deprecated Please use the new paginated many mutation (deleteManyPropsConnection)
   */
  deleteManyProps: BatchPayload;
  /** Delete many Prop documents, return deleted documents */
  deleteManyPropsConnection: PropConnection;
  /**
   * Delete many QuestionGroup documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionGroupsConnection)
   */
  deleteManyQuestionGroups: BatchPayload;
  /** Delete many QuestionGroup documents, return deleted documents */
  deleteManyQuestionGroupsConnection: QuestionGroupConnection;
  /**
   * Delete many Question documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionsConnection)
   */
  deleteManyQuestions: BatchPayload;
  /** Delete many Question documents, return deleted documents */
  deleteManyQuestionsConnection: QuestionConnection;
  /**
   * Delete many Section documents
   * @deprecated Please use the new paginated many mutation (deleteManySectionsConnection)
   */
  deleteManySections: BatchPayload;
  /** Delete many Section documents, return deleted documents */
  deleteManySectionsConnection: SectionConnection;
  /**
   * Delete many Seo documents
   * @deprecated Please use the new paginated many mutation (deleteManySeosConnection)
   */
  deleteManySeos: BatchPayload;
  /** Delete many Seo documents, return deleted documents */
  deleteManySeosConnection: SeoConnection;
  /**
   * Delete many Story documents
   * @deprecated Please use the new paginated many mutation (deleteManyStoriesConnection)
   */
  deleteManyStories: BatchPayload;
  /** Delete many Story documents, return deleted documents */
  deleteManyStoriesConnection: StoryConnection;
  /**
   * Delete many TextSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyTextSectionsConnection)
   */
  deleteManyTextSections: BatchPayload;
  /** Delete many TextSection documents, return deleted documents */
  deleteManyTextSectionsConnection: TextSectionConnection;
  /**
   * Delete many Text documents
   * @deprecated Please use the new paginated many mutation (deleteManyTextsConnection)
   */
  deleteManyTexts: BatchPayload;
  /** Delete many Text documents, return deleted documents */
  deleteManyTextsConnection: TextConnection;
  /**
   * Delete many Video documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideosConnection)
   */
  deleteManyVideos: BatchPayload;
  /** Delete many Video documents, return deleted documents */
  deleteManyVideosConnection: VideoConnection;
  /** Delete one media from _all_ existing stages. Returns deleted document. */
  deleteMedia?: Maybe<Media>;
  /** Delete one navigation from _all_ existing stages. Returns deleted document. */
  deleteNavigation?: Maybe<Navigation>;
  /** Delete one page from _all_ existing stages. Returns deleted document. */
  deletePage?: Maybe<Page>;
  /** Delete one place from _all_ existing stages. Returns deleted document. */
  deletePlace?: Maybe<Place>;
  deleteProject: Scalars['Boolean'];
  /** Delete one prop from _all_ existing stages. Returns deleted document. */
  deleteProp?: Maybe<Prop>;
  /** Delete one question from _all_ existing stages. Returns deleted document. */
  deleteQuestion?: Maybe<Question>;
  /** Delete one questionGroup from _all_ existing stages. Returns deleted document. */
  deleteQuestionGroup?: Maybe<QuestionGroup>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one section from _all_ existing stages. Returns deleted document. */
  deleteSection?: Maybe<Section>;
  /** Delete one seo from _all_ existing stages. Returns deleted document. */
  deleteSeo?: Maybe<Seo>;
  /** Delete one story from _all_ existing stages. Returns deleted document. */
  deleteStory?: Maybe<Story>;
  /** Delete one text from _all_ existing stages. Returns deleted document. */
  deleteText?: Maybe<Text>;
  /** Delete one textSection from _all_ existing stages. Returns deleted document. */
  deleteTextSection?: Maybe<TextSection>;
  /** Delete one video from _all_ existing stages. Returns deleted document. */
  deleteVideo?: Maybe<Video>;
  login: LoginResponseDto;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one content */
  publishContent?: Maybe<Content>;
  /** Publish one footer */
  publishFooter?: Maybe<Footer>;
  /** Publish one form */
  publishForm?: Maybe<Form>;
  /** Publish one heading */
  publishHeading?: Maybe<Heading>;
  /** Publish one headingText */
  publishHeadingText?: Maybe<HeadingText>;
  /** Publish one link */
  publishLink?: Maybe<Link>;
  /** Publish one linkGroup */
  publishLinkGroup?: Maybe<LinkGroup>;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many Content documents
   * @deprecated Please use the new paginated many mutation (publishManyContentsConnection)
   */
  publishManyContents: BatchPayload;
  /** Publish many Content documents */
  publishManyContentsConnection: ContentConnection;
  /**
   * Publish many Footer documents
   * @deprecated Please use the new paginated many mutation (publishManyFootersConnection)
   */
  publishManyFooters: BatchPayload;
  /** Publish many Footer documents */
  publishManyFootersConnection: FooterConnection;
  /**
   * Publish many Form documents
   * @deprecated Please use the new paginated many mutation (publishManyFormsConnection)
   */
  publishManyForms: BatchPayload;
  /** Publish many Form documents */
  publishManyFormsConnection: FormConnection;
  /**
   * Publish many HeadingText documents
   * @deprecated Please use the new paginated many mutation (publishManyHeadingTextsConnection)
   */
  publishManyHeadingTexts: BatchPayload;
  /** Publish many HeadingText documents */
  publishManyHeadingTextsConnection: HeadingTextConnection;
  /**
   * Publish many Heading documents
   * @deprecated Please use the new paginated many mutation (publishManyHeadingsConnection)
   */
  publishManyHeadings: BatchPayload;
  /** Publish many Heading documents */
  publishManyHeadingsConnection: HeadingConnection;
  /**
   * Publish many LinkGroup documents
   * @deprecated Please use the new paginated many mutation (publishManyLinkGroupsConnection)
   */
  publishManyLinkGroups: BatchPayload;
  /** Publish many LinkGroup documents */
  publishManyLinkGroupsConnection: LinkGroupConnection;
  /**
   * Publish many Link documents
   * @deprecated Please use the new paginated many mutation (publishManyLinksConnection)
   */
  publishManyLinks: BatchPayload;
  /** Publish many Link documents */
  publishManyLinksConnection: LinkConnection;
  /**
   * Publish many Media documents
   * @deprecated Please use the new paginated many mutation (publishManyMediasConnection)
   */
  publishManyMedias: BatchPayload;
  /** Publish many Media documents */
  publishManyMediasConnection: MediaConnection;
  /**
   * Publish many Navigation documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationsConnection)
   */
  publishManyNavigations: BatchPayload;
  /** Publish many Navigation documents */
  publishManyNavigationsConnection: NavigationConnection;
  /**
   * Publish many Page documents
   * @deprecated Please use the new paginated many mutation (publishManyPagesConnection)
   */
  publishManyPages: BatchPayload;
  /** Publish many Page documents */
  publishManyPagesConnection: PageConnection;
  /**
   * Publish many Place documents
   * @deprecated Please use the new paginated many mutation (publishManyPlacesConnection)
   */
  publishManyPlaces: BatchPayload;
  /** Publish many Place documents */
  publishManyPlacesConnection: PlaceConnection;
  /**
   * Publish many Prop documents
   * @deprecated Please use the new paginated many mutation (publishManyPropsConnection)
   */
  publishManyProps: BatchPayload;
  /** Publish many Prop documents */
  publishManyPropsConnection: PropConnection;
  /**
   * Publish many QuestionGroup documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionGroupsConnection)
   */
  publishManyQuestionGroups: BatchPayload;
  /** Publish many QuestionGroup documents */
  publishManyQuestionGroupsConnection: QuestionGroupConnection;
  /**
   * Publish many Question documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionsConnection)
   */
  publishManyQuestions: BatchPayload;
  /** Publish many Question documents */
  publishManyQuestionsConnection: QuestionConnection;
  /**
   * Publish many Section documents
   * @deprecated Please use the new paginated many mutation (publishManySectionsConnection)
   */
  publishManySections: BatchPayload;
  /** Publish many Section documents */
  publishManySectionsConnection: SectionConnection;
  /**
   * Publish many Seo documents
   * @deprecated Please use the new paginated many mutation (publishManySeosConnection)
   */
  publishManySeos: BatchPayload;
  /** Publish many Seo documents */
  publishManySeosConnection: SeoConnection;
  /**
   * Publish many Story documents
   * @deprecated Please use the new paginated many mutation (publishManyStoriesConnection)
   */
  publishManyStories: BatchPayload;
  /** Publish many Story documents */
  publishManyStoriesConnection: StoryConnection;
  /**
   * Publish many TextSection documents
   * @deprecated Please use the new paginated many mutation (publishManyTextSectionsConnection)
   */
  publishManyTextSections: BatchPayload;
  /** Publish many TextSection documents */
  publishManyTextSectionsConnection: TextSectionConnection;
  /**
   * Publish many Text documents
   * @deprecated Please use the new paginated many mutation (publishManyTextsConnection)
   */
  publishManyTexts: BatchPayload;
  /** Publish many Text documents */
  publishManyTextsConnection: TextConnection;
  /**
   * Publish many Video documents
   * @deprecated Please use the new paginated many mutation (publishManyVideosConnection)
   */
  publishManyVideos: BatchPayload;
  /** Publish many Video documents */
  publishManyVideosConnection: VideoConnection;
  /** Publish one media */
  publishMedia?: Maybe<Media>;
  /** Publish one navigation */
  publishNavigation?: Maybe<Navigation>;
  /** Publish one page */
  publishPage?: Maybe<Page>;
  /** Publish one place */
  publishPlace?: Maybe<Place>;
  /** Publish one prop */
  publishProp?: Maybe<Prop>;
  /** Publish one question */
  publishQuestion?: Maybe<Question>;
  /** Publish one questionGroup */
  publishQuestionGroup?: Maybe<QuestionGroup>;
  /** Publish one section */
  publishSection?: Maybe<Section>;
  /** Publish one seo */
  publishSeo?: Maybe<Seo>;
  /** Publish one story */
  publishStory?: Maybe<Story>;
  /** Publish one text */
  publishText?: Maybe<Text>;
  /** Publish one textSection */
  publishTextSection?: Maybe<TextSection>;
  /** Publish one video */
  publishVideo?: Maybe<Video>;
  resetPassword: Scalars['Boolean'];
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one content */
  schedulePublishContent?: Maybe<Content>;
  /** Schedule to publish one footer */
  schedulePublishFooter?: Maybe<Footer>;
  /** Schedule to publish one form */
  schedulePublishForm?: Maybe<Form>;
  /** Schedule to publish one heading */
  schedulePublishHeading?: Maybe<Heading>;
  /** Schedule to publish one headingText */
  schedulePublishHeadingText?: Maybe<HeadingText>;
  /** Schedule to publish one link */
  schedulePublishLink?: Maybe<Link>;
  /** Schedule to publish one linkGroup */
  schedulePublishLinkGroup?: Maybe<LinkGroup>;
  /** Schedule to publish one media */
  schedulePublishMedia?: Maybe<Media>;
  /** Schedule to publish one navigation */
  schedulePublishNavigation?: Maybe<Navigation>;
  /** Schedule to publish one page */
  schedulePublishPage?: Maybe<Page>;
  /** Schedule to publish one place */
  schedulePublishPlace?: Maybe<Place>;
  /** Schedule to publish one prop */
  schedulePublishProp?: Maybe<Prop>;
  /** Schedule to publish one question */
  schedulePublishQuestion?: Maybe<Question>;
  /** Schedule to publish one questionGroup */
  schedulePublishQuestionGroup?: Maybe<QuestionGroup>;
  /** Schedule to publish one section */
  schedulePublishSection?: Maybe<Section>;
  /** Schedule to publish one seo */
  schedulePublishSeo?: Maybe<Seo>;
  /** Schedule to publish one story */
  schedulePublishStory?: Maybe<Story>;
  /** Schedule to publish one text */
  schedulePublishText?: Maybe<Text>;
  /** Schedule to publish one textSection */
  schedulePublishTextSection?: Maybe<TextSection>;
  /** Schedule to publish one video */
  schedulePublishVideo?: Maybe<Video>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one content from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContent?: Maybe<Content>;
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooter?: Maybe<Footer>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishForm?: Maybe<Form>;
  /** Unpublish one heading from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeading?: Maybe<Heading>;
  /** Unpublish one headingText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeadingText?: Maybe<HeadingText>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLink?: Maybe<Link>;
  /** Unpublish one linkGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLinkGroup?: Maybe<LinkGroup>;
  /** Unpublish one media from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMedia?: Maybe<Media>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one page from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPage?: Maybe<Page>;
  /** Unpublish one place from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPlace?: Maybe<Place>;
  /** Unpublish one prop from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProp?: Maybe<Prop>;
  /** Unpublish one question from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestion?: Maybe<Question>;
  /** Unpublish one questionGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestionGroup?: Maybe<QuestionGroup>;
  /** Unpublish one section from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSection?: Maybe<Section>;
  /** Unpublish one seo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSeo?: Maybe<Seo>;
  /** Unpublish one story from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishStory?: Maybe<Story>;
  /** Unpublish one text from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishText?: Maybe<Text>;
  /** Unpublish one textSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTextSection?: Maybe<TextSection>;
  /** Unpublish one video from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishVideo?: Maybe<Video>;
  shortlistProject: Project;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one content from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContent?: Maybe<Content>;
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooter?: Maybe<Footer>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishForm?: Maybe<Form>;
  /** Unpublish one heading from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeading?: Maybe<Heading>;
  /** Unpublish one headingText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeadingText?: Maybe<HeadingText>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLink?: Maybe<Link>;
  /** Unpublish one linkGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLinkGroup?: Maybe<LinkGroup>;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many Content documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentsConnection)
   */
  unpublishManyContents: BatchPayload;
  /** Find many Content documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentsConnection: ContentConnection;
  /**
   * Unpublish many Footer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFootersConnection)
   */
  unpublishManyFooters: BatchPayload;
  /** Find many Footer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFootersConnection: FooterConnection;
  /**
   * Unpublish many Form documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormsConnection)
   */
  unpublishManyForms: BatchPayload;
  /** Find many Form documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormsConnection: FormConnection;
  /**
   * Unpublish many HeadingText documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeadingTextsConnection)
   */
  unpublishManyHeadingTexts: BatchPayload;
  /** Find many HeadingText documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeadingTextsConnection: HeadingTextConnection;
  /**
   * Unpublish many Heading documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeadingsConnection)
   */
  unpublishManyHeadings: BatchPayload;
  /** Find many Heading documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeadingsConnection: HeadingConnection;
  /**
   * Unpublish many LinkGroup documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLinkGroupsConnection)
   */
  unpublishManyLinkGroups: BatchPayload;
  /** Find many LinkGroup documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLinkGroupsConnection: LinkGroupConnection;
  /**
   * Unpublish many Link documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLinksConnection)
   */
  unpublishManyLinks: BatchPayload;
  /** Find many Link documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLinksConnection: LinkConnection;
  /**
   * Unpublish many Media documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMediasConnection)
   */
  unpublishManyMedias: BatchPayload;
  /** Find many Media documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMediasConnection: MediaConnection;
  /**
   * Unpublish many Navigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationsConnection)
   */
  unpublishManyNavigations: BatchPayload;
  /** Find many Navigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationsConnection: NavigationConnection;
  /**
   * Unpublish many Page documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPagesConnection)
   */
  unpublishManyPages: BatchPayload;
  /** Find many Page documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPagesConnection: PageConnection;
  /**
   * Unpublish many Place documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPlacesConnection)
   */
  unpublishManyPlaces: BatchPayload;
  /** Find many Place documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPlacesConnection: PlaceConnection;
  /**
   * Unpublish many Prop documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPropsConnection)
   */
  unpublishManyProps: BatchPayload;
  /** Find many Prop documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPropsConnection: PropConnection;
  /**
   * Unpublish many QuestionGroup documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionGroupsConnection)
   */
  unpublishManyQuestionGroups: BatchPayload;
  /** Find many QuestionGroup documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionGroupsConnection: QuestionGroupConnection;
  /**
   * Unpublish many Question documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionsConnection)
   */
  unpublishManyQuestions: BatchPayload;
  /** Find many Question documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionsConnection: QuestionConnection;
  /**
   * Unpublish many Section documents
   * @deprecated Please use the new paginated many mutation (unpublishManySectionsConnection)
   */
  unpublishManySections: BatchPayload;
  /** Find many Section documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySectionsConnection: SectionConnection;
  /**
   * Unpublish many Seo documents
   * @deprecated Please use the new paginated many mutation (unpublishManySeosConnection)
   */
  unpublishManySeos: BatchPayload;
  /** Find many Seo documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySeosConnection: SeoConnection;
  /**
   * Unpublish many Story documents
   * @deprecated Please use the new paginated many mutation (unpublishManyStoriesConnection)
   */
  unpublishManyStories: BatchPayload;
  /** Find many Story documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyStoriesConnection: StoryConnection;
  /**
   * Unpublish many TextSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTextSectionsConnection)
   */
  unpublishManyTextSections: BatchPayload;
  /** Find many TextSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTextSectionsConnection: TextSectionConnection;
  /**
   * Unpublish many Text documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTextsConnection)
   */
  unpublishManyTexts: BatchPayload;
  /** Find many Text documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTextsConnection: TextConnection;
  /**
   * Unpublish many Video documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideosConnection)
   */
  unpublishManyVideos: BatchPayload;
  /** Find many Video documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideosConnection: VideoConnection;
  /** Unpublish one media from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMedia?: Maybe<Media>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one page from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPage?: Maybe<Page>;
  /** Unpublish one place from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPlace?: Maybe<Place>;
  /** Unpublish one prop from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProp?: Maybe<Prop>;
  /** Unpublish one question from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestion?: Maybe<Question>;
  /** Unpublish one questionGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestionGroup?: Maybe<QuestionGroup>;
  /** Unpublish one section from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSection?: Maybe<Section>;
  /** Unpublish one seo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSeo?: Maybe<Seo>;
  /** Unpublish one story from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishStory?: Maybe<Story>;
  /** Unpublish one text from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishText?: Maybe<Text>;
  /** Unpublish one textSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTextSection?: Maybe<TextSection>;
  /** Unpublish one video from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishVideo?: Maybe<Video>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  updateCategory: MapLayerCategory;
  /** Update one content */
  updateContent?: Maybe<Content>;
  /** Update one footer */
  updateFooter?: Maybe<Footer>;
  /** Update one form */
  updateForm?: Maybe<Form>;
  /** Update one heading */
  updateHeading?: Maybe<Heading>;
  /** Update one headingText */
  updateHeadingText?: Maybe<HeadingText>;
  updateLayer: Layer;
  /** Update one link */
  updateLink?: Maybe<Link>;
  /** Update one linkGroup */
  updateLinkGroup?: Maybe<LinkGroup>;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many contents
   * @deprecated Please use the new paginated many mutation (updateManyContentsConnection)
   */
  updateManyContents: BatchPayload;
  /** Update many Content documents */
  updateManyContentsConnection: ContentConnection;
  /**
   * Update many footers
   * @deprecated Please use the new paginated many mutation (updateManyFootersConnection)
   */
  updateManyFooters: BatchPayload;
  /** Update many Footer documents */
  updateManyFootersConnection: FooterConnection;
  /**
   * Update many forms
   * @deprecated Please use the new paginated many mutation (updateManyFormsConnection)
   */
  updateManyForms: BatchPayload;
  /** Update many Form documents */
  updateManyFormsConnection: FormConnection;
  /**
   * Update many headingTexts
   * @deprecated Please use the new paginated many mutation (updateManyHeadingTextsConnection)
   */
  updateManyHeadingTexts: BatchPayload;
  /** Update many HeadingText documents */
  updateManyHeadingTextsConnection: HeadingTextConnection;
  /**
   * Update many headings
   * @deprecated Please use the new paginated many mutation (updateManyHeadingsConnection)
   */
  updateManyHeadings: BatchPayload;
  /** Update many Heading documents */
  updateManyHeadingsConnection: HeadingConnection;
  /**
   * Update many linkGroups
   * @deprecated Please use the new paginated many mutation (updateManyLinkGroupsConnection)
   */
  updateManyLinkGroups: BatchPayload;
  /** Update many LinkGroup documents */
  updateManyLinkGroupsConnection: LinkGroupConnection;
  /**
   * Update many links
   * @deprecated Please use the new paginated many mutation (updateManyLinksConnection)
   */
  updateManyLinks: BatchPayload;
  /** Update many Link documents */
  updateManyLinksConnection: LinkConnection;
  /**
   * Update many medias
   * @deprecated Please use the new paginated many mutation (updateManyMediasConnection)
   */
  updateManyMedias: BatchPayload;
  /** Update many Media documents */
  updateManyMediasConnection: MediaConnection;
  /**
   * Update many navigations
   * @deprecated Please use the new paginated many mutation (updateManyNavigationsConnection)
   */
  updateManyNavigations: BatchPayload;
  /** Update many Navigation documents */
  updateManyNavigationsConnection: NavigationConnection;
  /**
   * Update many pages
   * @deprecated Please use the new paginated many mutation (updateManyPagesConnection)
   */
  updateManyPages: BatchPayload;
  /** Update many Page documents */
  updateManyPagesConnection: PageConnection;
  /**
   * Update many places
   * @deprecated Please use the new paginated many mutation (updateManyPlacesConnection)
   */
  updateManyPlaces: BatchPayload;
  /** Update many Place documents */
  updateManyPlacesConnection: PlaceConnection;
  /**
   * Update many props
   * @deprecated Please use the new paginated many mutation (updateManyPropsConnection)
   */
  updateManyProps: BatchPayload;
  /** Update many Prop documents */
  updateManyPropsConnection: PropConnection;
  /**
   * Update many questionGroups
   * @deprecated Please use the new paginated many mutation (updateManyQuestionGroupsConnection)
   */
  updateManyQuestionGroups: BatchPayload;
  /** Update many QuestionGroup documents */
  updateManyQuestionGroupsConnection: QuestionGroupConnection;
  /**
   * Update many questions
   * @deprecated Please use the new paginated many mutation (updateManyQuestionsConnection)
   */
  updateManyQuestions: BatchPayload;
  /** Update many Question documents */
  updateManyQuestionsConnection: QuestionConnection;
  /**
   * Update many sections
   * @deprecated Please use the new paginated many mutation (updateManySectionsConnection)
   */
  updateManySections: BatchPayload;
  /** Update many Section documents */
  updateManySectionsConnection: SectionConnection;
  /**
   * Update many seos
   * @deprecated Please use the new paginated many mutation (updateManySeosConnection)
   */
  updateManySeos: BatchPayload;
  /** Update many Seo documents */
  updateManySeosConnection: SeoConnection;
  /**
   * Update many stories
   * @deprecated Please use the new paginated many mutation (updateManyStoriesConnection)
   */
  updateManyStories: BatchPayload;
  /** Update many Story documents */
  updateManyStoriesConnection: StoryConnection;
  /**
   * Update many textSections
   * @deprecated Please use the new paginated many mutation (updateManyTextSectionsConnection)
   */
  updateManyTextSections: BatchPayload;
  /** Update many TextSection documents */
  updateManyTextSectionsConnection: TextSectionConnection;
  /**
   * Update many texts
   * @deprecated Please use the new paginated many mutation (updateManyTextsConnection)
   */
  updateManyTexts: BatchPayload;
  /** Update many Text documents */
  updateManyTextsConnection: TextConnection;
  /**
   * Update many videos
   * @deprecated Please use the new paginated many mutation (updateManyVideosConnection)
   */
  updateManyVideos: BatchPayload;
  /** Update many Video documents */
  updateManyVideosConnection: VideoConnection;
  /** Update one media */
  updateMedia?: Maybe<Media>;
  /** Update one navigation */
  updateNavigation?: Maybe<Navigation>;
  /** Update one page */
  updatePage?: Maybe<Page>;
  updateParticipant: Participant;
  updatePassword: Scalars['Boolean'];
  /** Update one place */
  updatePlace?: Maybe<Place>;
  updateProjectImages: Project;
  /** Update one prop */
  updateProp?: Maybe<Prop>;
  /** Update one question */
  updateQuestion?: Maybe<Question>;
  /** Update one questionGroup */
  updateQuestionGroup?: Maybe<QuestionGroup>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one section */
  updateSection?: Maybe<Section>;
  /** Update one seo */
  updateSeo?: Maybe<Seo>;
  /** Update one story */
  updateStory?: Maybe<Story>;
  /** Update one text */
  updateText?: Maybe<Text>;
  /** Update one textSection */
  updateTextSection?: Maybe<TextSection>;
  /** Update one video */
  updateVideo?: Maybe<Video>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one content */
  upsertContent?: Maybe<Content>;
  /** Upsert one footer */
  upsertFooter?: Maybe<Footer>;
  /** Upsert one form */
  upsertForm?: Maybe<Form>;
  /** Upsert one heading */
  upsertHeading?: Maybe<Heading>;
  /** Upsert one headingText */
  upsertHeadingText?: Maybe<HeadingText>;
  /** Upsert one link */
  upsertLink?: Maybe<Link>;
  /** Upsert one linkGroup */
  upsertLinkGroup?: Maybe<LinkGroup>;
  /** Upsert one media */
  upsertMedia?: Maybe<Media>;
  /** Upsert one navigation */
  upsertNavigation?: Maybe<Navigation>;
  /** Upsert one page */
  upsertPage?: Maybe<Page>;
  /** Upsert one place */
  upsertPlace?: Maybe<Place>;
  /** Upsert one prop */
  upsertProp?: Maybe<Prop>;
  /** Upsert one question */
  upsertQuestion?: Maybe<Question>;
  /** Upsert one questionGroup */
  upsertQuestionGroup?: Maybe<QuestionGroup>;
  /** Upsert one section */
  upsertSection?: Maybe<Section>;
  /** Upsert one seo */
  upsertSeo?: Maybe<Seo>;
  /** Upsert one story */
  upsertStory?: Maybe<Story>;
  /** Upsert one text */
  upsertText?: Maybe<Text>;
  /** Upsert one textSection */
  upsertTextSection?: Maybe<TextSection>;
  /** Upsert one video */
  upsertVideo?: Maybe<Video>;
  vote: Scalars['Boolean'];
};


export type MutationActivateProjectArgs = {
  id: Scalars['String'];
  value: Scalars['Boolean'];
};


export type MutationAddLayerArgs = {
  data: CreateLayerInput;
};


export type MutationAddProjectArgs = {
  name: Scalars['String'];
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateContentArgs = {
  data: ContentCreateInput;
};


export type MutationCreateEnquiryArgs = {
  data: CreateEnquiryInput;
};


export type MutationCreateFooterArgs = {
  data: FooterCreateInput;
};


export type MutationCreateFormArgs = {
  data: FormCreateInput;
};


export type MutationCreateHeadingArgs = {
  data: HeadingCreateInput;
};


export type MutationCreateHeadingTextArgs = {
  data: HeadingTextCreateInput;
};


export type MutationCreateLinkArgs = {
  data: LinkCreateInput;
};


export type MutationCreateLinkGroupArgs = {
  data: LinkGroupCreateInput;
};


export type MutationCreateMediaArgs = {
  data: MediaCreateInput;
};


export type MutationCreateNavigationArgs = {
  data: NavigationCreateInput;
};


export type MutationCreatePageArgs = {
  data: PageCreateInput;
};


export type MutationCreatePlaceArgs = {
  data: PlaceCreateInput;
};


export type MutationCreatePropArgs = {
  data: PropCreateInput;
};


export type MutationCreateQuestionArgs = {
  data: QuestionCreateInput;
};


export type MutationCreateQuestionGroupArgs = {
  data: QuestionGroupCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateSectionArgs = {
  data: SectionCreateInput;
};


export type MutationCreateSeoArgs = {
  data: SeoCreateInput;
};


export type MutationCreateStoryArgs = {
  data: StoryCreateInput;
};


export type MutationCreateTextArgs = {
  data: TextCreateInput;
};


export type MutationCreateTextSectionArgs = {
  data: TextSectionCreateInput;
};


export type MutationCreateVideoArgs = {
  data: VideoCreateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteContentArgs = {
  where: ContentWhereUniqueInput;
};


export type MutationDeleteFooterArgs = {
  where: FooterWhereUniqueInput;
};


export type MutationDeleteFormArgs = {
  where: FormWhereUniqueInput;
};


export type MutationDeleteHeadingArgs = {
  where: HeadingWhereUniqueInput;
};


export type MutationDeleteHeadingTextArgs = {
  where: HeadingTextWhereUniqueInput;
};


export type MutationDeleteLayerArgs = {
  id: Scalars['ObjectId'];
  key: Scalars['String'];
};


export type MutationDeleteLinkArgs = {
  where: LinkWhereUniqueInput;
};


export type MutationDeleteLinkGroupArgs = {
  where: LinkGroupWhereUniqueInput;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyContentsArgs = {
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationDeleteManyContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationDeleteManyFootersArgs = {
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationDeleteManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationDeleteManyFormsArgs = {
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyHeadingTextsArgs = {
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationDeleteManyHeadingTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationDeleteManyHeadingsArgs = {
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationDeleteManyHeadingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationDeleteManyLinkGroupsArgs = {
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationDeleteManyLinkGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationDeleteManyLinksArgs = {
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyMediasArgs = {
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationDeleteManyMediasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationDeleteManyNavigationsArgs = {
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyPagesArgs = {
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationDeleteManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationDeleteManyPlacesArgs = {
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationDeleteManyPlacesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationDeleteManyPropsArgs = {
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationDeleteManyPropsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationDeleteManyQuestionGroupsArgs = {
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationDeleteManyQuestionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationDeleteManyQuestionsArgs = {
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationDeleteManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationDeleteManySectionsArgs = {
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationDeleteManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationDeleteManySeosArgs = {
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationDeleteManySeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationDeleteManyStoriesArgs = {
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationDeleteManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationDeleteManyTextSectionsArgs = {
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationDeleteManyTextSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationDeleteManyTextsArgs = {
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationDeleteManyTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationDeleteManyVideosArgs = {
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationDeleteManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationDeleteMediaArgs = {
  where: MediaWhereUniqueInput;
};


export type MutationDeleteNavigationArgs = {
  where: NavigationWhereUniqueInput;
};


export type MutationDeletePageArgs = {
  where: PageWhereUniqueInput;
};


export type MutationDeletePlaceArgs = {
  where: PlaceWhereUniqueInput;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['String'];
};


export type MutationDeletePropArgs = {
  where: PropWhereUniqueInput;
};


export type MutationDeleteQuestionArgs = {
  where: QuestionWhereUniqueInput;
};


export type MutationDeleteQuestionGroupArgs = {
  where: QuestionGroupWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteSectionArgs = {
  where: SectionWhereUniqueInput;
};


export type MutationDeleteSeoArgs = {
  where: SeoWhereUniqueInput;
};


export type MutationDeleteStoryArgs = {
  where: StoryWhereUniqueInput;
};


export type MutationDeleteTextArgs = {
  where: TextWhereUniqueInput;
};


export type MutationDeleteTextSectionArgs = {
  where: TextSectionWhereUniqueInput;
};


export type MutationDeleteVideoArgs = {
  where: VideoWhereUniqueInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: ContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishFooterArgs = {
  to?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationPublishFormArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishHeadingArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: HeadingWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishHeadingTextArgs = {
  to?: Array<Stage>;
  where: HeadingTextWhereUniqueInput;
};


export type MutationPublishLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishLinkGroupArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: LinkGroupWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyContentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyFootersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationPublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationPublishManyFormsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyHeadingTextsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationPublishManyHeadingTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationPublishManyHeadingsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeadingManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyHeadingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeadingManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyLinkGroupsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyLinkGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyLinksArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyMediasArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationPublishManyMediasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationPublishManyNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyPagesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPlacesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<PlaceManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPlacesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PlaceManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPropsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationPublishManyPropsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationPublishManyQuestionGroupsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationPublishManyQuestionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationPublishManyQuestionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManySectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationPublishManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationPublishManySeosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<SeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManySeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<SeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyStoriesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<StoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<StoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTextSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTextSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTextsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyVideosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishMediaArgs = {
  to?: Array<Stage>;
  where: MediaWhereUniqueInput;
};


export type MutationPublishNavigationArgs = {
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationPublishPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: PageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishPlaceArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: PlaceWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishPropArgs = {
  to?: Array<Stage>;
  where: PropWhereUniqueInput;
};


export type MutationPublishQuestionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: QuestionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishQuestionGroupArgs = {
  to?: Array<Stage>;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationPublishSectionArgs = {
  to?: Array<Stage>;
  where: SectionWhereUniqueInput;
};


export type MutationPublishSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: SeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishStoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: StoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: TextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishTextSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: TextSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishVideoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: VideoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: ContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishFooterArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationSchedulePublishFormArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishHeadingArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: HeadingWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishHeadingTextArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: HeadingTextWhereUniqueInput;
};


export type MutationSchedulePublishLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishLinkGroupArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: LinkGroupWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishMediaArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: MediaWhereUniqueInput;
};


export type MutationSchedulePublishNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationSchedulePublishPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishPlaceArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PlaceWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishPropArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PropWhereUniqueInput;
};


export type MutationSchedulePublishQuestionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: QuestionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishQuestionGroupArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationSchedulePublishSectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: SectionWhereUniqueInput;
};


export type MutationSchedulePublishSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: SeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishStoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: StoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: TextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishTextSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: TextSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishVideoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: VideoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: ContentWhereUniqueInput;
};


export type MutationScheduleUnpublishFooterArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: FooterWhereUniqueInput;
};


export type MutationScheduleUnpublishFormArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: FormWhereUniqueInput;
};


export type MutationScheduleUnpublishHeadingArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: HeadingWhereUniqueInput;
};


export type MutationScheduleUnpublishHeadingTextArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: HeadingTextWhereUniqueInput;
};


export type MutationScheduleUnpublishLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: LinkWhereUniqueInput;
};


export type MutationScheduleUnpublishLinkGroupArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: LinkGroupWhereUniqueInput;
};


export type MutationScheduleUnpublishMediaArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: MediaWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: NavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PageWhereUniqueInput;
};


export type MutationScheduleUnpublishPlaceArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PlaceWhereUniqueInput;
};


export type MutationScheduleUnpublishPropArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: PropWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: QuestionWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionGroupArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationScheduleUnpublishSectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: SectionWhereUniqueInput;
};


export type MutationScheduleUnpublishSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: SeoWhereUniqueInput;
};


export type MutationScheduleUnpublishStoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: StoryWhereUniqueInput;
};


export type MutationScheduleUnpublishTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TextWhereUniqueInput;
};


export type MutationScheduleUnpublishTextSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TextSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: VideoWhereUniqueInput;
};


export type MutationShortlistProjectArgs = {
  id: Scalars['String'];
  value: Scalars['Boolean'];
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: ContentWhereUniqueInput;
};


export type MutationUnpublishFooterArgs = {
  from?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationUnpublishFormArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: FormWhereUniqueInput;
};


export type MutationUnpublishHeadingArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: HeadingWhereUniqueInput;
};


export type MutationUnpublishHeadingTextArgs = {
  from?: Array<Stage>;
  where: HeadingTextWhereUniqueInput;
};


export type MutationUnpublishLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: LinkWhereUniqueInput;
};


export type MutationUnpublishLinkGroupArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: LinkGroupWhereUniqueInput;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyContentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationUnpublishManyContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationUnpublishManyFootersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUnpublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUnpublishManyFormsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyHeadingTextsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationUnpublishManyHeadingTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationUnpublishManyHeadingsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationUnpublishManyHeadingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationUnpublishManyLinkGroupsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationUnpublishManyLinkGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationUnpublishManyLinksArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyMediasArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationUnpublishManyMediasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationUnpublishManyNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyPagesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUnpublishManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUnpublishManyPlacesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationUnpublishManyPlacesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationUnpublishManyPropsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationUnpublishManyPropsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationUnpublishManyQuestionGroupsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationUnpublishManyQuestionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationUnpublishManyQuestionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUnpublishManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUnpublishManySectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUnpublishManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUnpublishManySeosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationUnpublishManySeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationUnpublishManyStoriesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUnpublishManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUnpublishManyTextSectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationUnpublishManyTextSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationUnpublishManyTextsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationUnpublishManyTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationUnpublishManyVideosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUnpublishManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUnpublishMediaArgs = {
  from?: Array<Stage>;
  where: MediaWhereUniqueInput;
};


export type MutationUnpublishNavigationArgs = {
  from?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationUnpublishPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PageWhereUniqueInput;
};


export type MutationUnpublishPlaceArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PlaceWhereUniqueInput;
};


export type MutationUnpublishPropArgs = {
  from?: Array<Stage>;
  where: PropWhereUniqueInput;
};


export type MutationUnpublishQuestionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: QuestionWhereUniqueInput;
};


export type MutationUnpublishQuestionGroupArgs = {
  from?: Array<Stage>;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationUnpublishSectionArgs = {
  from?: Array<Stage>;
  where: SectionWhereUniqueInput;
};


export type MutationUnpublishSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: SeoWhereUniqueInput;
};


export type MutationUnpublishStoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: StoryWhereUniqueInput;
};


export type MutationUnpublishTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TextWhereUniqueInput;
};


export type MutationUnpublishTextSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TextSectionWhereUniqueInput;
};


export type MutationUnpublishVideoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: VideoWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: UpdateCategoryInput;
  id: Scalars['ObjectId'];
};


export type MutationUpdateContentArgs = {
  data: ContentUpdateInput;
  where: ContentWhereUniqueInput;
};


export type MutationUpdateFooterArgs = {
  data: FooterUpdateInput;
  where: FooterWhereUniqueInput;
};


export type MutationUpdateFormArgs = {
  data: FormUpdateInput;
  where: FormWhereUniqueInput;
};


export type MutationUpdateHeadingArgs = {
  data: HeadingUpdateInput;
  where: HeadingWhereUniqueInput;
};


export type MutationUpdateHeadingTextArgs = {
  data: HeadingTextUpdateInput;
  where: HeadingTextWhereUniqueInput;
};


export type MutationUpdateLayerArgs = {
  data: CreateLayerInput;
  id: Scalars['ObjectId'];
};


export type MutationUpdateLinkArgs = {
  data: LinkUpdateInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpdateLinkGroupArgs = {
  data: LinkGroupUpdateInput;
  where: LinkGroupWhereUniqueInput;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyContentsArgs = {
  data: ContentUpdateManyInput;
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationUpdateManyContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: ContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentManyWhereInput>;
};


export type MutationUpdateManyFootersArgs = {
  data: FooterUpdateManyInput;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUpdateManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUpdateManyFormsArgs = {
  data: FormUpdateManyInput;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyHeadingTextsArgs = {
  data: HeadingTextUpdateManyInput;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationUpdateManyHeadingTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: HeadingTextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeadingTextManyWhereInput>;
};


export type MutationUpdateManyHeadingsArgs = {
  data: HeadingUpdateManyInput;
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationUpdateManyHeadingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: HeadingUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeadingManyWhereInput>;
};


export type MutationUpdateManyLinkGroupsArgs = {
  data: LinkGroupUpdateManyInput;
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationUpdateManyLinkGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: LinkGroupUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkGroupManyWhereInput>;
};


export type MutationUpdateManyLinksArgs = {
  data: LinkUpdateManyInput;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: LinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyMediasArgs = {
  data: MediaUpdateManyInput;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationUpdateManyMediasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: MediaUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaManyWhereInput>;
};


export type MutationUpdateManyNavigationsArgs = {
  data: NavigationUpdateManyInput;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: NavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyPagesArgs = {
  data: PageUpdateManyInput;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUpdateManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUpdateManyPlacesArgs = {
  data: PlaceUpdateManyInput;
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationUpdateManyPlacesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PlaceUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaceManyWhereInput>;
};


export type MutationUpdateManyPropsArgs = {
  data: PropUpdateManyInput;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationUpdateManyPropsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PropUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PropManyWhereInput>;
};


export type MutationUpdateManyQuestionGroupsArgs = {
  data: QuestionGroupUpdateManyInput;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationUpdateManyQuestionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: QuestionGroupUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionGroupManyWhereInput>;
};


export type MutationUpdateManyQuestionsArgs = {
  data: QuestionUpdateManyInput;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUpdateManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: QuestionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUpdateManySectionsArgs = {
  data: SectionUpdateManyInput;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUpdateManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: SectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUpdateManySeosArgs = {
  data: SeoUpdateManyInput;
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationUpdateManySeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: SeoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoManyWhereInput>;
};


export type MutationUpdateManyStoriesArgs = {
  data: StoryUpdateManyInput;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUpdateManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: StoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUpdateManyTextSectionsArgs = {
  data: TextSectionUpdateManyInput;
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationUpdateManyTextSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: TextSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextSectionManyWhereInput>;
};


export type MutationUpdateManyTextsArgs = {
  data: TextUpdateManyInput;
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationUpdateManyTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: TextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextManyWhereInput>;
};


export type MutationUpdateManyVideosArgs = {
  data: VideoUpdateManyInput;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUpdateManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: VideoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUpdateMediaArgs = {
  data: MediaUpdateInput;
  where: MediaWhereUniqueInput;
};


export type MutationUpdateNavigationArgs = {
  data: NavigationUpdateInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpdatePageArgs = {
  data: PageUpdateInput;
  where: PageWhereUniqueInput;
};


export type MutationUpdateParticipantArgs = {
  data: UpdateParticipantInput;
};


export type MutationUpdatePasswordArgs = {
  data: UpdatePasswordInput;
};


export type MutationUpdatePlaceArgs = {
  data: PlaceUpdateInput;
  where: PlaceWhereUniqueInput;
};


export type MutationUpdateProjectImagesArgs = {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdatePropArgs = {
  data: PropUpdateInput;
  where: PropWhereUniqueInput;
};


export type MutationUpdateQuestionArgs = {
  data: QuestionUpdateInput;
  where: QuestionWhereUniqueInput;
};


export type MutationUpdateQuestionGroupArgs = {
  data: QuestionGroupUpdateInput;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateSectionArgs = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpdateSeoArgs = {
  data: SeoUpdateInput;
  where: SeoWhereUniqueInput;
};


export type MutationUpdateStoryArgs = {
  data: StoryUpdateInput;
  where: StoryWhereUniqueInput;
};


export type MutationUpdateTextArgs = {
  data: TextUpdateInput;
  where: TextWhereUniqueInput;
};


export type MutationUpdateTextSectionArgs = {
  data: TextSectionUpdateInput;
  where: TextSectionWhereUniqueInput;
};


export type MutationUpdateVideoArgs = {
  data: VideoUpdateInput;
  where: VideoWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertContentArgs = {
  upsert: ContentUpsertInput;
  where: ContentWhereUniqueInput;
};


export type MutationUpsertFooterArgs = {
  upsert: FooterUpsertInput;
  where: FooterWhereUniqueInput;
};


export type MutationUpsertFormArgs = {
  upsert: FormUpsertInput;
  where: FormWhereUniqueInput;
};


export type MutationUpsertHeadingArgs = {
  upsert: HeadingUpsertInput;
  where: HeadingWhereUniqueInput;
};


export type MutationUpsertHeadingTextArgs = {
  upsert: HeadingTextUpsertInput;
  where: HeadingTextWhereUniqueInput;
};


export type MutationUpsertLinkArgs = {
  upsert: LinkUpsertInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpsertLinkGroupArgs = {
  upsert: LinkGroupUpsertInput;
  where: LinkGroupWhereUniqueInput;
};


export type MutationUpsertMediaArgs = {
  upsert: MediaUpsertInput;
  where: MediaWhereUniqueInput;
};


export type MutationUpsertNavigationArgs = {
  upsert: NavigationUpsertInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpsertPageArgs = {
  upsert: PageUpsertInput;
  where: PageWhereUniqueInput;
};


export type MutationUpsertPlaceArgs = {
  upsert: PlaceUpsertInput;
  where: PlaceWhereUniqueInput;
};


export type MutationUpsertPropArgs = {
  upsert: PropUpsertInput;
  where: PropWhereUniqueInput;
};


export type MutationUpsertQuestionArgs = {
  upsert: QuestionUpsertInput;
  where: QuestionWhereUniqueInput;
};


export type MutationUpsertQuestionGroupArgs = {
  upsert: QuestionGroupUpsertInput;
  where: QuestionGroupWhereUniqueInput;
};


export type MutationUpsertSectionArgs = {
  upsert: SectionUpsertInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpsertSeoArgs = {
  upsert: SeoUpsertInput;
  where: SeoWhereUniqueInput;
};


export type MutationUpsertStoryArgs = {
  upsert: StoryUpsertInput;
  where: StoryWhereUniqueInput;
};


export type MutationUpsertTextArgs = {
  upsert: TextUpsertInput;
  where: TextWhereUniqueInput;
};


export type MutationUpsertTextSectionArgs = {
  upsert: TextSectionUpsertInput;
  where: TextSectionWhereUniqueInput;
};


export type MutationUpsertVideoArgs = {
  upsert: VideoUpsertInput;
  where: VideoWhereUniqueInput;
};


export type MutationVoteArgs = {
  id: Scalars['String'];
};

export type Navigation = Entity & Node & {
  __typename?: 'Navigation';
  component?: Maybe<NavigationComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Navigation>;
  /** List of Navigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  links: Array<Link>;
  oldComponent?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type NavigationHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type NavigationLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type NavigationPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type NavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum NavigationComponent {
  Internal = 'Internal'
}

export type NavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationConnection = {
  __typename?: 'NavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationCreateInput = {
  component?: InputMaybe<NavigationComponent>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  oldComponent?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type NavigationCreateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Create and connect multiple existing Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
};

export type NavigationCreateOneInlineInput = {
  /** Connect one existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
};

/** An edge in a connection. */
export type NavigationEdge = {
  __typename?: 'NavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Navigation;
};

/** Identifies documents */
export type NavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  component?: InputMaybe<NavigationComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<NavigationComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<NavigationComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<NavigationComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  oldComponent?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  oldComponent_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  oldComponent_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  oldComponent_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  oldComponent_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  oldComponent_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  oldComponent_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  oldComponent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  oldComponent_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  oldComponent_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NavigationOrderByInput {
  ComponentAsc = 'component_ASC',
  ComponentDesc = 'component_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OldComponentAsc = 'oldComponent_ASC',
  OldComponentDesc = 'oldComponent_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type NavigationUpdateInput = {
  component?: InputMaybe<NavigationComponent>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  oldComponent?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NavigationUpdateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationConnectInput>>;
  /** Create and connect multiple Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
  /** Delete multiple Navigation documents */
  delete?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Disconnect multiple Navigation documents */
  disconnect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Navigation documents */
  set?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Update multiple Navigation documents */
  update?: InputMaybe<Array<NavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Navigation documents */
  upsert?: InputMaybe<Array<NavigationUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationUpdateManyInput = {
  component?: InputMaybe<NavigationComponent>;
  oldComponent?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationUpdateManyInput;
  /** Document search */
  where: NavigationWhereInput;
};

export type NavigationUpdateOneInlineInput = {
  /** Connect existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
  /** Delete currently connected Navigation document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Navigation document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Navigation document */
  update?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Navigation document */
  upsert?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
};

export type NavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationUpdateInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

export type NavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationCreateInput;
  /** Update document if it exists */
  update: NavigationUpdateInput;
};

export type NavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationUpsertInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type NavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  component?: InputMaybe<NavigationComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<NavigationComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<NavigationComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<NavigationComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  oldComponent?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  oldComponent_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  oldComponent_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  oldComponent_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  oldComponent_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  oldComponent_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  oldComponent_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  oldComponent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  oldComponent_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  oldComponent_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Navigation record uniquely */
export type NavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

export type Overview = {
  __typename?: 'Overview';
  apc?: Maybe<Scalars['Float']>;
  tpc?: Maybe<Scalars['Float']>;
};

export type Page = Entity & Node & {
  __typename?: 'Page';
  blocks: Array<PageBlocks>;
  category?: Maybe<PageCategory>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Page>;
  /** List of Page versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Used for projects */
  image?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Page>;
  place?: Maybe<Place>;
  projectHasUnits?: Maybe<Scalars['Boolean']>;
  projectState?: Maybe<ProjectState>;
  projectUnitsSold?: Maybe<Scalars['Int']>;
  projectUnitsTotal?: Maybe<Scalars['Int']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  route: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  /** System stage field */
  stage: Stage;
  stories: Array<PageStories>;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageBlocksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PageHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type PagePlaceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageBlocks = Form | Heading | Media | Navigation | Section | TextSection | Video;

export type PageBlocksConnectInput = {
  Form?: InputMaybe<FormConnectInput>;
  Heading?: InputMaybe<HeadingConnectInput>;
  Media?: InputMaybe<MediaConnectInput>;
  Navigation?: InputMaybe<NavigationConnectInput>;
  Section?: InputMaybe<SectionConnectInput>;
  TextSection?: InputMaybe<TextSectionConnectInput>;
  Video?: InputMaybe<VideoConnectInput>;
};

export type PageBlocksCreateInput = {
  Form?: InputMaybe<FormCreateInput>;
  Heading?: InputMaybe<HeadingCreateInput>;
  Media?: InputMaybe<MediaCreateInput>;
  Navigation?: InputMaybe<NavigationCreateInput>;
  Section?: InputMaybe<SectionCreateInput>;
  TextSection?: InputMaybe<TextSectionCreateInput>;
  Video?: InputMaybe<VideoCreateInput>;
};

export type PageBlocksCreateManyInlineInput = {
  /** Connect multiple existing PageBlocks documents */
  connect?: InputMaybe<Array<PageBlocksWhereUniqueInput>>;
  /** Create and connect multiple existing PageBlocks documents */
  create?: InputMaybe<Array<PageBlocksCreateInput>>;
};

export type PageBlocksCreateOneInlineInput = {
  /** Connect one existing PageBlocks document */
  connect?: InputMaybe<PageBlocksWhereUniqueInput>;
  /** Create and connect one PageBlocks document */
  create?: InputMaybe<PageBlocksCreateInput>;
};

export type PageBlocksUpdateInput = {
  Form?: InputMaybe<FormUpdateInput>;
  Heading?: InputMaybe<HeadingUpdateInput>;
  Media?: InputMaybe<MediaUpdateInput>;
  Navigation?: InputMaybe<NavigationUpdateInput>;
  Section?: InputMaybe<SectionUpdateInput>;
  TextSection?: InputMaybe<TextSectionUpdateInput>;
  Video?: InputMaybe<VideoUpdateInput>;
};

export type PageBlocksUpdateManyInlineInput = {
  /** Connect multiple existing PageBlocks documents */
  connect?: InputMaybe<Array<PageBlocksConnectInput>>;
  /** Create and connect multiple PageBlocks documents */
  create?: InputMaybe<Array<PageBlocksCreateInput>>;
  /** Delete multiple PageBlocks documents */
  delete?: InputMaybe<Array<PageBlocksWhereUniqueInput>>;
  /** Disconnect multiple PageBlocks documents */
  disconnect?: InputMaybe<Array<PageBlocksWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageBlocks documents */
  set?: InputMaybe<Array<PageBlocksWhereUniqueInput>>;
  /** Update multiple PageBlocks documents */
  update?: InputMaybe<Array<PageBlocksUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageBlocks documents */
  upsert?: InputMaybe<Array<PageBlocksUpsertWithNestedWhereUniqueInput>>;
};

export type PageBlocksUpdateManyWithNestedWhereInput = {
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  Heading?: InputMaybe<HeadingUpdateManyWithNestedWhereInput>;
  Media?: InputMaybe<MediaUpdateManyWithNestedWhereInput>;
  Navigation?: InputMaybe<NavigationUpdateManyWithNestedWhereInput>;
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
  TextSection?: InputMaybe<TextSectionUpdateManyWithNestedWhereInput>;
  Video?: InputMaybe<VideoUpdateManyWithNestedWhereInput>;
};

export type PageBlocksUpdateOneInlineInput = {
  /** Connect existing PageBlocks document */
  connect?: InputMaybe<PageBlocksWhereUniqueInput>;
  /** Create and connect one PageBlocks document */
  create?: InputMaybe<PageBlocksCreateInput>;
  /** Delete currently connected PageBlocks document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected PageBlocks document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single PageBlocks document */
  update?: InputMaybe<PageBlocksUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageBlocks document */
  upsert?: InputMaybe<PageBlocksUpsertWithNestedWhereUniqueInput>;
};

export type PageBlocksUpdateWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  Heading?: InputMaybe<HeadingUpdateWithNestedWhereUniqueInput>;
  Media?: InputMaybe<MediaUpdateWithNestedWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionUpdateWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
};

export type PageBlocksUpsertWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  Heading?: InputMaybe<HeadingUpsertWithNestedWhereUniqueInput>;
  Media?: InputMaybe<MediaUpsertWithNestedWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionUpsertWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type PageBlocksWhereInput = {
  Form?: InputMaybe<FormWhereInput>;
  Heading?: InputMaybe<HeadingWhereInput>;
  Media?: InputMaybe<MediaWhereInput>;
  Navigation?: InputMaybe<NavigationWhereInput>;
  Section?: InputMaybe<SectionWhereInput>;
  TextSection?: InputMaybe<TextSectionWhereInput>;
  Video?: InputMaybe<VideoWhereInput>;
};

export type PageBlocksWhereUniqueInput = {
  Form?: InputMaybe<FormWhereUniqueInput>;
  Heading?: InputMaybe<HeadingWhereUniqueInput>;
  Media?: InputMaybe<MediaWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationWhereUniqueInput>;
  Section?: InputMaybe<SectionWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionWhereUniqueInput>;
  Video?: InputMaybe<VideoWhereUniqueInput>;
};

export enum PageCategory {
  Article = 'ARTICLE',
  Main = 'MAIN',
  Project = 'PROJECT'
}

export type PageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageConnection = {
  __typename?: 'PageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageCreateInput = {
  blocks?: InputMaybe<PageBlocksCreateManyInlineInput>;
  category?: InputMaybe<PageCategory>;
  ckxk28vg73hbd01z06j9y2o62?: InputMaybe<LinkCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PageCreateLocalizationsInput>;
  place?: InputMaybe<PlaceCreateOneInlineInput>;
  projectHasUnits?: InputMaybe<Scalars['Boolean']>;
  projectState?: InputMaybe<ProjectState>;
  projectUnitsSold?: InputMaybe<Scalars['Int']>;
  projectUnitsTotal?: InputMaybe<Scalars['Int']>;
  /** route input for default locale (en) */
  route: Scalars['String'];
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  slug: Scalars['String'];
  stories?: InputMaybe<PageStoriesCreateManyInlineInput>;
  /** title input for default locale (en) */
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  route: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PageCreateLocalizationInput = {
  /** Localization input */
  data: PageCreateLocalizationDataInput;
  locale: Locale;
};

export type PageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PageCreateLocalizationInput>>;
};

export type PageCreateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Create and connect multiple existing Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
};

export type PageCreateOneInlineInput = {
  /** Connect one existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Page;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Identifies documents */
export type PageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  /** All values in which the union is empty */
  blocks_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  blocks_some?: InputMaybe<PageBlocksWhereInput>;
  category?: InputMaybe<PageCategory>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<PageCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<PageCategory>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<PageCategory>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  place?: InputMaybe<PlaceWhereInput>;
  projectHasUnits?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  projectHasUnits_not?: InputMaybe<Scalars['Boolean']>;
  projectState?: InputMaybe<ProjectState>;
  /** All values that are contained in given list. */
  projectState_in?: InputMaybe<Array<InputMaybe<ProjectState>>>;
  /** Any other value that exists and is not equal to the given value. */
  projectState_not?: InputMaybe<ProjectState>;
  /** All values that are not contained in given list. */
  projectState_not_in?: InputMaybe<Array<InputMaybe<ProjectState>>>;
  projectUnitsSold?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  projectUnitsSold_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  projectUnitsSold_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  projectUnitsSold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  projectUnitsSold_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  projectUnitsSold_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  projectUnitsSold_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  projectUnitsSold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  projectUnitsTotal?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  projectUnitsTotal_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  projectUnitsTotal_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  projectUnitsTotal_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  projectUnitsTotal_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  projectUnitsTotal_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  projectUnitsTotal_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  projectUnitsTotal_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  /** All values in which the union is empty */
  stories_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  stories_some?: InputMaybe<PageStoriesWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageOrderByInput {
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectHasUnitsAsc = 'projectHasUnits_ASC',
  ProjectHasUnitsDesc = 'projectHasUnits_DESC',
  ProjectStateAsc = 'projectState_ASC',
  ProjectStateDesc = 'projectState_DESC',
  ProjectUnitsSoldAsc = 'projectUnitsSold_ASC',
  ProjectUnitsSoldDesc = 'projectUnitsSold_DESC',
  ProjectUnitsTotalAsc = 'projectUnitsTotal_ASC',
  ProjectUnitsTotalDesc = 'projectUnitsTotal_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RouteAsc = 'route_ASC',
  RouteDesc = 'route_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PageStories = Story;

export type PageStoriesConnectInput = {
  Story?: InputMaybe<StoryConnectInput>;
};

export type PageStoriesCreateInput = {
  Story?: InputMaybe<StoryCreateInput>;
};

export type PageStoriesCreateManyInlineInput = {
  /** Connect multiple existing PageStories documents */
  connect?: InputMaybe<Array<PageStoriesWhereUniqueInput>>;
  /** Create and connect multiple existing PageStories documents */
  create?: InputMaybe<Array<PageStoriesCreateInput>>;
};

export type PageStoriesCreateOneInlineInput = {
  /** Connect one existing PageStories document */
  connect?: InputMaybe<PageStoriesWhereUniqueInput>;
  /** Create and connect one PageStories document */
  create?: InputMaybe<PageStoriesCreateInput>;
};

export type PageStoriesUpdateInput = {
  Story?: InputMaybe<StoryUpdateInput>;
};

export type PageStoriesUpdateManyInlineInput = {
  /** Connect multiple existing PageStories documents */
  connect?: InputMaybe<Array<PageStoriesConnectInput>>;
  /** Create and connect multiple PageStories documents */
  create?: InputMaybe<Array<PageStoriesCreateInput>>;
  /** Delete multiple PageStories documents */
  delete?: InputMaybe<Array<PageStoriesWhereUniqueInput>>;
  /** Disconnect multiple PageStories documents */
  disconnect?: InputMaybe<Array<PageStoriesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageStories documents */
  set?: InputMaybe<Array<PageStoriesWhereUniqueInput>>;
  /** Update multiple PageStories documents */
  update?: InputMaybe<Array<PageStoriesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageStories documents */
  upsert?: InputMaybe<Array<PageStoriesUpsertWithNestedWhereUniqueInput>>;
};

export type PageStoriesUpdateManyWithNestedWhereInput = {
  Story?: InputMaybe<StoryUpdateManyWithNestedWhereInput>;
};

export type PageStoriesUpdateOneInlineInput = {
  /** Connect existing PageStories document */
  connect?: InputMaybe<PageStoriesWhereUniqueInput>;
  /** Create and connect one PageStories document */
  create?: InputMaybe<PageStoriesCreateInput>;
  /** Delete currently connected PageStories document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected PageStories document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single PageStories document */
  update?: InputMaybe<PageStoriesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageStories document */
  upsert?: InputMaybe<PageStoriesUpsertWithNestedWhereUniqueInput>;
};

export type PageStoriesUpdateWithNestedWhereUniqueInput = {
  Story?: InputMaybe<StoryUpdateWithNestedWhereUniqueInput>;
};

export type PageStoriesUpsertWithNestedWhereUniqueInput = {
  Story?: InputMaybe<StoryUpsertWithNestedWhereUniqueInput>;
};

export type PageStoriesWhereInput = {
  Story?: InputMaybe<StoryWhereInput>;
};

export type PageStoriesWhereUniqueInput = {
  Story?: InputMaybe<StoryWhereUniqueInput>;
};

export type PageUpdateInput = {
  blocks?: InputMaybe<PageBlocksUpdateManyInlineInput>;
  category?: InputMaybe<PageCategory>;
  ckxk28vg73hbd01z06j9y2o62?: InputMaybe<LinkUpdateManyInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PageUpdateLocalizationsInput>;
  place?: InputMaybe<PlaceUpdateOneInlineInput>;
  projectHasUnits?: InputMaybe<Scalars['Boolean']>;
  projectState?: InputMaybe<ProjectState>;
  projectUnitsSold?: InputMaybe<Scalars['Int']>;
  projectUnitsTotal?: InputMaybe<Scalars['Int']>;
  /** route input for default locale (en) */
  route?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  stories?: InputMaybe<PageStoriesUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type PageUpdateLocalizationDataInput = {
  route?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PageUpdateLocalizationInput = {
  data: PageUpdateLocalizationDataInput;
  locale: Locale;
};

export type PageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PageUpsertLocalizationInput>>;
};

export type PageUpdateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageConnectInput>>;
  /** Create and connect multiple Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
  /** Delete multiple Page documents */
  delete?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Disconnect multiple Page documents */
  disconnect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Page documents */
  set?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Update multiple Page documents */
  update?: InputMaybe<Array<PageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Page documents */
  upsert?: InputMaybe<Array<PageUpsertWithNestedWhereUniqueInput>>;
};

export type PageUpdateManyInput = {
  category?: InputMaybe<PageCategory>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PageUpdateManyLocalizationsInput>;
  projectHasUnits?: InputMaybe<Scalars['Boolean']>;
  projectState?: InputMaybe<ProjectState>;
  projectUnitsSold?: InputMaybe<Scalars['Int']>;
  projectUnitsTotal?: InputMaybe<Scalars['Int']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type PageUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type PageUpdateManyLocalizationInput = {
  data: PageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PageUpdateManyLocalizationInput>>;
};

export type PageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageUpdateManyInput;
  /** Document search */
  where: PageWhereInput;
};

export type PageUpdateOneInlineInput = {
  /** Connect existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
  /** Delete currently connected Page document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Page document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Page document */
  update?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Page document */
  upsert?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type PageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageUpdateInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

export type PageUpsertInput = {
  /** Create document if it didn't exist */
  create: PageCreateInput;
  /** Update document if it exists */
  update: PageUpdateInput;
};

export type PageUpsertLocalizationInput = {
  create: PageCreateLocalizationDataInput;
  locale: Locale;
  update: PageUpdateLocalizationDataInput;
};

export type PageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageUpsertInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  /** All values in which the union is empty */
  blocks_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  blocks_some?: InputMaybe<PageBlocksWhereInput>;
  category?: InputMaybe<PageCategory>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<PageCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<PageCategory>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<PageCategory>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  place?: InputMaybe<PlaceWhereInput>;
  projectHasUnits?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  projectHasUnits_not?: InputMaybe<Scalars['Boolean']>;
  projectState?: InputMaybe<ProjectState>;
  /** All values that are contained in given list. */
  projectState_in?: InputMaybe<Array<InputMaybe<ProjectState>>>;
  /** Any other value that exists and is not equal to the given value. */
  projectState_not?: InputMaybe<ProjectState>;
  /** All values that are not contained in given list. */
  projectState_not_in?: InputMaybe<Array<InputMaybe<ProjectState>>>;
  projectUnitsSold?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  projectUnitsSold_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  projectUnitsSold_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  projectUnitsSold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  projectUnitsSold_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  projectUnitsSold_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  projectUnitsSold_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  projectUnitsSold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  projectUnitsTotal?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  projectUnitsTotal_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  projectUnitsTotal_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  projectUnitsTotal_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  projectUnitsTotal_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  projectUnitsTotal_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  projectUnitsTotal_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  projectUnitsTotal_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  route?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  route_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  route_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  route_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  route_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  route_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  route_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  route_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  route_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  route_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  /** All values in which the union is empty */
  stories_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  stories_some?: InputMaybe<PageStoriesWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Page record uniquely */
export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Participant = {
  __typename?: 'Participant';
  _id?: Maybe<Scalars['ObjectId']>;
  acceptedTerms: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  architectureCollaborators?: Maybe<Array<Author>>;
  associates?: Maybe<Array<Associate>>;
  coauthors?: Maybe<Array<Author>>;
  company?: Maybe<Company>;
  email: Scalars['String'];
  isValid: Scalars['Boolean'];
  members?: Maybe<Array<Member>>;
  name: Scalars['String'];
  officeName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  projects?: Maybe<Array<Project>>;
  signatureNumber: Scalars['String'];
  specialityCollaborators?: Maybe<Array<Author>>;
  type: ParticipantType;
};

export type ParticipantInput = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  acceptedTerms: Scalars['Boolean'];
  address?: InputMaybe<Scalars['String']>;
  architectureCollaborators?: InputMaybe<Array<AuthorInput>>;
  associates?: InputMaybe<Array<AssociateInput>>;
  coauthors?: InputMaybe<Array<AuthorInput>>;
  company?: InputMaybe<CompanyInput>;
  email: Scalars['String'];
  isValid?: InputMaybe<Scalars['Boolean']>;
  members?: InputMaybe<Array<MemberInput>>;
  name: Scalars['String'];
  officeName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  projects?: InputMaybe<Array<ProjectInput>>;
  signatureNumber: Scalars['String'];
  specialityCollaborators?: InputMaybe<Array<AuthorInput>>;
  type: ParticipantType;
};

export enum ParticipantType {
  ArchitectureOffice = 'ArchitectureOffice',
  Individual = 'Individual',
  LegalEntity = 'LegalEntity'
}

/** Place that can be marked on the map */
export type Place = Entity & Node & {
  __typename?: 'Place';
  /** Use internally for separation */
  category?: Maybe<Scalars['String']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<Place>;
  /** List of Place versions */
  history: Array<Version>;
  icon: Asset;
  /** The unique identifier */
  id: Scalars['ID'];
  image?: Maybe<Asset>;
  layout?: Maybe<PlaceLayout>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Place>;
  location: Location;
  page: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']>;
  type: PlaceType;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  visible?: Maybe<Scalars['Boolean']>;
};


/** Place that can be marked on the map */
export type PlaceCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Place that can be marked on the map */
export type PlaceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Place that can be marked on the map */
export type PlaceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Place that can be marked on the map */
export type PlaceHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Place that can be marked on the map */
export type PlaceIconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Place that can be marked on the map */
export type PlaceImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Place that can be marked on the map */
export type PlaceLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Place that can be marked on the map */
export type PlaceLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Place that can be marked on the map */
export type PlacePageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


/** Place that can be marked on the map */
export type PlacePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Place that can be marked on the map */
export type PlacePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Place that can be marked on the map */
export type PlaceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Place that can be marked on the map */
export type PlaceUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Place that can be marked on the map */
export type PlaceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PlaceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PlaceWhereUniqueInput;
};

/** A connection to a list of items. */
export type PlaceConnection = {
  __typename?: 'PlaceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PlaceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PlaceCreateInput = {
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  icon: AssetCreateOneInlineInput;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  layout?: InputMaybe<PlaceLayout>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PlaceCreateLocalizationsInput>;
  location: LocationInput;
  page?: InputMaybe<PageCreateManyInlineInput>;
  /** slug input for default locale (en) */
  slug?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  type: PlaceType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PlaceCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PlaceCreateLocalizationInput = {
  /** Localization input */
  data: PlaceCreateLocalizationDataInput;
  locale: Locale;
};

export type PlaceCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PlaceCreateLocalizationInput>>;
};

export type PlaceCreateManyInlineInput = {
  /** Connect multiple existing Place documents */
  connect?: InputMaybe<Array<PlaceWhereUniqueInput>>;
  /** Create and connect multiple existing Place documents */
  create?: InputMaybe<Array<PlaceCreateInput>>;
};

export type PlaceCreateOneInlineInput = {
  /** Connect one existing Place document */
  connect?: InputMaybe<PlaceWhereUniqueInput>;
  /** Create and connect one Place document */
  create?: InputMaybe<PlaceCreateInput>;
};

/** An edge in a connection. */
export type PlaceEdge = {
  __typename?: 'PlaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Place;
};

export enum PlaceLayout {
  Default = 'Default',
  Large = 'Large',
  Small = 'Small'
}

/** Identifies documents */
export type PlaceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PlaceWhereStageInput>;
  documentInStages_none?: InputMaybe<PlaceWhereStageInput>;
  documentInStages_some?: InputMaybe<PlaceWhereStageInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  layout?: InputMaybe<PlaceLayout>;
  /** All values that are contained in given list. */
  layout_in?: InputMaybe<Array<InputMaybe<PlaceLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  layout_not?: InputMaybe<PlaceLayout>;
  /** All values that are not contained in given list. */
  layout_not_in?: InputMaybe<Array<InputMaybe<PlaceLayout>>>;
  link?: InputMaybe<LinkWhereInput>;
  page_every?: InputMaybe<PageWhereInput>;
  page_none?: InputMaybe<PageWhereInput>;
  page_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  type?: InputMaybe<PlaceType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<PlaceType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<PlaceType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<PlaceType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum PlaceOrderByInput {
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VisibleAsc = 'visible_ASC',
  VisibleDesc = 'visible_DESC'
}

export enum PlaceType {
  Entrance = 'ENTRANCE',
  Info = 'INFO',
  Poi = 'POI',
  Project = 'PROJECT'
}

export type PlaceUpdateInput = {
  category?: InputMaybe<Scalars['String']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<AssetUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  layout?: InputMaybe<PlaceLayout>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PlaceUpdateLocalizationsInput>;
  location?: InputMaybe<LocationInput>;
  page?: InputMaybe<PageUpdateManyInlineInput>;
  /** slug input for default locale (en) */
  slug?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PlaceType>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PlaceUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PlaceUpdateLocalizationInput = {
  data: PlaceUpdateLocalizationDataInput;
  locale: Locale;
};

export type PlaceUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PlaceCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PlaceUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PlaceUpsertLocalizationInput>>;
};

export type PlaceUpdateManyInlineInput = {
  /** Connect multiple existing Place documents */
  connect?: InputMaybe<Array<PlaceConnectInput>>;
  /** Create and connect multiple Place documents */
  create?: InputMaybe<Array<PlaceCreateInput>>;
  /** Delete multiple Place documents */
  delete?: InputMaybe<Array<PlaceWhereUniqueInput>>;
  /** Disconnect multiple Place documents */
  disconnect?: InputMaybe<Array<PlaceWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Place documents */
  set?: InputMaybe<Array<PlaceWhereUniqueInput>>;
  /** Update multiple Place documents */
  update?: InputMaybe<Array<PlaceUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Place documents */
  upsert?: InputMaybe<Array<PlaceUpsertWithNestedWhereUniqueInput>>;
};

export type PlaceUpdateManyInput = {
  category?: InputMaybe<Scalars['String']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<PlaceLayout>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PlaceUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PlaceType>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PlaceUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PlaceUpdateManyLocalizationInput = {
  data: PlaceUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PlaceUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PlaceUpdateManyLocalizationInput>>;
};

export type PlaceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PlaceUpdateManyInput;
  /** Document search */
  where: PlaceWhereInput;
};

export type PlaceUpdateOneInlineInput = {
  /** Connect existing Place document */
  connect?: InputMaybe<PlaceWhereUniqueInput>;
  /** Create and connect one Place document */
  create?: InputMaybe<PlaceCreateInput>;
  /** Delete currently connected Place document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Place document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Place document */
  update?: InputMaybe<PlaceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Place document */
  upsert?: InputMaybe<PlaceUpsertWithNestedWhereUniqueInput>;
};

export type PlaceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PlaceUpdateInput;
  /** Unique document search */
  where: PlaceWhereUniqueInput;
};

export type PlaceUpsertInput = {
  /** Create document if it didn't exist */
  create: PlaceCreateInput;
  /** Update document if it exists */
  update: PlaceUpdateInput;
};

export type PlaceUpsertLocalizationInput = {
  create: PlaceCreateLocalizationDataInput;
  locale: Locale;
  update: PlaceUpdateLocalizationDataInput;
};

export type PlaceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PlaceUpsertInput;
  /** Unique document search */
  where: PlaceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PlaceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PlaceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<PlaceWhereStageInput>;
  documentInStages_none?: InputMaybe<PlaceWhereStageInput>;
  documentInStages_some?: InputMaybe<PlaceWhereStageInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  layout?: InputMaybe<PlaceLayout>;
  /** All values that are contained in given list. */
  layout_in?: InputMaybe<Array<InputMaybe<PlaceLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  layout_not?: InputMaybe<PlaceLayout>;
  /** All values that are not contained in given list. */
  layout_not_in?: InputMaybe<Array<InputMaybe<PlaceLayout>>>;
  link?: InputMaybe<LinkWhereInput>;
  page_every?: InputMaybe<PageWhereInput>;
  page_none?: InputMaybe<PageWhereInput>;
  page_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PlaceType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<PlaceType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<PlaceType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<PlaceType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PlaceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaceWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaceWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaceWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PlaceWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Place record uniquely */
export type PlaceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type PolygonFeature = {
  __typename?: 'PolygonFeature';
  bbox?: Maybe<Array<Scalars['Float']>>;
  geometry: GeometryPolygon;
  id?: Maybe<Scalars['String']>;
  properties: LayerProperties;
  type: Scalars['String'];
};

export type PolygonFeatureInput = {
  bbox?: InputMaybe<Array<Scalars['Float']>>;
  geometry: GeometryPolygonInput;
  id?: InputMaybe<Scalars['String']>;
  properties: LayerPropertiesInput;
  type: Scalars['String'];
};

export enum PopUpTheme {
  Dark = 'DARK',
  Light = 'LIGHT',
  White = 'WHITE'
}

export type Project = {
  __typename?: 'Project';
  _id: Scalars['ObjectId'];
  costs?: Maybe<File>;
  first?: Maybe<File>;
  images?: Maybe<Scalars['Int']>;
  isShortlisted: Scalars['Boolean'];
  isSubmitted: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  name: Scalars['String'];
  participant?: Maybe<Participant>;
  second?: Maybe<File>;
};

export type ProjectAuthor = {
  __typename?: 'ProjectAuthor';
  name?: Maybe<Scalars['String']>;
};

export type ProjectInput = {
  _id: Scalars['ObjectId'];
  costs?: InputMaybe<FileInput>;
  first?: InputMaybe<FileInput>;
  images?: InputMaybe<Scalars['Int']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']>;
  isValid?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  participant?: InputMaybe<ParticipantInput>;
  second?: InputMaybe<FileInput>;
};

export enum ProjectState {
  PartiallySold = 'PARTIALLY_SOLD',
  Reserved = 'RESERVED',
  Sold = 'SOLD',
  Wip = 'WIP'
}

export type ProjectVotes = {
  __typename?: 'ProjectVotes';
  name?: Maybe<Scalars['String']>;
  votes?: Maybe<Scalars['Float']>;
};

export type Prop = Entity & Node & {
  __typename?: 'Prop';
  booleanValue?: Maybe<Scalars['Boolean']>;
  colorValue?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dateValue?: Maybe<Scalars['Date']>;
  /** Get the document in other stages */
  documentInStages: Array<Prop>;
  floatValue?: Maybe<Scalars['Float']>;
  /** List of Prop versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  key: Scalars['String'];
  numberValue?: Maybe<Scalars['Int']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stringValue?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PropCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PropDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PropHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PropPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PropScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PropUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PropConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PropWhereUniqueInput;
};

/** A connection to a list of items. */
export type PropConnection = {
  __typename?: 'PropConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PropEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PropCreateInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  colorValue?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateValue?: InputMaybe<Scalars['Date']>;
  floatValue?: InputMaybe<Scalars['Float']>;
  key: Scalars['String'];
  numberValue?: InputMaybe<Scalars['Int']>;
  stringValue?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PropCreateManyInlineInput = {
  /** Connect multiple existing Prop documents */
  connect?: InputMaybe<Array<PropWhereUniqueInput>>;
  /** Create and connect multiple existing Prop documents */
  create?: InputMaybe<Array<PropCreateInput>>;
};

export type PropCreateOneInlineInput = {
  /** Connect one existing Prop document */
  connect?: InputMaybe<PropWhereUniqueInput>;
  /** Create and connect one Prop document */
  create?: InputMaybe<PropCreateInput>;
};

/** An edge in a connection. */
export type PropEdge = {
  __typename?: 'PropEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Prop;
};

/** Identifies documents */
export type PropManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PropWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PropWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PropWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  booleanValue_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dateValue?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  dateValue_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  dateValue_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  dateValue_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  dateValue_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  dateValue_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  dateValue_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  dateValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  documentInStages_every?: InputMaybe<PropWhereStageInput>;
  documentInStages_none?: InputMaybe<PropWhereStageInput>;
  documentInStages_some?: InputMaybe<PropWhereStageInput>;
  floatValue?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  floatValue_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  floatValue_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  floatValue_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  floatValue_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  floatValue_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  floatValue_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  floatValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  numberValue_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  numberValue_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  numberValue_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  numberValue_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  numberValue_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  numberValue_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  numberValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stringValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  stringValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  stringValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  stringValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  stringValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  stringValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  stringValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  stringValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  stringValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  stringValue_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PropOrderByInput {
  BooleanValueAsc = 'booleanValue_ASC',
  BooleanValueDesc = 'booleanValue_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DateValueAsc = 'dateValue_ASC',
  DateValueDesc = 'dateValue_DESC',
  FloatValueAsc = 'floatValue_ASC',
  FloatValueDesc = 'floatValue_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KeyAsc = 'key_ASC',
  KeyDesc = 'key_DESC',
  NumberValueAsc = 'numberValue_ASC',
  NumberValueDesc = 'numberValue_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StringValueAsc = 'stringValue_ASC',
  StringValueDesc = 'stringValue_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PropUpdateInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  colorValue?: InputMaybe<ColorInput>;
  dateValue?: InputMaybe<Scalars['Date']>;
  floatValue?: InputMaybe<Scalars['Float']>;
  key?: InputMaybe<Scalars['String']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type PropUpdateManyInlineInput = {
  /** Connect multiple existing Prop documents */
  connect?: InputMaybe<Array<PropConnectInput>>;
  /** Create and connect multiple Prop documents */
  create?: InputMaybe<Array<PropCreateInput>>;
  /** Delete multiple Prop documents */
  delete?: InputMaybe<Array<PropWhereUniqueInput>>;
  /** Disconnect multiple Prop documents */
  disconnect?: InputMaybe<Array<PropWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Prop documents */
  set?: InputMaybe<Array<PropWhereUniqueInput>>;
  /** Update multiple Prop documents */
  update?: InputMaybe<Array<PropUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Prop documents */
  upsert?: InputMaybe<Array<PropUpsertWithNestedWhereUniqueInput>>;
};

export type PropUpdateManyInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  colorValue?: InputMaybe<ColorInput>;
  dateValue?: InputMaybe<Scalars['Date']>;
  floatValue?: InputMaybe<Scalars['Float']>;
  key?: InputMaybe<Scalars['String']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type PropUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PropUpdateManyInput;
  /** Document search */
  where: PropWhereInput;
};

export type PropUpdateOneInlineInput = {
  /** Connect existing Prop document */
  connect?: InputMaybe<PropWhereUniqueInput>;
  /** Create and connect one Prop document */
  create?: InputMaybe<PropCreateInput>;
  /** Delete currently connected Prop document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Prop document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Prop document */
  update?: InputMaybe<PropUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Prop document */
  upsert?: InputMaybe<PropUpsertWithNestedWhereUniqueInput>;
};

export type PropUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PropUpdateInput;
  /** Unique document search */
  where: PropWhereUniqueInput;
};

export type PropUpsertInput = {
  /** Create document if it didn't exist */
  create: PropCreateInput;
  /** Update document if it exists */
  update: PropUpdateInput;
};

export type PropUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PropUpsertInput;
  /** Unique document search */
  where: PropWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PropWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PropWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PropWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PropWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PropWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  booleanValue_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dateValue?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  dateValue_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  dateValue_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  dateValue_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  dateValue_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  dateValue_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  dateValue_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  dateValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  documentInStages_every?: InputMaybe<PropWhereStageInput>;
  documentInStages_none?: InputMaybe<PropWhereStageInput>;
  documentInStages_some?: InputMaybe<PropWhereStageInput>;
  floatValue?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  floatValue_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  floatValue_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  floatValue_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  floatValue_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  floatValue_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  floatValue_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  floatValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  numberValue_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  numberValue_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  numberValue_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  numberValue_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  numberValue_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  numberValue_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  numberValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stringValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  stringValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  stringValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  stringValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  stringValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  stringValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  stringValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  stringValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  stringValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  stringValue_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PropWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PropWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PropWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PropWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PropWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Prop record uniquely */
export type PropWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  categories: Array<MapLayerCategory>;
  /** Retrieve a single content */
  content?: Maybe<Content>;
  /** Retrieve document version */
  contentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contents */
  contents: Array<Content>;
  /** Retrieve multiple contents using the Relay connection interface */
  contentsConnection: ContentConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single footer */
  footer?: Maybe<Footer>;
  /** Retrieve document version */
  footerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple footers */
  footers: Array<Footer>;
  /** Retrieve multiple footers using the Relay connection interface */
  footersConnection: FooterConnection;
  /** Retrieve a single form */
  form?: Maybe<Form>;
  /** Retrieve document version */
  formVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple forms */
  forms: Array<Form>;
  /** Retrieve multiple forms using the Relay connection interface */
  formsConnection: FormConnection;
  getProject: Project;
  /** Retrieve a single heading */
  heading?: Maybe<Heading>;
  /** Retrieve a single headingText */
  headingText?: Maybe<HeadingText>;
  /** Retrieve document version */
  headingTextVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple headingTexts */
  headingTexts: Array<HeadingText>;
  /** Retrieve multiple headingTexts using the Relay connection interface */
  headingTextsConnection: HeadingTextConnection;
  /** Retrieve document version */
  headingVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple headings */
  headings: Array<Heading>;
  /** Retrieve multiple headings using the Relay connection interface */
  headingsConnection: HeadingConnection;
  imagineProjects: Array<ImagineProject>;
  layer?: Maybe<Layer>;
  layers: Array<Layer>;
  /** Retrieve a single link */
  link?: Maybe<Link>;
  /** Retrieve a single linkGroup */
  linkGroup?: Maybe<LinkGroup>;
  /** Retrieve document version */
  linkGroupVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple linkGroups */
  linkGroups: Array<LinkGroup>;
  /** Retrieve multiple linkGroups using the Relay connection interface */
  linkGroupsConnection: LinkGroupConnection;
  /** Retrieve document version */
  linkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple links */
  links: Array<Link>;
  /** Retrieve multiple links using the Relay connection interface */
  linksConnection: LinkConnection;
  me: Me;
  /** Retrieve a single media */
  media?: Maybe<Media>;
  /** Retrieve document version */
  mediaVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple medias */
  medias: Array<Media>;
  /** Retrieve multiple medias using the Relay connection interface */
  mediasConnection: MediaConnection;
  myProjects: Array<Project>;
  /** Retrieve a single navigation */
  navigation?: Maybe<Navigation>;
  /** Retrieve document version */
  navigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigations */
  navigations: Array<Navigation>;
  /** Retrieve multiple navigations using the Relay connection interface */
  navigationsConnection: NavigationConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  overview: Overview;
  /** Retrieve a single page */
  page?: Maybe<Page>;
  /** Retrieve document version */
  pageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pages */
  pages: Array<Page>;
  /** Retrieve multiple pages using the Relay connection interface */
  pagesConnection: PageConnection;
  participant: Participant;
  participants: Array<Participant>;
  /** Retrieve a single place */
  place?: Maybe<Place>;
  /** Retrieve document version */
  placeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple places */
  places: Array<Place>;
  /** Retrieve multiple places using the Relay connection interface */
  placesConnection: PlaceConnection;
  projects: Array<Project>;
  /** Retrieve a single prop */
  prop?: Maybe<Prop>;
  /** Retrieve document version */
  propVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple props */
  props: Array<Prop>;
  /** Retrieve multiple props using the Relay connection interface */
  propsConnection: PropConnection;
  /** Retrieve a single question */
  question?: Maybe<Question>;
  /** Retrieve a single questionGroup */
  questionGroup?: Maybe<QuestionGroup>;
  /** Retrieve document version */
  questionGroupVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questionGroups */
  questionGroups: Array<QuestionGroup>;
  /** Retrieve multiple questionGroups using the Relay connection interface */
  questionGroupsConnection: QuestionGroupConnection;
  /** Retrieve document version */
  questionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questions */
  questions: Array<Question>;
  /** Retrieve multiple questions using the Relay connection interface */
  questionsConnection: QuestionConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single section */
  section?: Maybe<Section>;
  /** Retrieve document version */
  sectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sections */
  sections: Array<Section>;
  /** Retrieve multiple sections using the Relay connection interface */
  sectionsConnection: SectionConnection;
  /** Retrieve a single seo */
  seo?: Maybe<Seo>;
  /** Retrieve document version */
  seoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple seos */
  seos: Array<Seo>;
  /** Retrieve multiple seos using the Relay connection interface */
  seosConnection: SeoConnection;
  shortlistProjects: Array<Project>;
  /** Retrieve multiple stories */
  stories: Array<Story>;
  /** Retrieve multiple stories using the Relay connection interface */
  storiesConnection: StoryConnection;
  /** Retrieve a single story */
  story?: Maybe<Story>;
  /** Retrieve document version */
  storyVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single text */
  text?: Maybe<Text>;
  /** Retrieve a single textSection */
  textSection?: Maybe<TextSection>;
  /** Retrieve document version */
  textSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple textSections */
  textSections: Array<TextSection>;
  /** Retrieve multiple textSections using the Relay connection interface */
  textSectionsConnection: TextSectionConnection;
  /** Retrieve document version */
  textVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple texts */
  texts: Array<Text>;
  /** Retrieve multiple texts using the Relay connection interface */
  textsConnection: TextConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
  /** Retrieve a single video */
  video?: Maybe<Video>;
  /** Retrieve document version */
  videoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videos */
  videos: Array<Video>;
  /** Retrieve multiple videos using the Relay connection interface */
  videosConnection: VideoConnection;
  voted?: Maybe<Scalars['String']>;
  votes?: Maybe<Array<ProjectVotes>>;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentWhereUniqueInput;
};


export type QueryContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FooterWhereUniqueInput;
};


export type QueryFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFootersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FooterWhereInput>;
};


export type QueryFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FooterWhereInput>;
};


export type QueryFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormWhereUniqueInput;
};


export type QueryFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryGetProjectArgs = {
  id: Scalars['String'];
};


export type QueryHeadingArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeadingWhereUniqueInput;
};


export type QueryHeadingTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeadingTextWhereUniqueInput;
};


export type QueryHeadingTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeadingTextsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeadingTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<HeadingTextWhereInput>;
};


export type QueryHeadingTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeadingTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<HeadingTextWhereInput>;
};


export type QueryHeadingVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeadingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeadingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<HeadingWhereInput>;
};


export type QueryHeadingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeadingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<HeadingWhereInput>;
};


export type QueryLayerArgs = {
  id: Scalars['ObjectId'];
};


export type QueryLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LinkWhereUniqueInput;
};


export type QueryLinkGroupArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LinkGroupWhereUniqueInput;
};


export type QueryLinkGroupVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLinkGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LinkGroupWhereInput>;
};


export type QueryLinkGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LinkGroupWhereInput>;
};


export type QueryLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryMediaArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MediaWhereUniqueInput;
};


export type QueryMediaVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMediasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MediaWhereInput>;
};


export type QueryMediasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MediaWhereInput>;
};


export type QueryNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationWhereUniqueInput;
};


export type QueryNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageWhereUniqueInput;
};


export type QueryPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPlaceArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PlaceWhereUniqueInput;
};


export type QueryPlaceVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPlacesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlaceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlaceWhereInput>;
};


export type QueryPlacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlaceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlaceWhereInput>;
};


export type QueryPropArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PropWhereUniqueInput;
};


export type QueryPropVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPropsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PropOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PropWhereInput>;
};


export type QueryPropsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PropOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PropWhereInput>;
};


export type QueryQuestionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionWhereUniqueInput;
};


export type QueryQuestionGroupArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionGroupWhereUniqueInput;
};


export type QueryQuestionGroupVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<QuestionGroupWhereInput>;
};


export type QueryQuestionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<QuestionGroupWhereInput>;
};


export type QueryQuestionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QueryQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QuerySectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SectionWhereUniqueInput;
};


export type QuerySectionVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySeoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SeoWhereUniqueInput;
};


export type QuerySeoVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySeosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<SeoWhereInput>;
};


export type QuerySeosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<SeoWhereInput>;
};


export type QueryStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<StoryWhereInput>;
};


export type QueryStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<StoryWhereInput>;
};


export type QueryStoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: StoryWhereUniqueInput;
};


export type QueryStoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TextWhereUniqueInput;
};


export type QueryTextSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TextSectionWhereUniqueInput;
};


export type QueryTextSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTextSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TextSectionWhereInput>;
};


export type QueryTextSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TextSectionWhereInput>;
};


export type QueryTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTextsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TextWhereInput>;
};


export type QueryTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TextWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVideoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoWhereUniqueInput;
};


export type QueryVideoVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<VideoWhereInput>;
};


export type QueryVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<VideoWhereInput>;
};

export type Question = Entity & Node & {
  __typename?: 'Question';
  answer?: Maybe<QuestionAnswerRichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Question>;
  /** List of Question versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Question>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuestionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type QuestionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type QuestionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuestionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuestionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionAnswerRichText = {
  __typename?: 'QuestionAnswerRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<QuestionAnswerRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type QuestionAnswerRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type QuestionAnswerRichTextEmbeddedTypes = Link | Video;

export type QuestionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionCreateInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']>;
  ckybs383w050901xt7nbh9lbq?: InputMaybe<QuestionGroupCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<QuestionCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type QuestionCreateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type QuestionCreateLocalizationInput = {
  /** Localization input */
  data: QuestionCreateLocalizationDataInput;
  locale: Locale;
};

export type QuestionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<QuestionCreateLocalizationInput>>;
};

export type QuestionCreateManyInlineInput = {
  /** Connect multiple existing Question documents */
  connect?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Create and connect multiple existing Question documents */
  create?: InputMaybe<Array<QuestionCreateInput>>;
};

export type QuestionCreateOneInlineInput = {
  /** Connect one existing Question document */
  connect?: InputMaybe<QuestionWhereUniqueInput>;
  /** Create and connect one Question document */
  create?: InputMaybe<QuestionCreateInput>;
};

/** An edge in a connection. */
export type QuestionEdge = {
  __typename?: 'QuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Question;
};

export type QuestionGroup = Entity & Node & {
  __typename?: 'QuestionGroup';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuestionGroup>;
  /** List of QuestionGroup versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items: Array<Question>;
  name?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionGroupCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionGroupDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type QuestionGroupHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionGroupItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QuestionGroupPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionGroupScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionGroupSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuestionGroupUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionGroupConnection = {
  __typename?: 'QuestionGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<QuestionCreateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type QuestionGroupCreateManyInlineInput = {
  /** Connect multiple existing QuestionGroup documents */
  connect?: InputMaybe<Array<QuestionGroupWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionGroup documents */
  create?: InputMaybe<Array<QuestionGroupCreateInput>>;
};

export type QuestionGroupCreateOneInlineInput = {
  /** Connect one existing QuestionGroup document */
  connect?: InputMaybe<QuestionGroupWhereUniqueInput>;
  /** Create and connect one QuestionGroup document */
  create?: InputMaybe<QuestionGroupCreateInput>;
};

/** An edge in a connection. */
export type QuestionGroupEdge = {
  __typename?: 'QuestionGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: QuestionGroup;
};

/** Identifies documents */
export type QuestionGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  items_every?: InputMaybe<QuestionWhereInput>;
  items_none?: InputMaybe<QuestionWhereInput>;
  items_some?: InputMaybe<QuestionWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionGroupOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type QuestionGroupUpdateInput = {
  items?: InputMaybe<QuestionUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
};

export type QuestionGroupUpdateManyInlineInput = {
  /** Connect multiple existing QuestionGroup documents */
  connect?: InputMaybe<Array<QuestionGroupConnectInput>>;
  /** Create and connect multiple QuestionGroup documents */
  create?: InputMaybe<Array<QuestionGroupCreateInput>>;
  /** Delete multiple QuestionGroup documents */
  delete?: InputMaybe<Array<QuestionGroupWhereUniqueInput>>;
  /** Disconnect multiple QuestionGroup documents */
  disconnect?: InputMaybe<Array<QuestionGroupWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionGroup documents */
  set?: InputMaybe<Array<QuestionGroupWhereUniqueInput>>;
  /** Update multiple QuestionGroup documents */
  update?: InputMaybe<Array<QuestionGroupUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionGroup documents */
  upsert?: InputMaybe<Array<QuestionGroupUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionGroupUpdateManyInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type QuestionGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionGroupUpdateManyInput;
  /** Document search */
  where: QuestionGroupWhereInput;
};

export type QuestionGroupUpdateOneInlineInput = {
  /** Connect existing QuestionGroup document */
  connect?: InputMaybe<QuestionGroupWhereUniqueInput>;
  /** Create and connect one QuestionGroup document */
  create?: InputMaybe<QuestionGroupCreateInput>;
  /** Delete currently connected QuestionGroup document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected QuestionGroup document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single QuestionGroup document */
  update?: InputMaybe<QuestionGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionGroup document */
  upsert?: InputMaybe<QuestionGroupUpsertWithNestedWhereUniqueInput>;
};

export type QuestionGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionGroupUpdateInput;
  /** Unique document search */
  where: QuestionGroupWhereUniqueInput;
};

export type QuestionGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionGroupCreateInput;
  /** Update document if it exists */
  update: QuestionGroupUpdateInput;
};

export type QuestionGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionGroupUpsertInput;
  /** Unique document search */
  where: QuestionGroupWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionGroupWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type QuestionGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  items_every?: InputMaybe<QuestionWhereInput>;
  items_none?: InputMaybe<QuestionWhereInput>;
  items_some?: InputMaybe<QuestionWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionGroupWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionGroupWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionGroupWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionGroupWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionGroupWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuestionGroup record uniquely */
export type QuestionGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Identifies documents */
export type QuestionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type QuestionUpdateInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']>;
  ckybs383w050901xt7nbh9lbq?: InputMaybe<QuestionGroupUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<QuestionUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type QuestionUpdateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QuestionUpdateLocalizationInput = {
  data: QuestionUpdateLocalizationDataInput;
  locale: Locale;
};

export type QuestionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<QuestionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<QuestionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<QuestionUpsertLocalizationInput>>;
};

export type QuestionUpdateManyInlineInput = {
  /** Connect multiple existing Question documents */
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  /** Create and connect multiple Question documents */
  create?: InputMaybe<Array<QuestionCreateInput>>;
  /** Delete multiple Question documents */
  delete?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Disconnect multiple Question documents */
  disconnect?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Question documents */
  set?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Update multiple Question documents */
  update?: InputMaybe<Array<QuestionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Question documents */
  upsert?: InputMaybe<Array<QuestionUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionUpdateManyInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<QuestionUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type QuestionUpdateManyLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QuestionUpdateManyLocalizationInput = {
  data: QuestionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type QuestionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<QuestionUpdateManyLocalizationInput>>;
};

export type QuestionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionUpdateManyInput;
  /** Document search */
  where: QuestionWhereInput;
};

export type QuestionUpdateOneInlineInput = {
  /** Connect existing Question document */
  connect?: InputMaybe<QuestionWhereUniqueInput>;
  /** Create and connect one Question document */
  create?: InputMaybe<QuestionCreateInput>;
  /** Delete currently connected Question document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Question document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Question document */
  update?: InputMaybe<QuestionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Question document */
  upsert?: InputMaybe<QuestionUpsertWithNestedWhereUniqueInput>;
};

export type QuestionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionUpdateInput;
  /** Unique document search */
  where: QuestionWhereUniqueInput;
};

export type QuestionUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionCreateInput;
  /** Update document if it exists */
  update: QuestionUpdateInput;
};

export type QuestionUpsertLocalizationInput = {
  create: QuestionCreateLocalizationDataInput;
  locale: Locale;
  update: QuestionUpdateLocalizationDataInput;
};

export type QuestionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionUpsertInput;
  /** Unique document search */
  where: QuestionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type QuestionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Question record uniquely */
export type QuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency'];
  b: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  r: Scalars['RGBAHue'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency'];
  b: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  r: Scalars['RGBAHue'];
};

export type ResetPasswordInput = {
  email: Scalars['String'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | Content | Footer | Form | Heading | HeadingText | Link | LinkGroup | Media | Navigation | Page | Place | Prop | Question | QuestionGroup | Section | Seo | Story | Text | TextSection | Video;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Section = Entity & Node & {
  __typename?: 'Section';
  align?: Maybe<TextAlign>;
  component?: Maybe<SectionComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Section>;
  /** List of Section versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items: Array<SectionItems>;
  name?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  width?: Maybe<SectionWidth>;
};


export type SectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type SectionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type SectionItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SectionPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type SectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum SectionComponent {
  Carousel = 'Carousel',
  Mosaic = 'Mosaic',
  Stories = 'Stories'
}

export type SectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type SectionConnection = {
  __typename?: 'SectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SectionCreateInput = {
  align?: InputMaybe<TextAlign>;
  component?: InputMaybe<SectionComponent>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<SectionItemsCreateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  width?: InputMaybe<SectionWidth>;
};

export type SectionCreateManyInlineInput = {
  /** Connect multiple existing Section documents */
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Create and connect multiple existing Section documents */
  create?: InputMaybe<Array<SectionCreateInput>>;
};

export type SectionCreateOneInlineInput = {
  /** Connect one existing Section document */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create and connect one Section document */
  create?: InputMaybe<SectionCreateInput>;
};

/** An edge in a connection. */
export type SectionEdge = {
  __typename?: 'SectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Section;
};

export type SectionItems = Content | Form | Heading | HeadingText | LinkGroup | Media | QuestionGroup | Text | TextSection | Video;

export type SectionItemsConnectInput = {
  Content?: InputMaybe<ContentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  Heading?: InputMaybe<HeadingConnectInput>;
  HeadingText?: InputMaybe<HeadingTextConnectInput>;
  LinkGroup?: InputMaybe<LinkGroupConnectInput>;
  Media?: InputMaybe<MediaConnectInput>;
  QuestionGroup?: InputMaybe<QuestionGroupConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
  TextSection?: InputMaybe<TextSectionConnectInput>;
  Video?: InputMaybe<VideoConnectInput>;
};

export type SectionItemsCreateInput = {
  Content?: InputMaybe<ContentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  Heading?: InputMaybe<HeadingCreateInput>;
  HeadingText?: InputMaybe<HeadingTextCreateInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateInput>;
  Media?: InputMaybe<MediaCreateInput>;
  QuestionGroup?: InputMaybe<QuestionGroupCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
  TextSection?: InputMaybe<TextSectionCreateInput>;
  Video?: InputMaybe<VideoCreateInput>;
};

export type SectionItemsCreateManyInlineInput = {
  /** Connect multiple existing SectionItems documents */
  connect?: InputMaybe<Array<SectionItemsWhereUniqueInput>>;
  /** Create and connect multiple existing SectionItems documents */
  create?: InputMaybe<Array<SectionItemsCreateInput>>;
};

export type SectionItemsCreateOneInlineInput = {
  /** Connect one existing SectionItems document */
  connect?: InputMaybe<SectionItemsWhereUniqueInput>;
  /** Create and connect one SectionItems document */
  create?: InputMaybe<SectionItemsCreateInput>;
};

export type SectionItemsUpdateInput = {
  Content?: InputMaybe<ContentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  Heading?: InputMaybe<HeadingUpdateInput>;
  HeadingText?: InputMaybe<HeadingTextUpdateInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateInput>;
  Media?: InputMaybe<MediaUpdateInput>;
  QuestionGroup?: InputMaybe<QuestionGroupUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
  TextSection?: InputMaybe<TextSectionUpdateInput>;
  Video?: InputMaybe<VideoUpdateInput>;
};

export type SectionItemsUpdateManyInlineInput = {
  /** Connect multiple existing SectionItems documents */
  connect?: InputMaybe<Array<SectionItemsConnectInput>>;
  /** Create and connect multiple SectionItems documents */
  create?: InputMaybe<Array<SectionItemsCreateInput>>;
  /** Delete multiple SectionItems documents */
  delete?: InputMaybe<Array<SectionItemsWhereUniqueInput>>;
  /** Disconnect multiple SectionItems documents */
  disconnect?: InputMaybe<Array<SectionItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SectionItems documents */
  set?: InputMaybe<Array<SectionItemsWhereUniqueInput>>;
  /** Update multiple SectionItems documents */
  update?: InputMaybe<Array<SectionItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SectionItems documents */
  upsert?: InputMaybe<Array<SectionItemsUpsertWithNestedWhereUniqueInput>>;
};

export type SectionItemsUpdateManyWithNestedWhereInput = {
  Content?: InputMaybe<ContentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  Heading?: InputMaybe<HeadingUpdateManyWithNestedWhereInput>;
  HeadingText?: InputMaybe<HeadingTextUpdateManyWithNestedWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateManyWithNestedWhereInput>;
  Media?: InputMaybe<MediaUpdateManyWithNestedWhereInput>;
  QuestionGroup?: InputMaybe<QuestionGroupUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
  TextSection?: InputMaybe<TextSectionUpdateManyWithNestedWhereInput>;
  Video?: InputMaybe<VideoUpdateManyWithNestedWhereInput>;
};

export type SectionItemsUpdateOneInlineInput = {
  /** Connect existing SectionItems document */
  connect?: InputMaybe<SectionItemsWhereUniqueInput>;
  /** Create and connect one SectionItems document */
  create?: InputMaybe<SectionItemsCreateInput>;
  /** Delete currently connected SectionItems document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected SectionItems document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single SectionItems document */
  update?: InputMaybe<SectionItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionItems document */
  upsert?: InputMaybe<SectionItemsUpsertWithNestedWhereUniqueInput>;
};

export type SectionItemsUpdateWithNestedWhereUniqueInput = {
  Content?: InputMaybe<ContentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  Heading?: InputMaybe<HeadingUpdateWithNestedWhereUniqueInput>;
  HeadingText?: InputMaybe<HeadingTextUpdateWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  Media?: InputMaybe<MediaUpdateWithNestedWhereUniqueInput>;
  QuestionGroup?: InputMaybe<QuestionGroupUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionUpdateWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
};

export type SectionItemsUpsertWithNestedWhereUniqueInput = {
  Content?: InputMaybe<ContentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  Heading?: InputMaybe<HeadingUpsertWithNestedWhereUniqueInput>;
  HeadingText?: InputMaybe<HeadingTextUpsertWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
  Media?: InputMaybe<MediaUpsertWithNestedWhereUniqueInput>;
  QuestionGroup?: InputMaybe<QuestionGroupUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionUpsertWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type SectionItemsWhereInput = {
  Content?: InputMaybe<ContentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  Heading?: InputMaybe<HeadingWhereInput>;
  HeadingText?: InputMaybe<HeadingTextWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereInput>;
  Media?: InputMaybe<MediaWhereInput>;
  QuestionGroup?: InputMaybe<QuestionGroupWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
  TextSection?: InputMaybe<TextSectionWhereInput>;
  Video?: InputMaybe<VideoWhereInput>;
};

export type SectionItemsWhereUniqueInput = {
  Content?: InputMaybe<ContentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  Heading?: InputMaybe<HeadingWhereUniqueInput>;
  HeadingText?: InputMaybe<HeadingTextWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereUniqueInput>;
  Media?: InputMaybe<MediaWhereUniqueInput>;
  QuestionGroup?: InputMaybe<QuestionGroupWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
  TextSection?: InputMaybe<TextSectionWhereUniqueInput>;
  Video?: InputMaybe<VideoWhereUniqueInput>;
};

export enum SectionLayout {
  Split = 'SPLIT',
  Stack = 'STACK'
}

/** Identifies documents */
export type SectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  align?: InputMaybe<TextAlign>;
  /** All values that are contained in given list. */
  align_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  align_not?: InputMaybe<TextAlign>;
  /** All values that are not contained in given list. */
  align_not_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  component?: InputMaybe<SectionComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<SectionComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<SectionComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<SectionComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SectionWhereStageInput>;
  documentInStages_none?: InputMaybe<SectionWhereStageInput>;
  documentInStages_some?: InputMaybe<SectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<SectionItemsWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  width?: InputMaybe<SectionWidth>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<SectionWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<SectionWidth>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<SectionWidth>>>;
};

export enum SectionOrderByInput {
  AlignAsc = 'align_ASC',
  AlignDesc = 'align_DESC',
  ComponentAsc = 'component_ASC',
  ComponentDesc = 'component_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

export type SectionUpdateInput = {
  align?: InputMaybe<TextAlign>;
  component?: InputMaybe<SectionComponent>;
  items?: InputMaybe<SectionItemsUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<SectionWidth>;
};

export type SectionUpdateManyInlineInput = {
  /** Connect multiple existing Section documents */
  connect?: InputMaybe<Array<SectionConnectInput>>;
  /** Create and connect multiple Section documents */
  create?: InputMaybe<Array<SectionCreateInput>>;
  /** Delete multiple Section documents */
  delete?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Disconnect multiple Section documents */
  disconnect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Section documents */
  set?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Update multiple Section documents */
  update?: InputMaybe<Array<SectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Section documents */
  upsert?: InputMaybe<Array<SectionUpsertWithNestedWhereUniqueInput>>;
};

export type SectionUpdateManyInput = {
  align?: InputMaybe<TextAlign>;
  component?: InputMaybe<SectionComponent>;
  name?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<SectionWidth>;
};

export type SectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionUpdateManyInput;
  /** Document search */
  where: SectionWhereInput;
};

export type SectionUpdateOneInlineInput = {
  /** Connect existing Section document */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create and connect one Section document */
  create?: InputMaybe<SectionCreateInput>;
  /** Delete currently connected Section document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Section document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Section document */
  update?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Section document */
  upsert?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type SectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionUpdateInput;
  /** Unique document search */
  where: SectionWhereUniqueInput;
};

export type SectionUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionCreateInput;
  /** Update document if it exists */
  update: SectionUpdateInput;
};

export type SectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionUpsertInput;
  /** Unique document search */
  where: SectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type SectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  align?: InputMaybe<TextAlign>;
  /** All values that are contained in given list. */
  align_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  align_not?: InputMaybe<TextAlign>;
  /** All values that are not contained in given list. */
  align_not_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  component?: InputMaybe<SectionComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<SectionComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<SectionComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<SectionComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SectionWhereStageInput>;
  documentInStages_none?: InputMaybe<SectionWhereStageInput>;
  documentInStages_some?: InputMaybe<SectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<SectionItemsWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  width?: InputMaybe<SectionWidth>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<SectionWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<SectionWidth>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<SectionWidth>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Section record uniquely */
export type SectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum SectionWidth {
  Four = 'FOUR',
  Six = 'SIX'
}

export type Seo = Entity & Node & {
  __typename?: 'Seo';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<Seo>;
  /** List of Seo versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  image?: Maybe<Asset>;
  keywords: Array<Scalars['String']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Seo>;
  noIndex: Scalars['Boolean'];
  parent?: Maybe<SeoSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SeoCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SeoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SeoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type SeoHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type SeoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SeoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type SeoParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SeoPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SeoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SeoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SeoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SeoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type SeoConnection = {
  __typename?: 'SeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SeoCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** keywords input for default locale (en) */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SeoCreateLocalizationsInput>;
  noIndex: Scalars['Boolean'];
  parent?: InputMaybe<SeoSeoCreateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SeoCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SeoCreateLocalizationInput = {
  /** Localization input */
  data: SeoCreateLocalizationDataInput;
  locale: Locale;
};

export type SeoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SeoCreateLocalizationInput>>;
};

export type SeoCreateManyInlineInput = {
  /** Connect multiple existing Seo documents */
  connect?: InputMaybe<Array<SeoWhereUniqueInput>>;
  /** Create and connect multiple existing Seo documents */
  create?: InputMaybe<Array<SeoCreateInput>>;
};

export type SeoCreateOneInlineInput = {
  /** Connect one existing Seo document */
  connect?: InputMaybe<SeoWhereUniqueInput>;
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>;
};

/** An edge in a connection. */
export type SeoEdge = {
  __typename?: 'SeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Seo;
};

/** Identifies documents */
export type SeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SeoWhereStageInput>;
  documentInStages_none?: InputMaybe<SeoWhereStageInput>;
  documentInStages_some?: InputMaybe<SeoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']>;
  /** All values in which the union is connected to the given models */
  parent?: InputMaybe<SeoSeoWhereInput>;
  /** All values in which the union is empty */
  parent_empty?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SeoOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KeywordsAsc = 'keywords_ASC',
  KeywordsDesc = 'keywords_DESC',
  NoIndexAsc = 'noIndex_ASC',
  NoIndexDesc = 'noIndex_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SeoSeo = Page;

export type SeoSeoConnectInput = {
  Page?: InputMaybe<PageConnectInput>;
};

export type SeoSeoCreateInput = {
  Page?: InputMaybe<PageCreateInput>;
};

export type SeoSeoCreateManyInlineInput = {
  /** Connect multiple existing SeoSeo documents */
  connect?: InputMaybe<Array<SeoSeoWhereUniqueInput>>;
  /** Create and connect multiple existing SeoSeo documents */
  create?: InputMaybe<Array<SeoSeoCreateInput>>;
};

export type SeoSeoCreateOneInlineInput = {
  /** Connect one existing SeoSeo document */
  connect?: InputMaybe<SeoSeoWhereUniqueInput>;
  /** Create and connect one SeoSeo document */
  create?: InputMaybe<SeoSeoCreateInput>;
};

export type SeoSeoUpdateInput = {
  Page?: InputMaybe<PageUpdateInput>;
};

export type SeoSeoUpdateManyInlineInput = {
  /** Connect multiple existing SeoSeo documents */
  connect?: InputMaybe<Array<SeoSeoConnectInput>>;
  /** Create and connect multiple SeoSeo documents */
  create?: InputMaybe<Array<SeoSeoCreateInput>>;
  /** Delete multiple SeoSeo documents */
  delete?: InputMaybe<Array<SeoSeoWhereUniqueInput>>;
  /** Disconnect multiple SeoSeo documents */
  disconnect?: InputMaybe<Array<SeoSeoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SeoSeo documents */
  set?: InputMaybe<Array<SeoSeoWhereUniqueInput>>;
  /** Update multiple SeoSeo documents */
  update?: InputMaybe<Array<SeoSeoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SeoSeo documents */
  upsert?: InputMaybe<Array<SeoSeoUpsertWithNestedWhereUniqueInput>>;
};

export type SeoSeoUpdateManyWithNestedWhereInput = {
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
};

export type SeoSeoUpdateOneInlineInput = {
  /** Connect existing SeoSeo document */
  connect?: InputMaybe<SeoSeoWhereUniqueInput>;
  /** Create and connect one SeoSeo document */
  create?: InputMaybe<SeoSeoCreateInput>;
  /** Delete currently connected SeoSeo document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected SeoSeo document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single SeoSeo document */
  update?: InputMaybe<SeoSeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SeoSeo document */
  upsert?: InputMaybe<SeoSeoUpsertWithNestedWhereUniqueInput>;
};

export type SeoSeoUpdateWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
};

export type SeoSeoUpsertWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type SeoSeoWhereInput = {
  Page?: InputMaybe<PageWhereInput>;
};

export type SeoSeoWhereUniqueInput = {
  Page?: InputMaybe<PageWhereUniqueInput>;
};

export type SeoUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** keywords input for default locale (en) */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** Manage document localizations */
  localizations?: InputMaybe<SeoUpdateLocalizationsInput>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  parent?: InputMaybe<SeoSeoUpdateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type SeoUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SeoUpdateLocalizationInput = {
  data: SeoUpdateLocalizationDataInput;
  locale: Locale;
};

export type SeoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SeoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SeoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SeoUpsertLocalizationInput>>;
};

export type SeoUpdateManyInlineInput = {
  /** Connect multiple existing Seo documents */
  connect?: InputMaybe<Array<SeoConnectInput>>;
  /** Create and connect multiple Seo documents */
  create?: InputMaybe<Array<SeoCreateInput>>;
  /** Delete multiple Seo documents */
  delete?: InputMaybe<Array<SeoWhereUniqueInput>>;
  /** Disconnect multiple Seo documents */
  disconnect?: InputMaybe<Array<SeoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Seo documents */
  set?: InputMaybe<Array<SeoWhereUniqueInput>>;
  /** Update multiple Seo documents */
  update?: InputMaybe<Array<SeoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Seo documents */
  upsert?: InputMaybe<Array<SeoUpsertWithNestedWhereUniqueInput>>;
};

export type SeoUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  /** keywords input for default locale (en) */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SeoUpdateManyLocalizationsInput>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type SeoUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SeoUpdateManyLocalizationInput = {
  data: SeoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SeoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SeoUpdateManyLocalizationInput>>;
};

export type SeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeoUpdateManyInput;
  /** Document search */
  where: SeoWhereInput;
};

export type SeoUpdateOneInlineInput = {
  /** Connect existing Seo document */
  connect?: InputMaybe<SeoWhereUniqueInput>;
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>;
  /** Delete currently connected Seo document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Seo document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Seo document */
  update?: InputMaybe<SeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Seo document */
  upsert?: InputMaybe<SeoUpsertWithNestedWhereUniqueInput>;
};

export type SeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeoUpdateInput;
  /** Unique document search */
  where: SeoWhereUniqueInput;
};

export type SeoUpsertInput = {
  /** Create document if it didn't exist */
  create: SeoCreateInput;
  /** Update document if it exists */
  update: SeoUpdateInput;
};

export type SeoUpsertLocalizationInput = {
  create: SeoCreateLocalizationDataInput;
  locale: Locale;
  update: SeoUpdateLocalizationDataInput;
};

export type SeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeoUpsertInput;
  /** Unique document search */
  where: SeoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SeoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type SeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<SeoWhereStageInput>;
  documentInStages_none?: InputMaybe<SeoWhereStageInput>;
  documentInStages_some?: InputMaybe<SeoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  keywords_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  keywords_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  keywords_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  keywords_not?: InputMaybe<Array<Scalars['String']>>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']>;
  /** All values in which the union is connected to the given models */
  parent?: InputMaybe<SeoSeoWhereInput>;
  /** All values in which the union is empty */
  parent_empty?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SeoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SeoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Seo record uniquely */
export type SeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

/** To be used for news & awards */
export type Story = Entity & Node & {
  __typename?: 'Story';
  accentColor?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description: StoryDescriptionRichText;
  /** Get the document in other stages */
  documentInStages: Array<Story>;
  /** List of Story versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  items?: Maybe<StoryItems>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Story>;
  pages: Array<Page>;
  published: Scalars['Date'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** To be used for news & awards */
export type StoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** To be used for news & awards */
export type StoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** To be used for news & awards */
export type StoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** To be used for news & awards */
export type StoryHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** To be used for news & awards */
export type StoryItemsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** To be used for news & awards */
export type StoryLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** To be used for news & awards */
export type StoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** To be used for news & awards */
export type StoryPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


/** To be used for news & awards */
export type StoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** To be used for news & awards */
export type StoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** To be used for news & awards */
export type StoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** To be used for news & awards */
export type StoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** To be used for news & awards */
export type StoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type StoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: StoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type StoryConnection = {
  __typename?: 'StoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<StoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type StoryCreateInput = {
  accentColor?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** description input for default locale (en) */
  description: Scalars['RichTextAST'];
  items?: InputMaybe<StoryItemsCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<StoryCreateLocalizationsInput>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  published: Scalars['Date'];
  /** title input for default locale (en) */
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['RichTextAST'];
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StoryCreateLocalizationInput = {
  /** Localization input */
  data: StoryCreateLocalizationDataInput;
  locale: Locale;
};

export type StoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<StoryCreateLocalizationInput>>;
};

export type StoryCreateManyInlineInput = {
  /** Connect multiple existing Story documents */
  connect?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Create and connect multiple existing Story documents */
  create?: InputMaybe<Array<StoryCreateInput>>;
};

export type StoryCreateOneInlineInput = {
  /** Connect one existing Story document */
  connect?: InputMaybe<StoryWhereUniqueInput>;
  /** Create and connect one Story document */
  create?: InputMaybe<StoryCreateInput>;
};

export type StoryDescriptionRichText = {
  __typename?: 'StoryDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<StoryDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type StoryDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type StoryDescriptionRichTextEmbeddedTypes = Link | Page;

/** An edge in a connection. */
export type StoryEdge = {
  __typename?: 'StoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Story;
};

export type StoryItems = Asset | Video;

export type StoryItemsConnectInput = {
  Asset?: InputMaybe<AssetConnectInput>;
  Video?: InputMaybe<VideoConnectInput>;
};

export type StoryItemsCreateInput = {
  Asset?: InputMaybe<AssetCreateInput>;
  Video?: InputMaybe<VideoCreateInput>;
};

export type StoryItemsCreateManyInlineInput = {
  /** Connect multiple existing StoryItems documents */
  connect?: InputMaybe<Array<StoryItemsWhereUniqueInput>>;
  /** Create and connect multiple existing StoryItems documents */
  create?: InputMaybe<Array<StoryItemsCreateInput>>;
};

export type StoryItemsCreateOneInlineInput = {
  /** Connect one existing StoryItems document */
  connect?: InputMaybe<StoryItemsWhereUniqueInput>;
  /** Create and connect one StoryItems document */
  create?: InputMaybe<StoryItemsCreateInput>;
};

export type StoryItemsUpdateInput = {
  Asset?: InputMaybe<AssetUpdateInput>;
  Video?: InputMaybe<VideoUpdateInput>;
};

export type StoryItemsUpdateManyInlineInput = {
  /** Connect multiple existing StoryItems documents */
  connect?: InputMaybe<Array<StoryItemsConnectInput>>;
  /** Create and connect multiple StoryItems documents */
  create?: InputMaybe<Array<StoryItemsCreateInput>>;
  /** Delete multiple StoryItems documents */
  delete?: InputMaybe<Array<StoryItemsWhereUniqueInput>>;
  /** Disconnect multiple StoryItems documents */
  disconnect?: InputMaybe<Array<StoryItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing StoryItems documents */
  set?: InputMaybe<Array<StoryItemsWhereUniqueInput>>;
  /** Update multiple StoryItems documents */
  update?: InputMaybe<Array<StoryItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple StoryItems documents */
  upsert?: InputMaybe<Array<StoryItemsUpsertWithNestedWhereUniqueInput>>;
};

export type StoryItemsUpdateManyWithNestedWhereInput = {
  Asset?: InputMaybe<AssetUpdateManyWithNestedWhereInput>;
  Video?: InputMaybe<VideoUpdateManyWithNestedWhereInput>;
};

export type StoryItemsUpdateOneInlineInput = {
  /** Connect existing StoryItems document */
  connect?: InputMaybe<StoryItemsWhereUniqueInput>;
  /** Create and connect one StoryItems document */
  create?: InputMaybe<StoryItemsCreateInput>;
  /** Delete currently connected StoryItems document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected StoryItems document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single StoryItems document */
  update?: InputMaybe<StoryItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StoryItems document */
  upsert?: InputMaybe<StoryItemsUpsertWithNestedWhereUniqueInput>;
};

export type StoryItemsUpdateWithNestedWhereUniqueInput = {
  Asset?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
};

export type StoryItemsUpsertWithNestedWhereUniqueInput = {
  Asset?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type StoryItemsWhereInput = {
  Asset?: InputMaybe<AssetWhereInput>;
  Video?: InputMaybe<VideoWhereInput>;
};

export type StoryItemsWhereUniqueInput = {
  Asset?: InputMaybe<AssetWhereUniqueInput>;
  Video?: InputMaybe<VideoWhereUniqueInput>;
};

/** Identifies documents */
export type StoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<StoryWhereStageInput>;
  documentInStages_none?: InputMaybe<StoryWhereStageInput>;
  documentInStages_some?: InputMaybe<StoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is connected to the given models */
  items?: InputMaybe<StoryItemsWhereInput>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<LinkWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  published?: InputMaybe<Scalars['Date']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum StoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type StoryUpdateInput = {
  accentColor?: InputMaybe<ColorInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']>;
  items?: InputMaybe<StoryItemsUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<StoryUpdateLocalizationsInput>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  published?: InputMaybe<Scalars['Date']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type StoryUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']>;
  title?: InputMaybe<Scalars['String']>;
};

export type StoryUpdateLocalizationInput = {
  data: StoryUpdateLocalizationDataInput;
  locale: Locale;
};

export type StoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<StoryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<StoryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<StoryUpsertLocalizationInput>>;
};

export type StoryUpdateManyInlineInput = {
  /** Connect multiple existing Story documents */
  connect?: InputMaybe<Array<StoryConnectInput>>;
  /** Create and connect multiple Story documents */
  create?: InputMaybe<Array<StoryCreateInput>>;
  /** Delete multiple Story documents */
  delete?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Disconnect multiple Story documents */
  disconnect?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Story documents */
  set?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Update multiple Story documents */
  update?: InputMaybe<Array<StoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Story documents */
  upsert?: InputMaybe<Array<StoryUpsertWithNestedWhereUniqueInput>>;
};

export type StoryUpdateManyInput = {
  accentColor?: InputMaybe<ColorInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<StoryUpdateManyLocalizationsInput>;
  published?: InputMaybe<Scalars['Date']>;
};

export type StoryUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']>;
};

export type StoryUpdateManyLocalizationInput = {
  data: StoryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type StoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<StoryUpdateManyLocalizationInput>>;
};

export type StoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: StoryUpdateManyInput;
  /** Document search */
  where: StoryWhereInput;
};

export type StoryUpdateOneInlineInput = {
  /** Connect existing Story document */
  connect?: InputMaybe<StoryWhereUniqueInput>;
  /** Create and connect one Story document */
  create?: InputMaybe<StoryCreateInput>;
  /** Delete currently connected Story document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Story document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Story document */
  update?: InputMaybe<StoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Story document */
  upsert?: InputMaybe<StoryUpsertWithNestedWhereUniqueInput>;
};

export type StoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: StoryUpdateInput;
  /** Unique document search */
  where: StoryWhereUniqueInput;
};

export type StoryUpsertInput = {
  /** Create document if it didn't exist */
  create: StoryCreateInput;
  /** Update document if it exists */
  update: StoryUpdateInput;
};

export type StoryUpsertLocalizationInput = {
  create: StoryCreateLocalizationDataInput;
  locale: Locale;
  update: StoryUpdateLocalizationDataInput;
};

export type StoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: StoryUpsertInput;
  /** Unique document search */
  where: StoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type StoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type StoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<StoryWhereStageInput>;
  documentInStages_none?: InputMaybe<StoryWhereStageInput>;
  documentInStages_some?: InputMaybe<StoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values in which the union is connected to the given models */
  items?: InputMaybe<StoryItemsWhereInput>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<LinkWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  published?: InputMaybe<Scalars['Date']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type StoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<StoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Story record uniquely */
export type StoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type Text = Entity & Node & {
  __typename?: 'Text';
  align?: Maybe<TextAlign>;
  content?: Maybe<TextContentRichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Text>;
  headingText?: Maybe<HeadingText>;
  /** List of Text versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Text>;
  name?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TextCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type TextHeadingTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TextHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type TextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type TextPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TextSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type TextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum TextAlign {
  Center = 'CENTER',
  Left = 'LEFT'
}

export type TextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextConnection = {
  __typename?: 'TextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextContentRichText = {
  __typename?: 'TextContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<TextContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type TextContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type TextContentRichTextEmbeddedTypes = Asset | Link | Video;

export type TextCreateInput = {
  align?: InputMaybe<TextAlign>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  headingText?: InputMaybe<HeadingTextCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TextCreateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TextCreateLocalizationInput = {
  /** Localization input */
  data: TextCreateLocalizationDataInput;
  locale: Locale;
};

export type TextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextCreateLocalizationInput>>;
};

export type TextCreateManyInlineInput = {
  /** Connect multiple existing Text documents */
  connect?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Create and connect multiple existing Text documents */
  create?: InputMaybe<Array<TextCreateInput>>;
};

export type TextCreateOneInlineInput = {
  /** Connect one existing Text document */
  connect?: InputMaybe<TextWhereUniqueInput>;
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
};

/** An edge in a connection. */
export type TextEdge = {
  __typename?: 'TextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Text;
};

/** Identifies documents */
export type TextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  align?: InputMaybe<TextAlign>;
  /** All values that are contained in given list. */
  align_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  align_not?: InputMaybe<TextAlign>;
  /** All values that are not contained in given list. */
  align_not_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextWhereStageInput>;
  documentInStages_none?: InputMaybe<TextWhereStageInput>;
  documentInStages_some?: InputMaybe<TextWhereStageInput>;
  headingText?: InputMaybe<HeadingTextWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TextOrderByInput {
  AlignAsc = 'align_ASC',
  AlignDesc = 'align_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TextSection = Entity & Node & {
  __typename?: 'TextSection';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** deprecated, use htmlDescription */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<TextSection>;
  headline?: Maybe<Scalars['String']>;
  /** List of TextSection versions */
  history: Array<Version>;
  htmlDescription?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TextSection>;
  name?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  /** System stage field */
  stage: Stage;
  subheadline?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TextSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TextSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type TextSectionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type TextSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


export type TextSectionPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type TextSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TextSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TextSectionSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type TextSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type TextSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TextSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextSectionConnection = {
  __typename?: 'TextSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextSectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  /** headline input for default locale (en) */
  headline?: InputMaybe<Scalars['String']>;
  /** htmlDescription input for default locale (en) */
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextSectionCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  /** subheadline input for default locale (en) */
  subheadline?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TextSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  subheadline?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TextSectionCreateLocalizationInput = {
  /** Localization input */
  data: TextSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type TextSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextSectionCreateLocalizationInput>>;
};

export type TextSectionCreateManyInlineInput = {
  /** Connect multiple existing TextSection documents */
  connect?: InputMaybe<Array<TextSectionWhereUniqueInput>>;
  /** Create and connect multiple existing TextSection documents */
  create?: InputMaybe<Array<TextSectionCreateInput>>;
};

export type TextSectionCreateOneInlineInput = {
  /** Connect one existing TextSection document */
  connect?: InputMaybe<TextSectionWhereUniqueInput>;
  /** Create and connect one TextSection document */
  create?: InputMaybe<TextSectionCreateInput>;
};

/** An edge in a connection. */
export type TextSectionEdge = {
  __typename?: 'TextSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TextSection;
};

/** Identifies documents */
export type TextSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<TextSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<TextSectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TextSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SubheadlineAsc = 'subheadline_ASC',
  SubheadlineDesc = 'subheadline_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TextSectionUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  /** headline input for default locale (en) */
  headline?: InputMaybe<Scalars['String']>;
  /** htmlDescription input for default locale (en) */
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TextSectionUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  /** subheadline input for default locale (en) */
  subheadline?: InputMaybe<Scalars['String']>;
};

export type TextSectionUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  subheadline?: InputMaybe<Scalars['String']>;
};

export type TextSectionUpdateLocalizationInput = {
  data: TextSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type TextSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TextSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TextSectionUpsertLocalizationInput>>;
};

export type TextSectionUpdateManyInlineInput = {
  /** Connect multiple existing TextSection documents */
  connect?: InputMaybe<Array<TextSectionConnectInput>>;
  /** Create and connect multiple TextSection documents */
  create?: InputMaybe<Array<TextSectionCreateInput>>;
  /** Delete multiple TextSection documents */
  delete?: InputMaybe<Array<TextSectionWhereUniqueInput>>;
  /** Disconnect multiple TextSection documents */
  disconnect?: InputMaybe<Array<TextSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TextSection documents */
  set?: InputMaybe<Array<TextSectionWhereUniqueInput>>;
  /** Update multiple TextSection documents */
  update?: InputMaybe<Array<TextSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TextSection documents */
  upsert?: InputMaybe<Array<TextSectionUpsertWithNestedWhereUniqueInput>>;
};

export type TextSectionUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']>;
  /** headline input for default locale (en) */
  headline?: InputMaybe<Scalars['String']>;
  /** htmlDescription input for default locale (en) */
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextSectionUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  /** subheadline input for default locale (en) */
  subheadline?: InputMaybe<Scalars['String']>;
};

export type TextSectionUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  htmlDescription?: InputMaybe<Scalars['RichTextAST']>;
  subheadline?: InputMaybe<Scalars['String']>;
};

export type TextSectionUpdateManyLocalizationInput = {
  data: TextSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TextSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextSectionUpdateManyLocalizationInput>>;
};

export type TextSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextSectionUpdateManyInput;
  /** Document search */
  where: TextSectionWhereInput;
};

export type TextSectionUpdateOneInlineInput = {
  /** Connect existing TextSection document */
  connect?: InputMaybe<TextSectionWhereUniqueInput>;
  /** Create and connect one TextSection document */
  create?: InputMaybe<TextSectionCreateInput>;
  /** Delete currently connected TextSection document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected TextSection document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single TextSection document */
  update?: InputMaybe<TextSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TextSection document */
  upsert?: InputMaybe<TextSectionUpsertWithNestedWhereUniqueInput>;
};

export type TextSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextSectionUpdateInput;
  /** Unique document search */
  where: TextSectionWhereUniqueInput;
};

export type TextSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: TextSectionCreateInput;
  /** Update document if it exists */
  update: TextSectionUpdateInput;
};

export type TextSectionUpsertLocalizationInput = {
  create: TextSectionCreateLocalizationDataInput;
  locale: Locale;
  update: TextSectionUpdateLocalizationDataInput;
};

export type TextSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextSectionUpsertInput;
  /** Unique document search */
  where: TextSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TextSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type TextSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<TextSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<TextSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<TextSectionWhereStageInput>;
  headline?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  subheadline?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subheadline_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subheadline_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subheadline_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subheadline_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subheadline_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subheadline_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subheadline_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TextSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TextSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TextSection record uniquely */
export type TextSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type TextUpdateInput = {
  align?: InputMaybe<TextAlign>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  headingText?: InputMaybe<HeadingTextUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<TextUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
};

export type TextUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
};

export type TextUpdateLocalizationInput = {
  data: TextUpdateLocalizationDataInput;
  locale: Locale;
};

export type TextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TextUpsertLocalizationInput>>;
};

export type TextUpdateManyInlineInput = {
  /** Connect multiple existing Text documents */
  connect?: InputMaybe<Array<TextConnectInput>>;
  /** Create and connect multiple Text documents */
  create?: InputMaybe<Array<TextCreateInput>>;
  /** Delete multiple Text documents */
  delete?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Disconnect multiple Text documents */
  disconnect?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Text documents */
  set?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Update multiple Text documents */
  update?: InputMaybe<Array<TextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Text documents */
  upsert?: InputMaybe<Array<TextUpsertWithNestedWhereUniqueInput>>;
};

export type TextUpdateManyInput = {
  align?: InputMaybe<TextAlign>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type TextUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
};

export type TextUpdateManyLocalizationInput = {
  data: TextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextUpdateManyLocalizationInput>>;
};

export type TextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextUpdateManyInput;
  /** Document search */
  where: TextWhereInput;
};

export type TextUpdateOneInlineInput = {
  /** Connect existing Text document */
  connect?: InputMaybe<TextWhereUniqueInput>;
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
  /** Delete currently connected Text document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Text document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Text document */
  update?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Text document */
  upsert?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type TextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextUpdateInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

export type TextUpsertInput = {
  /** Create document if it didn't exist */
  create: TextCreateInput;
  /** Update document if it exists */
  update: TextUpdateInput;
};

export type TextUpsertLocalizationInput = {
  create: TextCreateLocalizationDataInput;
  locale: Locale;
  update: TextUpdateLocalizationDataInput;
};

export type TextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextUpsertInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type TextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  align?: InputMaybe<TextAlign>;
  /** All values that are contained in given list. */
  align_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  align_not?: InputMaybe<TextAlign>;
  /** All values that are not contained in given list. */
  align_not_in?: InputMaybe<Array<InputMaybe<TextAlign>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextWhereStageInput>;
  documentInStages_none?: InputMaybe<TextWhereStageInput>;
  documentInStages_some?: InputMaybe<TextWhereStageInput>;
  headingText?: InputMaybe<HeadingTextWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Text record uniquely */
export type TextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

export type UpdateCategoryInput = {
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateParticipantInput = {
  architectureCollaborators?: InputMaybe<Array<AuthorInput>>;
  associates?: InputMaybe<Array<AssociateInput>>;
  coauthors?: InputMaybe<Array<AuthorInput>>;
  company?: InputMaybe<CompanyInput>;
  id: Scalars['String'];
  members?: InputMaybe<Array<MemberInput>>;
  officeName: Scalars['String'];
  specialityCollaborators?: InputMaybe<Array<AuthorInput>>;
};

export type UpdatePasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

/** Video content */
export type Video = Entity & Node & {
  __typename?: 'Video';
  color?: Maybe<Color>;
  component?: Maybe<VideoComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Video>;
  full?: Maybe<Scalars['String']>;
  /** List of Video versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Video>;
  mediaGroup?: Maybe<Media>;
  name?: Maybe<Scalars['String']>;
  pages: Array<Page>;
  placeholder?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  slug?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Video content */
export type VideoCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Video content */
export type VideoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Video content */
export type VideoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Video content */
export type VideoHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Video content */
export type VideoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Video content */
export type VideoMediaGroupArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Video content */
export type VideoPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


/** Video content */
export type VideoPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Video content */
export type VideoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Video content */
export type VideoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Video content */
export type VideoSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionWhereInput>;
};


/** Video content */
export type VideoStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Video content */
export type VideoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Video content */
export type VideoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum VideoComponent {
  Player = 'PLAYER'
}

export type VideoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCreateInput = {
  ckybpu3781ryf01z25nw247wy?: InputMaybe<ContentCreateManyInlineInput>;
  color?: InputMaybe<ColorInput>;
  component?: InputMaybe<VideoComponent>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** full input for default locale (en) */
  full?: InputMaybe<Scalars['String']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<VideoCreateLocalizationsInput>;
  mediaGroup?: InputMaybe<MediaCreateOneInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  /** placeholder input for default locale (en) */
  placeholder?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VideoCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  full?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VideoCreateLocalizationInput = {
  /** Localization input */
  data: VideoCreateLocalizationDataInput;
  locale: Locale;
};

export type VideoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<VideoCreateLocalizationInput>>;
};

export type VideoCreateManyInlineInput = {
  /** Connect multiple existing Video documents */
  connect?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Create and connect multiple existing Video documents */
  create?: InputMaybe<Array<VideoCreateInput>>;
};

export type VideoCreateOneInlineInput = {
  /** Connect one existing Video document */
  connect?: InputMaybe<VideoWhereUniqueInput>;
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Video;
};

/** Identifies documents */
export type VideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  component?: InputMaybe<VideoComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<VideoComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<VideoComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<VideoComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  mediaGroup?: InputMaybe<MediaWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum VideoOrderByInput {
  ComponentAsc = 'component_ASC',
  ComponentDesc = 'component_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FullAsc = 'full_ASC',
  FullDesc = 'full_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PlaceholderAsc = 'placeholder_ASC',
  PlaceholderDesc = 'placeholder_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoUpdateInput = {
  ckybpu3781ryf01z25nw247wy?: InputMaybe<ContentUpdateManyInlineInput>;
  color?: InputMaybe<ColorInput>;
  component?: InputMaybe<VideoComponent>;
  /** full input for default locale (en) */
  full?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<VideoUpdateLocalizationsInput>;
  mediaGroup?: InputMaybe<MediaUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  /** placeholder input for default locale (en) */
  placeholder?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
};

export type VideoUpdateLocalizationDataInput = {
  full?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
};

export type VideoUpdateLocalizationInput = {
  data: VideoUpdateLocalizationDataInput;
  locale: Locale;
};

export type VideoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<VideoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<VideoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<VideoUpsertLocalizationInput>>;
};

export type VideoUpdateManyInlineInput = {
  /** Connect multiple existing Video documents */
  connect?: InputMaybe<Array<VideoConnectInput>>;
  /** Create and connect multiple Video documents */
  create?: InputMaybe<Array<VideoCreateInput>>;
  /** Delete multiple Video documents */
  delete?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Disconnect multiple Video documents */
  disconnect?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Video documents */
  set?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Update multiple Video documents */
  update?: InputMaybe<Array<VideoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Video documents */
  upsert?: InputMaybe<Array<VideoUpsertWithNestedWhereUniqueInput>>;
};

export type VideoUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  component?: InputMaybe<VideoComponent>;
  /** full input for default locale (en) */
  full?: InputMaybe<Scalars['String']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<VideoUpdateManyLocalizationsInput>;
  /** placeholder input for default locale (en) */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type VideoUpdateManyLocalizationDataInput = {
  full?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
};

export type VideoUpdateManyLocalizationInput = {
  data: VideoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type VideoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<VideoUpdateManyLocalizationInput>>;
};

export type VideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoUpdateManyInput;
  /** Document search */
  where: VideoWhereInput;
};

export type VideoUpdateOneInlineInput = {
  /** Connect existing Video document */
  connect?: InputMaybe<VideoWhereUniqueInput>;
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
  /** Delete currently connected Video document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Video document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Video document */
  update?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Video document */
  upsert?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type VideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoUpdateInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCreateInput;
  /** Update document if it exists */
  update: VideoUpdateInput;
};

export type VideoUpsertLocalizationInput = {
  create: VideoCreateLocalizationDataInput;
  locale: Locale;
  update: VideoUpdateLocalizationDataInput;
};

export type VideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoUpsertInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type VideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  component?: InputMaybe<VideoComponent>;
  /** All values that are contained in given list. */
  component_in?: InputMaybe<Array<InputMaybe<VideoComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  component_not?: InputMaybe<VideoComponent>;
  /** All values that are not contained in given list. */
  component_not_in?: InputMaybe<Array<InputMaybe<VideoComponent>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoWhereStageInput>;
  full?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  full_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  full_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  full_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  full_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  full_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  full_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  full_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  full_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  full_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  mediaGroup?: InputMaybe<MediaWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  placeholder?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  placeholder_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  placeholder_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholder_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  placeholder_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  placeholder_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  placeholder_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  placeholder_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Video record uniquely */
export type VideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some'
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization'
}

export type ResetPasswordMutationVariables = Exact<{
  data: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  data: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type ParticipantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParticipantsQuery = { __typename?: 'Query', participants: Array<{ __typename?: 'Participant', _id?: any | null, name: string, signatureNumber: string, email: string, phone: string, address?: string | null, type: ParticipantType, officeName?: string | null, isValid: boolean, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null }> };

export type OverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewQuery = { __typename?: 'Query', overview: { __typename?: 'Overview', tpc?: number | null, apc?: number | null } };

export type ProjectFragment = { __typename?: 'Project', _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, images?: number | null, participant?: { __typename?: 'Participant', name: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null };

export type AddProjectMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddProjectMutation = { __typename?: 'Mutation', addProject: { __typename?: 'Project', _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, images?: number | null, participant?: { __typename?: 'Participant', name: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null } };

export type MyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProjectsQuery = { __typename?: 'Query', myProjects: Array<{ __typename?: 'Project', _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, images?: number | null, participant?: { __typename?: 'Participant', name: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null }> };

export type VotesQueryVariables = Exact<{ [key: string]: never; }>;


export type VotesQuery = { __typename?: 'Query', votes?: Array<{ __typename?: 'ProjectVotes', name?: string | null, votes?: number | null }> | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, images?: number | null, participant?: { __typename?: 'Participant', name: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null } };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, images?: number | null, participant?: { __typename?: 'Participant', isValid: boolean, name: string, email: string, phone: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null }> };

export type ShortlistProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShortlistProjectsQuery = { __typename?: 'Query', shortlistProjects: Array<{ __typename?: 'Project', images?: number | null, _id: any, name: string, isValid: boolean, isSubmitted: boolean, isShortlisted: boolean, participant?: { __typename?: 'Participant', isValid: boolean, name: string, email: string, phone: string, type: ParticipantType, officeName?: string | null, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null } | null, costs?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, first?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null, second?: { __typename?: 'File', filename?: string | null, fieldname?: string | null } | null }> };

export type ShortlistProjectMutationVariables = Exact<{
  id: Scalars['String'];
  value: Scalars['Boolean'];
}>;


export type ShortlistProjectMutation = { __typename?: 'Mutation', shortlistProject: { __typename?: 'Project', _id: any, isShortlisted: boolean } };

export type UpdateProjectImagesMutationVariables = Exact<{
  id: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateProjectImagesMutation = { __typename?: 'Mutation', updateProjectImages: { __typename?: 'Project', _id: any, images?: number | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type VoteProjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type VoteProjectMutation = { __typename?: 'Mutation', vote: boolean };

export type VotedProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type VotedProjectQuery = { __typename?: 'Query', voted?: string | null };

export type ParticipantFragmentFragment = { __typename?: 'Participant', _id?: any | null, name: string, signatureNumber: string, email: string, phone: string, address?: string | null, type: ParticipantType, officeName?: string | null, isValid: boolean, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, associates?: Array<{ __typename?: 'Associate', name: string, statute: string, contribution: string }> | null };

export type ParticipantQueryVariables = Exact<{ [key: string]: never; }>;


export type ParticipantQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', _id?: any | null, name: string, signatureNumber: string, email: string, phone: string, address?: string | null, type: ParticipantType, officeName?: string | null, isValid: boolean, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, associates?: Array<{ __typename?: 'Associate', name: string, statute: string, contribution: string }> | null } };

export type UpdateParticipantMutationVariables = Exact<{
  data: UpdateParticipantInput;
}>;


export type UpdateParticipantMutation = { __typename?: 'Mutation', updateParticipant: { __typename?: 'Participant', _id?: any | null, name: string, signatureNumber: string, email: string, phone: string, address?: string | null, type: ParticipantType, officeName?: string | null, isValid: boolean, company?: { __typename?: 'Company', name: string, address: string, fiscalCode: string, registrationNumber: string, representative: string } | null, members?: Array<{ __typename?: 'Member', name: string, signatureNumber: string }> | null, coauthors?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, architectureCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, specialityCollaborators?: Array<{ __typename?: 'Author', name: string, speciality?: string | null }> | null, associates?: Array<{ __typename?: 'Associate', name: string, statute: string, contribution: string }> | null } };

export type CreateEnquiryMutationVariables = Exact<{
  data: CreateEnquiryInput;
}>;


export type CreateEnquiryMutation = { __typename?: 'Mutation', createEnquiry: { __typename?: 'Enquiry', _id: any } };

export type ImagineProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImagineProjectsQuery = { __typename?: 'Query', imagineProjects: Array<{ __typename?: 'ImagineProject', _id?: any | null, name?: string | null, slug?: string | null, team?: string | null, images?: Array<string> | null, author?: { __typename?: 'ProjectAuthor', name?: string | null } | null }> };

export type LayersQueryVariables = Exact<{ [key: string]: never; }>;


export type LayersQuery = { __typename?: 'Query', layers: Array<{ __typename?: 'Layer', _id: any, category?: { __typename?: 'MapLayerCategory', slug?: string | null, color: string } | null, feature: { __typename?: 'PolygonFeature', id?: string | null, type: string, properties: { __typename?: 'LayerProperties', name: string, label: string, area: number, price?: number | null, selectable: boolean, visible: boolean }, geometry: { __typename?: 'GeometryPolygon', type: string, coordinates?: Array<Array<Array<number>>> | null } } }> };

export type BaseAssetFragment = { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null };

export type BaseAssetWithoutUrlFragment = { __typename?: 'Asset', id: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null };

export type AssetQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  transform?: InputMaybe<AssetTransformationInput>;
}>;


export type AssetQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null };

export type BaseContentFragment = { __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null };

export type FooterQueryVariables = Exact<{
  where: FooterWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type FooterQuery = { __typename?: 'Query', footer?: { __typename?: 'Footer', id: string, title: string, slug: string, primaryLinks: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }>, secondaryLinks: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null };

export type BaseFormFragment = { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null };

export type FormQueryVariables = Exact<{
  where: FormWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type FormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | null };

export type BaseHeadingTextFragment = { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> };

export type BaseHeadingFragment = { __typename?: 'Heading', id: string, content?: string | null, as?: string | null };

export type BaseLinkGroupFragment = { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> };

export type BaseLinkFragment = { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null };

export type BaseMediaFragment = { __typename?: 'Media', id: string, name?: string | null, slug?: string | null, items: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> };

export type BaseNavigationFragment = { __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> };

export type NavigationQueryVariables = Exact<{
  where: NavigationWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type NavigationQuery = { __typename?: 'Query', navigation?: { __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null };

export type NavigationsQueryVariables = Exact<{
  where: NavigationWhereInput;
  locales: Array<Locale> | Locale;
}>;


export type NavigationsQuery = { __typename?: 'Query', navigations: Array<{ __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> }> };

export type BasePageFragment = { __typename?: 'Page', id: string, locale: Locale, slug: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, blocks: Array<{ __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Media', id: string, name?: string | null, slug?: string | null, items: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Section', id: string, slug?: string | null, align?: TextAlign | null, width?: SectionWidth | null, sectionComponent?: SectionComponent | null, items: Array<{ __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null } | { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> } | { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Media' } | { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }>, stories: Array<{ __typename?: 'Story', id: string, title: string, published: any, description: { __typename?: 'StoryDescriptionRichText', html: string, text: string }, items?: { __typename?: 'Asset', id: string, fileName: string, handle: string, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, accentColor?: { __typename?: 'Color', hex: any, css: string, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null }>, place?: { __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> } | null, seo?: { __typename?: 'Seo', title?: string | null, description?: string | null, noIndex: boolean, keywords: Array<string>, image?: { __typename?: 'Asset', id: string, url: string } | null } | null, localizations: Array<{ __typename?: 'Page', route: string, locale: Locale }> };

export type PageQueryVariables = Exact<{
  where: PageWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, locale: Locale, slug: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, blocks: Array<{ __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Media', id: string, name?: string | null, slug?: string | null, items: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Section', id: string, slug?: string | null, align?: TextAlign | null, width?: SectionWidth | null, sectionComponent?: SectionComponent | null, items: Array<{ __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null } | { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> } | { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Media' } | { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }>, stories: Array<{ __typename?: 'Story', id: string, title: string, published: any, description: { __typename?: 'StoryDescriptionRichText', html: string, text: string }, items?: { __typename?: 'Asset', id: string, fileName: string, handle: string, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, accentColor?: { __typename?: 'Color', hex: any, css: string, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null }>, place?: { __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> } | null, seo?: { __typename?: 'Seo', title?: string | null, description?: string | null, noIndex: boolean, keywords: Array<string>, image?: { __typename?: 'Asset', id: string, url: string } | null } | null, localizations: Array<{ __typename?: 'Page', route: string, locale: Locale }> } | null };

export type PagesQueryVariables = Exact<{
  where: PageWhereInput;
  locales: Array<Locale> | Locale;
}>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id: string, locale: Locale, slug: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, blocks: Array<{ __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Media', id: string, name?: string | null, slug?: string | null, items: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'Navigation', id: string, title?: string | null, slug?: string | null, navigationComponent?: NavigationComponent | null, links: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Section', id: string, slug?: string | null, align?: TextAlign | null, width?: SectionWidth | null, sectionComponent?: SectionComponent | null, items: Array<{ __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null } | { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> } | { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Media' } | { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }>, stories: Array<{ __typename?: 'Story', id: string, title: string, published: any, description: { __typename?: 'StoryDescriptionRichText', html: string, text: string }, items?: { __typename?: 'Asset', id: string, fileName: string, handle: string, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, accentColor?: { __typename?: 'Color', hex: any, css: string, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null }>, place?: { __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> } | null, seo?: { __typename?: 'Seo', title?: string | null, description?: string | null, noIndex: boolean, keywords: Array<string>, image?: { __typename?: 'Asset', id: string, url: string } | null } | null, localizations: Array<{ __typename?: 'Page', route: string, locale: Locale }> }> };

export type PageRoutesQueryVariables = Exact<{
  where: PageWhereInput;
}>;


export type PageRoutesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id: string, route: string, slug: string, locale: Locale, category?: PageCategory | null, localizations: Array<{ __typename?: 'Page', route: string, locale: Locale }> }> };

export type PlaceIconFragment = { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null };

export type BasePlaceFragment = { __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> };

export type PlaceQueryVariables = Exact<{
  where: PlaceWhereUniqueInput;
  locale: Locale;
  transformation?: InputMaybe<AssetTransformationInput>;
}>;


export type PlaceQuery = { __typename?: 'Query', place?: { __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, image?: { __typename?: 'Asset', url: string, id: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> } | null };

export type PlacesQueryVariables = Exact<{
  where?: InputMaybe<PlaceWhereInput>;
  locale: Locale;
  transformation?: InputMaybe<AssetTransformationInput>;
}>;


export type PlacesQuery = { __typename?: 'Query', places: Array<{ __typename?: 'Place', id: string, title?: string | null, slug?: string | null, description?: string | null, type: PlaceType, layout?: PlaceLayout | null, category?: string | null, visible?: boolean | null, image?: { __typename?: 'Asset', url: string, id: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null, location: { __typename?: 'Location', latitude: number, longitude: number }, icon: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null }, localizations: Array<{ __typename?: 'Place', slug?: string | null, locale: Locale }> }> };

export type BaseQuestionGroupFragment = { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> };

export type BaseQuestionFragment = { __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null };

export type BaseSectionFragment = { __typename?: 'Section', id: string, slug?: string | null, align?: TextAlign | null, width?: SectionWidth | null, sectionComponent?: SectionComponent | null, items: Array<{ __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null } | { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> } | { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Media' } | { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> };

export type SectionQueryVariables = Exact<{
  where: SectionWhereUniqueInput;
  locale: Locale;
}>;


export type SectionQuery = { __typename?: 'Query', section?: { __typename?: 'Section', id: string, slug?: string | null, align?: TextAlign | null, width?: SectionWidth | null, sectionComponent?: SectionComponent | null, items: Array<{ __typename?: 'Content', id: string, video?: { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, heading?: { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | null, richContent?: { __typename?: 'ContentContentRichText', html: string, text: string } | null, linkGroup?: { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | null } | { __typename?: 'Form', id: string, name?: string | null, slug?: string | null, success?: string | null, details?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'HeadingText', id: string, items: Array<{ __typename?: 'Heading', id: string, content?: string | null, as?: string | null } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null }> } | { __typename?: 'LinkGroup', id: string, title?: string | null, slug?: string | null, items: Array<{ __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null }> } | { __typename?: 'Media' } | { __typename?: 'QuestionGroup', id: string, items: Array<{ __typename?: 'Question', id: string, title?: string | null, answer?: { __typename?: 'QuestionAnswerRichText', html: string, text: string } | null }> } | { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null } | { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null }> } | null };

export type BaseStoryFragment = { __typename?: 'Story', id: string, title: string, published: any, description: { __typename?: 'StoryDescriptionRichText', html: string, text: string }, items?: { __typename?: 'Asset', id: string, fileName: string, handle: string, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, accentColor?: { __typename?: 'Color', hex: any, css: string, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null };

export type StoriesQueryVariables = Exact<{
  where: StoryWhereInput;
  locales: Array<Locale> | Locale;
  order?: InputMaybe<StoryOrderByInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type StoriesQuery = { __typename?: 'Query', stories: Array<{ __typename?: 'Story', id: string, title: string, published: any, description: { __typename?: 'StoryDescriptionRichText', html: string, text: string }, items?: { __typename?: 'Asset', id: string, fileName: string, handle: string, bigScreen: string, smallScreen: string } | { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null } | null, accentColor?: { __typename?: 'Color', hex: any, css: string, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, link?: { __typename?: 'Link', id: string, slug?: string | null, title?: string | null, subtitle?: string | null, showTitle?: boolean | null, icon?: Icon | null, illustration?: Illustration | null, variant?: ButtonVariant | null, size?: ButtonSize | null, url?: string | null, image?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, handle: string, fileName: string, name?: string | null, mimeType?: string | null } | null, page?: { __typename?: 'Page', id: string, title: string, route: string, category?: PageCategory | null, projectState?: ProjectState | null, projectUnitsTotal?: number | null, projectUnitsSold?: number | null, projectHasUnits?: boolean | null } | null } | null }> };

export type BaseTextSectionFragment = { __typename?: 'TextSection', id: string, headline?: string | null, subheadline?: string | null, description?: string | null, htmlDescription?: { __typename?: 'RichText', html: string, text: string } | null };

export type BaseTextFragment = { __typename?: 'Text', id: string, align?: TextAlign | null, richContent?: { __typename?: 'TextContentRichText', html: string, text: string } | null };

export type BaseVideoFragment = { __typename?: 'Video', id: string, name?: string | null, slug?: string | null, placeholder?: string | null, full?: string | null, color?: { __typename?: 'Color', hex: any } | null };

export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  _id
  name
  isValid
  isSubmitted
  isShortlisted
  images
  participant {
    name
    type
    officeName
    company {
      name
      address
      fiscalCode
      registrationNumber
      representative
    }
    members {
      name
      signatureNumber
    }
    coauthors {
      name
      speciality
    }
    architectureCollaborators {
      name
      speciality
    }
    specialityCollaborators {
      name
      speciality
    }
  }
  costs {
    filename
    fieldname
  }
  first {
    filename
    fieldname
  }
  second {
    filename
    fieldname
  }
}
    `;
export const ParticipantFragmentFragmentDoc = gql`
    fragment ParticipantFragment on Participant {
  _id
  name
  signatureNumber
  email
  phone
  address
  type
  company {
    name
    address
    fiscalCode
    registrationNumber
    representative
  }
  officeName
  members {
    name
    signatureNumber
  }
  coauthors {
    name
    speciality
  }
  architectureCollaborators {
    name
    speciality
  }
  specialityCollaborators {
    name
    speciality
  }
  associates {
    name
    statute
    contribution
  }
  isValid
}
    `;
export const BaseAssetWithoutUrlFragmentDoc = gql`
    fragment BaseAssetWithoutUrl on Asset {
  id
  width
  height
  handle
  fileName
  name
  mimeType
}
    `;
export const BaseAssetFragmentDoc = gql`
    fragment BaseAsset on Asset {
  id
  url
  width
  height
  handle
  fileName
  name
  mimeType
}
    `;
export const BaseVideoFragmentDoc = gql`
    fragment BaseVideo on Video {
  id
  name
  slug
  placeholder
  full
  color {
    hex
  }
}
    `;
export const BaseMediaFragmentDoc = gql`
    fragment BaseMedia on Media {
  id
  name
  slug
  items(locales: [en]) {
    ... on Asset {
      id
      url
      bigScreen: url(
        transformation: {document: {output: {format: jpg}}, image: {resize: {width: 1800}}}
      )
      smallScreen: url(
        transformation: {document: {output: {format: jpg}}, image: {resize: {width: 900}}}
      )
      width
      height
      handle
      fileName
      name
      mimeType
    }
    ...BaseVideo
  }
}
    ${BaseVideoFragmentDoc}`;
export const BaseHeadingFragmentDoc = gql`
    fragment BaseHeading on Heading {
  id
  content
  as
}
    `;
export const BaseTextFragmentDoc = gql`
    fragment BaseText on Text {
  id
  align
  richContent: content {
    html
    text
  }
}
    `;
export const BaseTextSectionFragmentDoc = gql`
    fragment BaseTextSection on TextSection {
  id
  headline
  subheadline
  description
  htmlDescription {
    html
    text
  }
}
    `;
export const BaseHeadingTextFragmentDoc = gql`
    fragment BaseHeadingText on HeadingText {
  id
  items {
    ...BaseHeading
    ...BaseText
  }
}
    ${BaseHeadingFragmentDoc}
${BaseTextFragmentDoc}`;
export const BaseLinkFragmentDoc = gql`
    fragment BaseLink on Link {
  id
  slug
  title
  subtitle
  showTitle
  icon
  illustration
  image(locales: [en]) {
    ...BaseAsset
  }
  variant
  size
  page {
    id
    title
    route
    category
    projectState
    projectState
    projectUnitsTotal
    projectUnitsSold
    projectHasUnits
  }
  url
}
    ${BaseAssetFragmentDoc}`;
export const BaseLinkGroupFragmentDoc = gql`
    fragment BaseLinkGroup on LinkGroup {
  id
  title
  slug
  items {
    ...BaseLink
  }
}
    ${BaseLinkFragmentDoc}`;
export const BaseContentFragmentDoc = gql`
    fragment BaseContent on Content {
  id
  video {
    ...BaseVideo
  }
  image(locales: [en]) {
    ...BaseAsset
  }
  heading {
    ...BaseHeading
  }
  richContent: content {
    html
    text
  }
  linkGroup {
    ...BaseLinkGroup
  }
}
    ${BaseVideoFragmentDoc}
${BaseAssetFragmentDoc}
${BaseHeadingFragmentDoc}
${BaseLinkGroupFragmentDoc}`;
export const BaseQuestionFragmentDoc = gql`
    fragment BaseQuestion on Question {
  id
  title
  answer {
    html
    text
  }
}
    `;
export const BaseQuestionGroupFragmentDoc = gql`
    fragment BaseQuestionGroup on QuestionGroup {
  id
  items {
    ...BaseQuestion
  }
}
    ${BaseQuestionFragmentDoc}`;
export const BaseFormFragmentDoc = gql`
    fragment BaseForm on Form {
  id
  name
  slug
  details {
    html
    text
  }
  success
}
    `;
export const BaseSectionFragmentDoc = gql`
    fragment BaseSection on Section {
  id
  sectionComponent: component
  slug
  align
  width
  items {
    ...BaseHeading
    ...BaseText
    ...BaseTextSection
    ...BaseHeadingText
    ...BaseVideo
    ...BaseContent
    ...BaseLinkGroup
    ...BaseQuestionGroup
    ...BaseForm
  }
}
    ${BaseHeadingFragmentDoc}
${BaseTextFragmentDoc}
${BaseTextSectionFragmentDoc}
${BaseHeadingTextFragmentDoc}
${BaseVideoFragmentDoc}
${BaseContentFragmentDoc}
${BaseLinkGroupFragmentDoc}
${BaseQuestionGroupFragmentDoc}
${BaseFormFragmentDoc}`;
export const BaseNavigationFragmentDoc = gql`
    fragment BaseNavigation on Navigation {
  id
  title
  slug
  navigationComponent: component
  links {
    ...BaseLink
  }
}
    ${BaseLinkFragmentDoc}`;
export const BaseStoryFragmentDoc = gql`
    fragment BaseStory on Story {
  id
  title
  description {
    html
    text
  }
  published
  items {
    ... on Asset {
      id
      fileName
      handle
      bigScreen: url(transformation: {image: {resize: {width: 960}}})
      smallScreen: url(transformation: {image: {resize: {width: 640}}})
    }
    ...BaseVideo
  }
  accentColor {
    hex
    rgba {
      r
      g
      b
      a
    }
    css
  }
  link {
    ...BaseLink
  }
}
    ${BaseVideoFragmentDoc}
${BaseLinkFragmentDoc}`;
export const PlaceIconFragmentDoc = gql`
    fragment PlaceIcon on Asset {
  id
  url(transformation: {document: {output: {format: png}}})
  width
  height
}
    `;
export const BasePlaceFragmentDoc = gql`
    fragment BasePlace on Place {
  id
  title
  slug
  description
  type
  layout
  category
  link {
    ...BaseLink
  }
  location {
    latitude
    longitude
  }
  icon {
    ...PlaceIcon
  }
  localizations {
    slug
    locale
  }
  visible
}
    ${BaseLinkFragmentDoc}
${PlaceIconFragmentDoc}`;
export const BasePageFragmentDoc = gql`
    fragment BasePage on Page {
  id
  locale
  image {
    ...BaseAsset
  }
  slug
  title
  route
  category
  projectState
  projectUnitsTotal
  projectUnitsSold
  projectHasUnits
  blocks {
    ...BaseMedia
    ...BaseHeading
    ...BaseVideo
    ...BaseSection
    ...BaseNavigation
    ...BaseTextSection
    ...BaseForm
  }
  stories {
    ...BaseStory
  }
  place {
    ...BasePlace
  }
  seo {
    title
    description
    noIndex
    keywords
    image(locales: [en]) {
      id
      url
    }
  }
  localizations {
    route
    locale
  }
}
    ${BaseAssetFragmentDoc}
${BaseMediaFragmentDoc}
${BaseHeadingFragmentDoc}
${BaseVideoFragmentDoc}
${BaseSectionFragmentDoc}
${BaseNavigationFragmentDoc}
${BaseTextSectionFragmentDoc}
${BaseFormFragmentDoc}
${BaseStoryFragmentDoc}
${BasePlaceFragmentDoc}`;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($data: ResetPasswordInput!) {
  resetPassword(data: $data)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($data: UpdatePasswordInput!) {
  updatePassword(data: $data)
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const ParticipantsDocument = gql`
    query Participants {
  participants {
    _id
    name
    signatureNumber
    email
    phone
    address
    type
    officeName
    company {
      name
      address
      fiscalCode
      registrationNumber
      representative
    }
    members {
      name
      signatureNumber
    }
    coauthors {
      name
      speciality
    }
    architectureCollaborators {
      name
      speciality
    }
    specialityCollaborators {
      name
      speciality
    }
    isValid
  }
}
    `;

export function useParticipantsQuery(options?: Omit<Urql.UseQueryArgs<ParticipantsQueryVariables>, 'query'>) {
  return Urql.useQuery<ParticipantsQuery, ParticipantsQueryVariables>({ query: ParticipantsDocument, ...options });
};
export const OverviewDocument = gql`
    query Overview {
  overview {
    tpc
    apc
  }
}
    `;

export function useOverviewQuery(options?: Omit<Urql.UseQueryArgs<OverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<OverviewQuery, OverviewQueryVariables>({ query: OverviewDocument, ...options });
};
export const AddProjectDocument = gql`
    mutation AddProject($name: String!) {
  addProject(name: $name) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

export function useAddProjectMutation() {
  return Urql.useMutation<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument);
};
export const MyProjectsDocument = gql`
    query MyProjects {
  myProjects {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

export function useMyProjectsQuery(options?: Omit<Urql.UseQueryArgs<MyProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyProjectsQuery, MyProjectsQueryVariables>({ query: MyProjectsDocument, ...options });
};
export const VotesDocument = gql`
    query Votes {
  votes {
    name
    votes
  }
}
    `;

export function useVotesQuery(options?: Omit<Urql.UseQueryArgs<VotesQueryVariables>, 'query'>) {
  return Urql.useQuery<VotesQuery, VotesQueryVariables>({ query: VotesDocument, ...options });
};
export const GetProjectDocument = gql`
    query GetProject($id: String!) {
  getProject(id: $id) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

export function useGetProjectQuery(options: Omit<Urql.UseQueryArgs<GetProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectQuery, GetProjectQueryVariables>({ query: GetProjectDocument, ...options });
};
export const ProjectsDocument = gql`
    query Projects {
  projects {
    ...Project
    participant {
      isValid
      name
      email
      phone
      type
    }
  }
}
    ${ProjectFragmentDoc}`;

export function useProjectsQuery(options?: Omit<Urql.UseQueryArgs<ProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsQuery, ProjectsQueryVariables>({ query: ProjectsDocument, ...options });
};
export const ShortlistProjectsDocument = gql`
    query ShortlistProjects {
  shortlistProjects {
    ...Project
    images
    participant {
      isValid
      name
      email
      phone
      type
    }
  }
}
    ${ProjectFragmentDoc}`;

export function useShortlistProjectsQuery(options?: Omit<Urql.UseQueryArgs<ShortlistProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<ShortlistProjectsQuery, ShortlistProjectsQueryVariables>({ query: ShortlistProjectsDocument, ...options });
};
export const ShortlistProjectDocument = gql`
    mutation ShortlistProject($id: String!, $value: Boolean!) {
  shortlistProject(id: $id, value: $value) {
    _id
    isShortlisted
  }
}
    `;

export function useShortlistProjectMutation() {
  return Urql.useMutation<ShortlistProjectMutation, ShortlistProjectMutationVariables>(ShortlistProjectDocument);
};
export const UpdateProjectImagesDocument = gql`
    mutation UpdateProjectImages($id: String!, $value: Int) {
  updateProjectImages(id: $id, value: $value) {
    _id
    images
  }
}
    `;

export function useUpdateProjectImagesMutation() {
  return Urql.useMutation<UpdateProjectImagesMutation, UpdateProjectImagesMutationVariables>(UpdateProjectImagesDocument);
};
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: String!) {
  deleteProject(id: $id)
}
    `;

export function useDeleteProjectMutation() {
  return Urql.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument);
};
export const VoteProjectDocument = gql`
    mutation VoteProject($id: String!) {
  vote(id: $id)
}
    `;

export function useVoteProjectMutation() {
  return Urql.useMutation<VoteProjectMutation, VoteProjectMutationVariables>(VoteProjectDocument);
};
export const VotedProjectDocument = gql`
    query VotedProject {
  voted
}
    `;

export function useVotedProjectQuery(options?: Omit<Urql.UseQueryArgs<VotedProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<VotedProjectQuery, VotedProjectQueryVariables>({ query: VotedProjectDocument, ...options });
};
export const ParticipantDocument = gql`
    query Participant {
  participant {
    ...ParticipantFragment
  }
}
    ${ParticipantFragmentFragmentDoc}`;

export function useParticipantQuery(options?: Omit<Urql.UseQueryArgs<ParticipantQueryVariables>, 'query'>) {
  return Urql.useQuery<ParticipantQuery, ParticipantQueryVariables>({ query: ParticipantDocument, ...options });
};
export const UpdateParticipantDocument = gql`
    mutation UpdateParticipant($data: UpdateParticipantInput!) {
  updateParticipant(data: $data) {
    ...ParticipantFragment
  }
}
    ${ParticipantFragmentFragmentDoc}`;

export function useUpdateParticipantMutation() {
  return Urql.useMutation<UpdateParticipantMutation, UpdateParticipantMutationVariables>(UpdateParticipantDocument);
};
export const CreateEnquiryDocument = gql`
    mutation CreateEnquiry($data: CreateEnquiryInput!) {
  createEnquiry(data: $data) {
    _id
  }
}
    `;

export function useCreateEnquiryMutation() {
  return Urql.useMutation<CreateEnquiryMutation, CreateEnquiryMutationVariables>(CreateEnquiryDocument);
};
export const ImagineProjectsDocument = gql`
    query ImagineProjects {
  imagineProjects {
    _id
    name
    slug
    team
    author {
      name
    }
    images
  }
}
    `;

export function useImagineProjectsQuery(options?: Omit<Urql.UseQueryArgs<ImagineProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<ImagineProjectsQuery, ImagineProjectsQueryVariables>({ query: ImagineProjectsDocument, ...options });
};
export const LayersDocument = gql`
    query Layers {
  layers {
    _id
    category {
      slug
      color
    }
    feature {
      id
      type
      properties {
        name
        label
        area
        price
        selectable
        visible
      }
      geometry {
        type
        coordinates
      }
    }
  }
}
    `;

export function useLayersQuery(options?: Omit<Urql.UseQueryArgs<LayersQueryVariables>, 'query'>) {
  return Urql.useQuery<LayersQuery, LayersQueryVariables>({ query: LayersDocument, ...options });
};
export const AssetDocument = gql`
    query Asset($id: ID, $transform: AssetTransformationInput) {
  asset(where: {id: $id}) {
    id
    url(transformation: $transform)
    width
    height
    handle
    fileName
    name
    mimeType
  }
}
    `;

export function useAssetQuery(options?: Omit<Urql.UseQueryArgs<AssetQueryVariables>, 'query'>) {
  return Urql.useQuery<AssetQuery, AssetQueryVariables>({ query: AssetDocument, ...options });
};
export const FooterDocument = gql`
    query Footer($where: FooterWhereUniqueInput!, $locales: [Locale!]!) {
  footer(where: $where, locales: $locales) {
    id
    title
    slug
    primaryLinks {
      ...BaseLink
    }
    secondaryLinks {
      ...BaseLink
    }
  }
}
    ${BaseLinkFragmentDoc}`;

export function useFooterQuery(options: Omit<Urql.UseQueryArgs<FooterQueryVariables>, 'query'>) {
  return Urql.useQuery<FooterQuery, FooterQueryVariables>({ query: FooterDocument, ...options });
};
export const FormDocument = gql`
    query form($where: FormWhereUniqueInput!, $locales: [Locale!]!) {
  form(where: $where, locales: $locales) {
    ...BaseForm
  }
}
    ${BaseFormFragmentDoc}`;

export function useFormQuery(options: Omit<Urql.UseQueryArgs<FormQueryVariables>, 'query'>) {
  return Urql.useQuery<FormQuery, FormQueryVariables>({ query: FormDocument, ...options });
};
export const NavigationDocument = gql`
    query Navigation($where: NavigationWhereUniqueInput!, $locales: [Locale!]!) {
  navigation(where: $where, locales: $locales) {
    ...BaseNavigation
  }
}
    ${BaseNavigationFragmentDoc}`;

export function useNavigationQuery(options: Omit<Urql.UseQueryArgs<NavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<NavigationQuery, NavigationQueryVariables>({ query: NavigationDocument, ...options });
};
export const NavigationsDocument = gql`
    query Navigations($where: NavigationWhereInput!, $locales: [Locale!]!) {
  navigations(where: $where, locales: $locales) {
    ...BaseNavigation
  }
}
    ${BaseNavigationFragmentDoc}`;

export function useNavigationsQuery(options: Omit<Urql.UseQueryArgs<NavigationsQueryVariables>, 'query'>) {
  return Urql.useQuery<NavigationsQuery, NavigationsQueryVariables>({ query: NavigationsDocument, ...options });
};
export const PageDocument = gql`
    query Page($where: PageWhereUniqueInput!, $locales: [Locale!]!) {
  page(where: $where, locales: $locales) {
    ...BasePage
  }
}
    ${BasePageFragmentDoc}`;

export function usePageQuery(options: Omit<Urql.UseQueryArgs<PageQueryVariables>, 'query'>) {
  return Urql.useQuery<PageQuery, PageQueryVariables>({ query: PageDocument, ...options });
};
export const PagesDocument = gql`
    query Pages($where: PageWhereInput!, $locales: [Locale!]!) {
  pages(where: $where, locales: $locales) {
    ...BasePage
  }
}
    ${BasePageFragmentDoc}`;

export function usePagesQuery(options: Omit<Urql.UseQueryArgs<PagesQueryVariables>, 'query'>) {
  return Urql.useQuery<PagesQuery, PagesQueryVariables>({ query: PagesDocument, ...options });
};
export const PageRoutesDocument = gql`
    query PageRoutes($where: PageWhereInput!) {
  pages(where: $where, locales: [ro, en]) {
    id
    route
    slug
    locale
    localizations {
      route
      locale
    }
    category
  }
}
    `;

export function usePageRoutesQuery(options: Omit<Urql.UseQueryArgs<PageRoutesQueryVariables>, 'query'>) {
  return Urql.useQuery<PageRoutesQuery, PageRoutesQueryVariables>({ query: PageRoutesDocument, ...options });
};
export const PlaceDocument = gql`
    query Place($where: PlaceWhereUniqueInput!, $locale: Locale!, $transformation: AssetTransformationInput) {
  place(where: $where, locales: [$locale, en]) {
    ...BasePlace
    image {
      ...BaseAssetWithoutUrl
      url(transformation: $transformation)
    }
  }
}
    ${BasePlaceFragmentDoc}
${BaseAssetWithoutUrlFragmentDoc}`;

export function usePlaceQuery(options: Omit<Urql.UseQueryArgs<PlaceQueryVariables>, 'query'>) {
  return Urql.useQuery<PlaceQuery, PlaceQueryVariables>({ query: PlaceDocument, ...options });
};
export const PlacesDocument = gql`
    query Places($where: PlaceWhereInput, $locale: Locale!, $transformation: AssetTransformationInput) {
  places(where: $where, locales: [$locale, en]) {
    ...BasePlace
    image {
      ...BaseAssetWithoutUrl
      url(transformation: $transformation)
    }
  }
}
    ${BasePlaceFragmentDoc}
${BaseAssetWithoutUrlFragmentDoc}`;

export function usePlacesQuery(options: Omit<Urql.UseQueryArgs<PlacesQueryVariables>, 'query'>) {
  return Urql.useQuery<PlacesQuery, PlacesQueryVariables>({ query: PlacesDocument, ...options });
};
export const SectionDocument = gql`
    query Section($where: SectionWhereUniqueInput!, $locale: Locale!) {
  section(where: $where, locales: [$locale, en]) {
    ...BaseSection
  }
}
    ${BaseSectionFragmentDoc}`;

export function useSectionQuery(options: Omit<Urql.UseQueryArgs<SectionQueryVariables>, 'query'>) {
  return Urql.useQuery<SectionQuery, SectionQueryVariables>({ query: SectionDocument, ...options });
};
export const StoriesDocument = gql`
    query Stories($where: StoryWhereInput!, $locales: [Locale!]!, $order: StoryOrderByInput, $first: Int, $skip: Int) {
  stories(
    where: $where
    locales: $locales
    orderBy: $order
    first: $first
    skip: $skip
  ) {
    ...BaseStory
  }
}
    ${BaseStoryFragmentDoc}`;

export function useStoriesQuery(options: Omit<Urql.UseQueryArgs<StoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<StoriesQuery, StoriesQueryVariables>({ query: StoriesDocument, ...options });
};